import faker from 'faker';
import React from 'react';
import { isMap, sum } from 'lodash';
// material
import { experimentalStyled as styled } from '@material-ui/core/styles';
import {
  Box,
  Grid,
  Card,
  Table,
  Divider,
  TableRow,
  Container,
  TableBody,
  TableHead,
  TableCell,
  Typography,
  TableContainer,
  Stack,
  Button,
  IconButton,
  TextField,
  LinearProgress,
  linearProgressClasses,
  OutlinedInput,
  InputAdornment,
  CircularProgress,
  FormControl,
  Tabs,
  Tab,
  Autocomplete,
  Checkbox,
  Tooltip,
  Avatar,
  Collapse,
  Dialog,
  DialogContent,
  Alert,
  DialogActions,
  Paper,
  TablePagination
} from '@material-ui/core';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react'
// routes
import { PATH_DASHBOARD } from 'src/routes/paths.js';
import { useNavigate, useParams } from 'react-router'
import { Add, AddCircle, AddCircleOutline, AddIcCallOutlined, ArrowBackIos, ArrowForwardIos, CheckBox, Delete, Done, Edit, Info, KeyboardArrowDown, KeyboardArrowUp, KeyboardBackspaceOutlined, Logout, RemoveCircleOutline, Search } from '@material-ui/icons';
import { Link as RouterLink, useLocation, } from 'react-router-dom'
// utils
import { fCurrency, fUSPrice } from 'src/utils/formatNumber.js';
// Backup before Install Labor request-service classification:
// import { getRecipeCostLaborRowComputed, getLaborTimelogCost, getJobCostTimelogLineCost, isRecipeCostInstallLaborTimelog, resolveInstallLaborServiceUnitCost, resolveInstallLaborServiceLineCost, resolveJobCostServiceLineTotal, getLabourCostServiceCatalogRate, shouldShowServiceOnJobCostOtherTab } from 'src/utils/laborTimelogCalc';
import { getRecipeCostLaborRowComputed, getLaborTimelogCost, getJobCostTimelogLineCost, isRecipeCostInstallLaborTimelog, isJobCostInstallLaborPayout, isJobCostInstallLaborTimelog, resolveInstallLaborServiceUnitCost, resolveInstallLaborServiceLineCost, resolveJobCostServiceLineTotal, getLabourCostServiceCatalogRate, shouldShowServiceOnJobCostOtherTab, includeJobCostServiceRowActual, getJobCostServiceActualCost, resolveEffectiveProductionLabor } from 'src/utils/laborTimelogCalc';
import { getJobCostMaterialCost } from 'src/utils/jobCostMaterialCalc';
import trash2Outline from '@iconify/icons-eva/trash-2-outline';
import searchFill from '@iconify/icons-eva/search-fill';
import fileTextFill from '@iconify/icons-eva/file-text-fill';

// components
import Page from 'src/components/Page.js';
import * as Yup from 'yup';
import Label from 'src/components/Label.js';
import Scrollbar from 'src/components/Scrollbar.js';
import HeaderBreadcrumbs from 'src/components/HeaderBreadcrumbs.js';
import InvoiceToolbar from 'src/components/_dashboard/e-commerce/invoice/InvoiceToolbar.js';
import JobCostToolbar from './JobCostToolbar';
import JobCostCartToolbar from './JobCostCartToolbar';
import ConfirmationPopup from 'src/components/confirmationPopup';
import Icon from '@iconify/react';
import { LoadingButton } from '@material-ui/lab';
import { Form, FormikProvider, useFormik } from 'formik';
import axios from 'axios';
import { COMPANY_NAME, currentFacilityId, REST_API_END_POINT, UNITS } from 'src/constants/Defaultvalues';
import { useSnackbar } from 'notistack';
import Modal from 'src/components/_dashboard/blog/ProjectModel';
import { useTheme } from '@material-ui/core/styles';
import LoadingScreen from 'src/components/LoadingScreen';
import { parse } from 'date-fns';
import { empty } from 'src/Helpers/Common';
import CompareJobCost from './CompareJobCost';
import QbLogo from 'src/assets/quickbookLogo-removebg-preview.png'
import RequestTabUpdates from 'src/components/_dashboard/user/account/RequestTabUpdates'
import JobCostChartSignwise from 'src/components/charts/JobCostChartSignwise';
import CompareJobCostChartMain from './CompareJobCostChartMain';
import JobCostMemberClockInTimer from 'src/components/_dashboard/general-app/JobCostMemberClockInTimer';
import JobCostLogsListing from 'src/components/_dashboard/general-app/JobCostLogsListing';
import JobCostMaterialsTab from 'src/components/_dashboard/general-app/JobCostMaterialsTab';
import JobCostEquipmentsTab from 'src/components/_dashboard/general-app/JobCostEquipmentsTab';
import JobCostOtherTab from 'src/components/_dashboard/general-app/JobCostOtherTab';
import JobCostCalculator from 'src/pages/dashboard/JobCost';
import TMSummary from './tm-tabs/TMSummary';



// ----------------------------------------------------------------------

const INVOICE = {
  id: faker.datatype.uuid(),
  taxes: 5,
  discount: 10,
  status: 'paid',
  invoiceFrom: {
    name: faker.name.findName(),
    address: 'DieSachbearbeiter Choriner Straße 49 10435 Berlin',
    company: faker.company.companyName(),
    email: faker.internet.email(),
    phone: faker.phone.phoneNumberFormat()
  },
  invoiceTo: {
    name: faker.name.findName(),
    address: 'Keas 69 Str. 15234, Chalandri Athens, Greece',
    company: faker.company.companyName(),
    email: faker.internet.email(),
    phone: faker.phone.phoneNumberFormat()
  },
  items: [...Array(1)].map(() => ({
    id: faker.datatype.uuid(),
    title: faker.lorem.sentence(),
    description: faker.lorem.lines(),
    qty: faker.datatype.number({ min: 1, max: 5 }),
    price: faker.datatype.number({ min: 4, max: 99, precision: 0.01 })
  }))
};

// Aligns with JobCostMemberClockInTimer: regular + OT at 1.5× for cost/bill amounts
const getRecipeCostLaborBreakdownText = (regularHours, otHours, rate) => {
  const reg = Number(regularHours) || 0;
  const ot = Number(otHours) || 0;
  const r = Number(rate) || 0;
  const regularAmount = reg * r;
  const otAmount = ot * r * 1.5;
  const total = regularAmount + otAmount;
  return `Regular: ${reg.toFixed(2)} x $${r.toFixed(2)} = $${regularAmount.toFixed(2)} | OT: ${ot.toFixed(2)} x $${r.toFixed(2)} x 1.5 = $${otAmount.toFixed(2)} | Total: $${total.toFixed(2)}`;
};

const RowResultStyle = styled(TableRow)(({ theme }) => ({
  '& td': {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1)
  }
}));

const SearchStyle = styled(OutlinedInput)(({ theme }) => ({
  width: '100%',
  transition: theme.transitions.create(['box-shadow', 'width'], {
    easing: theme.transitions.easing.easeInOut,
    duration: theme.transitions.duration.shorter
  }),
  '&.Mui-focused': { width: 320, boxShadow: theme.customShadows.z8 },
  '& fieldset': {
    borderWidth: `1px !important`,
    borderColor: `${theme.palette.grey[500_32]} !important`
  }
}));

const CardMediaStyle = styled('div')(({ theme }) => ({
  display: 'flex',
  position: 'relative',
  justifyContent: 'center',
  cursor: 'pointer',
  paddingTop: 'calc(100% * 9 / 16)',
  '&:before': {
    top: 0,
    zIndex: 9,
    content: "''",
    width: '100%',
    height: '100%',
    position: 'absolute',

    WebkitBackdropFilter: 'blur(3px)',
    borderTopLeftRadius: theme.shape.borderRadiusMd,
    borderTopRightRadius: theme.shape.borderRadiusMd,

  },
}))

const CoverImgStyle = styled('img')({
  top: 0,
  zIndex: 8,
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  position: 'absolute',

})

const TabBadge = styled('span')(({ theme, active, color }) => ({
  marginLeft: theme.spacing(1),
  padding: '2px 8px',
  borderRadius: 0.8 * 8,
  fontSize: '0.75rem',
  fontWeight: 800,
  backgroundColor: active ? theme.palette[color].main : theme.palette.action.hover,
  color: active ? theme.palette[color].contrastText : theme.palette.text.secondary,
  transition: 'all 0.3s ease'
}));

const SummaryCard = styled(Card)(({ theme }) => ({
  padding: theme.spacing(2.5, 2),
  textAlign: 'center',
  minWidth: 130,
  borderRadius: theme.shape.borderRadius * 2,
  boxShadow: 'none',
  border: `1px solid ${theme.palette.divider}`,
  background: theme.palette.background.paper,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  cursor: 'pointer',
  position: 'relative',
  overflow: 'hidden',
  transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
  '& *': {
    transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
  },
  '&:hover': {
    transform: 'translateY(-6px)',
    // boxShadow: `0 12px 24px -10px ${theme.palette.primary.main}4d`,
    borderColor: theme.palette.primary.light,
  }
}));

const ActionButton = styled(Button)(({ theme }) => ({
  padding: theme.spacing(1, 3),
  borderRadius: theme.shape.borderRadius,
  boxShadow: 'none',
  fontWeight: 700,
  transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
  '&:hover': {
    boxShadow: `0 8px 16px 0 ${theme.palette.primary.main}33`,
    transform: 'scale(1.02)'
  }
}));

const toSafeNumber = (value) => {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : 0;
};

const roundToTwo = (value) => Math.round((toSafeNumber(value) + Number.EPSILON) * 100) / 100;

// const calculateMargin = (total_bill, total_cost) => {
//   const safeTotalBill = toSafeNumber(total_bill);
//   const safeTotalCost = toSafeNumber(total_cost);
//
//   if (safeTotalBill === 0) {
//     if (safeTotalCost > 0) return -100;
//     return 0;
//   }
//
//   return roundToTwo(((safeTotalBill - safeTotalCost) / safeTotalCost) * 100);
// };


const calculateMargin = (total_bill, total_cost) => {
  return toSafeNumber(total_bill) - toSafeNumber(total_cost);
};

const getOtherEntriesTotals = (entries = []) => {
  const list = Array.isArray(entries) ? entries : [];
  return list.reduce(
    (acc, entry) => {
      const quantity = Number(entry?.quantity ?? 0);
      const unitCost = Number(entry?.unit_cost ?? 0);
      const unitBill = Number(entry?.unit_bill ?? 0);
      const totalCostFromRow = Number(entry?.total_cost);
      const totalBillFromRow = Number(entry?.total_bill);
      const billable = entry?.billable === 1 || entry?.billable === '1' || entry?.billable === true;

      const rowCost = Number.isFinite(totalCostFromRow) ? totalCostFromRow : (Number.isFinite(quantity) ? quantity : 0) * (Number.isFinite(unitCost) ? unitCost : 0);
      const rawBill = Number.isFinite(totalBillFromRow) ? totalBillFromRow : (Number.isFinite(quantity) ? quantity : 0) * (Number.isFinite(unitBill) ? unitBill : 0);
      const rowBill = billable ? rawBill : 0;

      acc.cost += rowCost;
      acc.bill += rowBill;
      return acc;
    },
    { cost: 0, bill: 0 }
  );
};

/** Include job-cost service rows in totals when DB has qty/cost even if taken is 0 */
const includeRecipeCostServiceRow = (service) => {
  if (!service) return false;
  if (service.taken === 1 || service.taken === '1') return true;
  if (parseFloat(service.jobcost_quantity || 0) > 0) return true;
  if (parseFloat(service.jobcost_total_cost || service.total_cost || 0) > 0) return true;
  if (parseFloat(service.qty || 0) > 0) return true;
  if (parseFloat(service.total_bill || 0) > 0) return true;
  if (parseFloat(service.jobcost_total_bill || 0) > 0) return true;
  return false;
};

const includeRecipeCostMaterialRow = (material) => {
  if (!material) return false;
  if (material.taken === 1 || material.taken === '1') return true;
  if (parseFloat(material.jobcost_quantity || 0) > 0) return true;
  if (parseFloat(material.jobcost_total || 0) > 0) return true;
  if (parseFloat(material.quantity || 0) > 0) return true;
  if (parseFloat(material.total_bill || 0) > 0) return true;
  if (parseFloat(material.jobcost_total_bill || 0) > 0) return true;
  return false;
};

// ----------------------------------------------------------------------

export default function JobCost({recipeCostId,recipeCostCurrentTab,handleBackToAlljobs,handleClickOpenJobCost,setRecipeCostCurrentTab,popupOn,onDataChange,requestId}) {
  const theme = useTheme();
  const { enqueueSnackbar } = useSnackbar();
  const user = JSON.parse(window.localStorage.getItem('user'))
  const subTotal = sum(INVOICE.items.map((item) => item.price * item.qty));
  const total = subTotal - INVOICE.discount + INVOICE.taxes;
  const location = useLocation();
  const navigate = useNavigate();
  
  const locationCurrentTab = location?.state?.currentTab || null; 
  const isEstimateJob = location?.state?.estimateJob || null; 
  const currentTab = popupOn?recipeCostCurrentTab:locationCurrentTab;
  const [projectDetails, setProjectDetails] = useState(null);
  const params = localStorage.getItem("params")
  const req_id = params || requestId
  const [stockConfirmationOpen, setStockConfirmationOpen] = useState(false);
  const [isHover, setIsHover] = useState(false)
  const [hoveredCard, setHoveredCard] = useState(null);
  const [productList, setProductList] = useState([]);
  const [initialMaterials, setInitialMaterials] = useState([]);
  const [materialList, setMaterialList] = useState([]);
  const [selectedProjects, setSelectedProjects] = useState([]);
  const [filterName, setFilterName] = useState('');
  const [openDeletePop, setOpenDeletePop] = useState(false)
  const [deleteId, setDeleteId] = useState()
  const [renderCards, setRenderCards] = useState(false)
  const [materialsPreview, setMaterialsPreview] = useState(false)
  const [loading, setLoading] = useState(false)
  const [selectedMaterial, setSelectedMaterial] = useState()
  const [manualTotalPayOut, setManualTotalPayOut] = useState(0)
  const [hourlyTotalPayOut, setHourlyTotalPayOut] = useState(0)
  const [excessHourlyPayoutAmount, setExcessHourlyPayoutAmount] = useState(0)
  const [excessManualPayoutAmount, setExcessManualPayoutAmount] = useState(0)
  const [allPayouts, setAllPayouts] = useState([])
  const [manuallyAddedPayouts, setManuallyAddedPayouts] = useState([])
  const [materialPayOut, setMaterialPayOut] = useState(0)
  const [materialPayOutBill, setMaterialPayOutBill] = useState(0)
  const [jobCost, setJobCost] = useState(0)
  const [staffTimelogs, setStaffTimelogs] = useState([])
  const [recipe, setRecipe] = useState([])
  const [isRecipe, setIsRecipe] = useState(false)
  const [ingredient, setIngredient] = useState(false)
  const [services, setAllServices] = useState([])
  const [stockProducts, setStockProducts] = useState([])
  const [confirmationPopup, setConfirmationPopup] = useState({ open: false, message: '', handleClick: () => {}, handleClose: () => {} });
  const [updatingTmDraft, setUpdatingTmDraft] = useState(false);
  const [openTmDraftConfirm, setOpenTmDraftConfirm] = useState(false);

  const handleOpenTmDraftConfirm = () => {
    setOpenTmDraftConfirm(true);
  };

  const handleToggleTmDraft = async () => {
    const requestIdResolved = projectData?.request_id || requestId || req_id;
    if (!requestIdResolved || updatingTmDraft) return;
    try {
      setUpdatingTmDraft(true);
      const nextDraft = Number(projectData?.tm_review_draft || 0) === 1 ? 0 : 1;
      const res = await axios.post(`${REST_API_END_POINT}project/update-tm-review-draft-status`, {
        requestId: requestIdResolved,
        isDraft: nextDraft,
        userId: user?.user_id
      });
      if (res?.data?.status === 1) {
        setProjectData((prev) => ({ ...prev, tm_review_draft: nextDraft }));
        enqueueSnackbar(nextDraft === 1 ? 'Moved to Draft' : 'Released from Draft', { variant: 'success' });
        if (onDataChange) onDataChange();
      } else {
        enqueueSnackbar(res?.data?.message || 'Failed to update draft status', { variant: 'error' });
      }
    } catch (error) {
      enqueueSnackbar('Failed to update draft status', { variant: 'error' });
    } finally {
      setUpdatingTmDraft(false);
      setOpenTmDraftConfirm(false);
    }
  };
  const [editServiceConfirmation, setEditServiceConfirmation] = useState({ open: false, serviceIndex: null, isProductionLabor: false })
  const [excludeManualFromProductionLabor, setExcludeManualFromProductionLabor] = useState(false)
  const [selectedProducts, setSelectedProducts] = useState(false)
  console.log('stockProducts', stockProducts)
  const [additionalMaterials,setAdditionalMaterials] = useState([])
  console.log('additionalMaterialssssssss',additionalMaterials)
  const [allServicesTemp, setAllServicesTemp] = useState([])
  const [additionalServices, setAdditionalServices] = useState([])
  const [projectData, setProjectData] = useState([])
  // Backup before T&M material markup fix: const isTM = projectData?.project_category === 12;
  const isTM = Number(projectData?.project_category) === 12 || projectData?.job_category_name === 'Time & Material';
  console.log('projectData**********',projectData);
  const [isMirrored, setIsMirrored] = useState(false)
  const [targetFacilityId, setTargetFacilityId] = useState(null)
  
  const [category, setCategory] = useState([{
    "id": length + 1,
    "name": "Product Formula",
    "added_by": 1,
    "status": 1,
    "timestamp": 1711096046,
    "c_id": 1,
    "authorized_by": "Rakesh Skyniche"
  }]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [color, setColor] = useState('#308fe8')
  const [errorFieldId, setErrorFieldId] = useState([]);
  const [jobCostPreview, setJobCostPreview] = useState(false)
  const [servicesPreview, setServicesPreview] = useState(false)
  const [jobCostCalculatorModal, setJobCostCalculatorModal] = useState(false)
  const [availableServices, setAvailableServices] = useState([])
  const [serviceExpectedHours, setServiceExpectedHours] = useState({})
  const [serviceSearchTerm, setServiceSearchTerm] = useState('')
    const tableContainerRef = useRef(null);
    const [openLabourIdx, setOpenLabourIdx] = useState(null);
  const [isHidden, setIsHidden] = useState(true);
  const [updates, setUpdates] = useState([]);
  const [rowEdit, setRowEdit] = useState({ section: null, index: null });
  const [logs, setLogs] = useState([]);
  const [tabSummaryStats, setTabSummaryStats] = useState({
    Labor: { cost: 0, laborCost: 0, billable: 0, marginPercent: 0 },
    Materials: { cost: 0, billable: 0, marginPercent: 0 },
    Equipment: { cost: 0, billable: 0, marginPercent: 0 },
    Other: { cost: 0, billable: 0, marginPercent: 0 }
  });
  const [hasMaterialsSummaryReported, setHasMaterialsSummaryReported] = useState(false);
  const [staffTimelogsGet, setStaffTimelogsGet] = useState([]);
  console.log('staffTimelogsGet-------------', staffTimelogsGet)
  const [totalManualHours, setTotalManualHours] = useState(0);
  console.log('totalManualHours', totalManualHours)
  const [projectMembers, setProjectMembers] = useState([]);
  const [projectTasks, setProjectTasks] = useState([]);
  const [otherEntries, setOtherEntries] = useState([]);
  const otherTotals = useMemo(() => getOtherEntriesTotals(otherEntries), [otherEntries]);
  
  // Pagination state variables for services modal
  const [servicesPage, setServicesPage] = useState(0);
  const [servicesRowsPerPage, setServicesRowsPerPage] = useState(10);
  const [servicesTotalCount, setServicesTotalCount] = useState(0);
  const [laborSectionTab, setLaborSectionTab] = useState('Labor');
  const [laborRowsCount, setLaborRowsCount] = useState({ total: 0, serviceCount: 0, laborCount: 0 });
  const [otherRowsCount, setOtherRowsCount] = useState(0);
  const [recalculateTrigger, setRecalculateTrigger] = useState(0);
  const [internalNote, setInternalNote] = useState('');
  const [customerInvoiceNote, setCustomerInvoiceNote] = useState('');
  const [notesHydrated, setNotesHydrated] = useState(false);
  const [notesTouched, setNotesTouched] = useState(false);
  const [isGeneratingSummaryNote, setIsGeneratingSummaryNote] = useState(false);
  const logo = 'https://www.shutterstock.com/image-photo/checklist-clipboard-task-documentation-management-260nw-2270860299.jpg'

  useEffect(() => {
    const validTabs = ['Labor', 'Materials', 'Equipment', 'Other', 'Summary'];
    if (currentTab && validTabs.includes(currentTab)) {
      setLaborSectionTab(currentTab);
      // Consume the tab from state so it doesn't persist on refresh
      if (!popupOn && location?.state?.currentTab) {
        const newState = { ...location.state };
        delete newState.currentTab;
        navigate(location.pathname, { 
          replace: true, 
          state: newState
        });
      }

      // Consume the tab from parent state/localStorage if in popup mode
      if (popupOn && recipeCostCurrentTab && typeof setRecipeCostCurrentTab === 'function') {
        setRecipeCostCurrentTab("");
        localStorage.removeItem("recipeCostCurrentTab");
      }
    }
  }, [currentTab, location, navigate, popupOn, recipeCostCurrentTab, setRecipeCostCurrentTab]);

  const calculateSummaryMarginPercent = (billable, cost) => {
    const safeBillable = Number.isFinite(Number(billable)) ? Number(billable) : 0;
    const safeCost = Number.isFinite(Number(cost)) ? Number(cost) : 0;
    if (!safeBillable) return safeCost > 0 ? -100 : 0;
    return Math.round((((safeBillable - safeCost) / safeBillable) * 100 + Number.EPSILON) * 100) / 100;
  };

  const summaryTabData = useMemo(() => {
    const toSummaryStat = (entry) => ({
      cost: Number(entry?.cost || 0),
      billable: Number(entry?.billable || 0),
      margin: `${Number(entry?.marginPercent || 0).toFixed(2)}%`
    });

    const labor = toSummaryStat(tabSummaryStats?.Labor);
    const materialsFallbackCost =
      (selectedProjects || []).reduce((sum, item) => {
        // Backup before T&M material markup:
        // const directTotal = item?.jobcost_total;
        // if (directTotal != null && directTotal !== '') return sum + Number(directTotal);
        // const qty = Number(item?.jobcost_quantity ?? item?.quantity ?? 0);
        // const unitCost = Number(item?.jobcost_unit_cost ?? item?.unit_cost ?? item?.price ?? 0);
        // return sum + (Number.isFinite(qty) ? qty : 0) * (Number.isFinite(unitCost) ? unitCost : 0);
        return sum + getJobCostMaterialCost(item, isTM);
      }, 0) +
      (additionalMaterials || []).reduce((sum, item) => {
        // Backup before T&M material markup:
        // const directTotal = item?.total;
        // if (directTotal != null && directTotal !== '') return sum + Number(directTotal);
        // const qty = Number(item?.quantity ?? 0);
        // const unitCost = Number(item?.unit_cost ?? item?.price ?? 0);
        // return sum + (Number.isFinite(qty) ? qty : 0) * (Number.isFinite(unitCost) ? unitCost : 0);
        return sum + getJobCostMaterialCost(item, isTM);
      }, 0);
    const materialsFallbackBillable =
      (selectedProjects || []).reduce((sum, item) => {
        const isBillable = item?.billable === 1 || item?.billable === '1' || item?.billable === true || item?.is_billable === 1 || item?.is_billable === '1' || item?.is_billable === true;
        if (!isBillable) return sum;

        const directTotal = item?.jobcost_total_bill ?? item?.total_bill;
        if (directTotal != null && directTotal !== '') return sum + Number(directTotal);
        const qty = Number(item?.jobcost_quantity ?? item?.quantity ?? 0);
        const billRate = Number(item?.jobcost_bill_rate ?? item?.bill_rate ?? item?.unit_bill ?? 0);
        const effectiveBillRate = billRate;
        return sum + (Number.isFinite(qty) ? qty : 0) * (Number.isFinite(effectiveBillRate) ? effectiveBillRate : 0);
      }, 0) +
      (additionalMaterials || []).reduce((sum, item) => {
        const isBillable = item?.billable === 1 || item?.billable === '1' || item?.billable === true || item?.is_billable === 1 || item?.is_billable === '1' || item?.is_billable === true;
        if (!isBillable) return sum;

        const directTotal = item?.total_bill ?? item?.jobcost_total_bill;
        if (directTotal != null && directTotal !== '') return sum + Number(directTotal);
        const qty = Number(item?.quantity ?? 0);
        const billRate = Number(item?.bill_unit_price ?? item?.unit_bill ?? 0);
        const effectiveBillRate = billRate;
        return sum + (Number.isFinite(qty) ? qty : 0) * (Number.isFinite(effectiveBillRate) ? effectiveBillRate : 0);
      }, 0);

    const materialFromChild = toSummaryStat(tabSummaryStats?.Materials);
    const materials = hasMaterialsSummaryReported
      ? materialFromChild
      : {
        cost: Math.round((materialsFallbackCost + Number.EPSILON) * 100) / 100,
        billable: Math.round((materialsFallbackBillable + Number.EPSILON) * 100) / 100,
        margin: `${calculateSummaryMarginPercent(materialsFallbackBillable, materialsFallbackCost).toFixed(2)}%`
      };
    const equipment = toSummaryStat(tabSummaryStats?.Equipment);
    const other = toSummaryStat(tabSummaryStats?.Other);
    const totalCost = labor.cost + materials.cost + equipment.cost + other.cost;
    const totalBillable = labor.billable + materials.billable + equipment.billable + other.billable;

    return {
      stats: {
        Labor: labor,
        Materials: materials,
        Equipment: equipment,
        Other: other
      },
      cost: totalCost,
      billable: projectData?.sales_order_total || totalBillable,
      margin: `${calculateSummaryMarginPercent(totalBillable, totalCost).toFixed(2)}%`
    };
  // Backup before T&M material markup: }, [tabSummaryStats, selectedProjects, additionalMaterials, hasMaterialsSummaryReported]);
  }, [tabSummaryStats, selectedProjects, additionalMaterials, hasMaterialsSummaryReported, isTM]);

  const normalizeSummaryStats = useCallback((stats) => ({
    cost: Math.round((Number(stats?.cost || 0) + Number.EPSILON) * 100) / 100,
    billable: Math.round((Number(stats?.billable || 0) + Number.EPSILON) * 100) / 100,
    marginPercent: Math.round((Number(stats?.marginPercent || 0) + Number.EPSILON) * 100) / 100
  }), []);

  const handleLaborSummaryChange = useCallback((stats) => {
    const nextStats = {
      ...normalizeSummaryStats(stats),
      laborCost: Math.round((Number(stats?.laborCost ?? stats?.cost ?? 0) + Number.EPSILON) * 100) / 100
    };
    setTabSummaryStats((prev) => {
      const prevStats = normalizeSummaryStats(prev?.Labor || {});
      const prevLaborCost = Number(prev?.Labor?.laborCost ?? 0);
      if (
        prevStats.cost === nextStats.cost &&
        prevLaborCost === nextStats.laborCost &&
        prevStats.billable === nextStats.billable &&
        prevStats.marginPercent === nextStats.marginPercent
      ) {
        return prev;
      }
      return { ...prev, Labor: nextStats };
    });
  }, [normalizeSummaryStats]);

  const handleMaterialsSummaryChange = useCallback((stats) => {
    const nextStats = normalizeSummaryStats(stats);
    setHasMaterialsSummaryReported(true);
    setTabSummaryStats((prev) => {
      const prevStats = normalizeSummaryStats(prev?.Materials || {});
      if (
        prevStats.cost === nextStats.cost &&
        prevStats.billable === nextStats.billable &&
        prevStats.marginPercent === nextStats.marginPercent
      ) {
        return prev;
      }
      return { ...prev, Materials: nextStats };
    });
  }, [normalizeSummaryStats]);

  const handleEquipmentSummaryChange = useCallback((stats) => {
    const nextStats = normalizeSummaryStats(stats);
    setTabSummaryStats((prev) => {
      const prevStats = normalizeSummaryStats(prev?.Equipment || {});
      if (
        prevStats.cost === nextStats.cost &&
        prevStats.billable === nextStats.billable &&
        prevStats.marginPercent === nextStats.marginPercent
      ) {
        return prev;
      }
      return { ...prev, Equipment: nextStats };
    });
  }, [normalizeSummaryStats]);

  const handleOtherSummaryChange = useCallback((stats) => {
    const nextStats = normalizeSummaryStats(stats);
    setTabSummaryStats((prev) => {
      const prevStats = normalizeSummaryStats(prev?.Other || {});
      if (
        prevStats.cost === nextStats.cost &&
        prevStats.billable === nextStats.billable &&
        prevStats.marginPercent === nextStats.marginPercent
      ) {
        return prev;
      }
      return { ...prev, Other: nextStats };
    });
  }, [normalizeSummaryStats]);

  const { id:paramsId } = useParams();
  const  id  = popupOn ? recipeCostId: paramsId

  const fetchProjectData = async () => {
    try {
      const  res = await axios.post(`${REST_API_END_POINT}jobs/get-project-details-by-id`, { projectId: id });
     setProjectDetails(res.data.result[0])
     localStorage.setItem("params",res.data.result[0].request_id) 
    } catch (error) {
      console.log("error",error)
    }
   }

  useEffect(()=>{
    fetchProjectData()
  },[id])

  useEffect(() => {
    setNotesHydrated(false);
    setNotesTouched(false);
    setInternalNote('');
    setCustomerInvoiceNote('');
  }, [id]);

  useEffect(()=>{
    if(projectDetails){
      const isMirrored = projectDetails?.origin_facility_id != currentFacilityId && projectDetails?.project_category !== 15 && projectDetails?.is_split_order == 1 ? true : false;
      if(isMirrored){
        setIsMirrored(isMirrored)
        setTargetFacilityId(projectDetails?.origin_facility_id)
      }  
    }
  },[projectDetails])

  useEffect(() => {
    const totalHours = staffTimelogsGet
      ?.filter(log => log.is_manually_added === 1 || log.is_manually_added === "1")
      // Backup before non-T&M Install Labor production split:
      // ?.reduce((accumulator, currentValue) => {
      //   return accumulator + (parseFloat(currentValue.hours) || 0);
      // }, 0) || 0;
      ?.filter(log => !isJobCostInstallLaborTimelog(log, services))
      ?.reduce((accumulator, currentValue) => {
        return accumulator + (parseFloat(currentValue.hours) || 0);
      }, 0) || 0;
    setTotalManualHours(totalHours);
  }, [staffTimelogsGet, services]);

    const handleScrollLeft = () => {
    tableContainerRef.current.scrollTo({
      left: 0,
      behavior: 'smooth'
    });
  };
  
  const handleScrollRight = () => {
    tableContainerRef.current.scrollTo({
      left: tableContainerRef.current.scrollWidth,
      behavior: 'smooth'
    });
  };

  const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
    height: 10,
    borderRadius: 5,
    [`&.${linearProgressClasses.colorPrimary}`]: {
      backgroundColor: theme.palette.grey[theme.palette.mode === 'light' ? 200 : 800],
    },
    [`& .${linearProgressClasses.bar}`]: {
      borderRadius: 5,
      backgroundColor: `hsl(${120 - (progressValue * 1.2)}, ${60}%, 50%)`, // `hsl(${(progressValue * 1.2)}, ${60 + (progressValue * 0.4)}%, 50%)`
    },
  }));

  const fetchFinishedProductsData = async () => {
    try {
      const finishedProductsResponse = await axios.post(`${REST_API_END_POINT}project/fetch-all-job-cost-add-materials-finished-products`);
      return Array.isArray(finishedProductsResponse?.data?.results)
        ? finishedProductsResponse.data.results
        : [];
    } catch (error) {
      console.error('Error fetching finished products:', error);
      return [];
    }
  };

  const fetchData = (noReloadOnClockIn) => {
    if (noReloadOnClockIn) {
      setLoading(false);
    } else {
      setLoading(true);
    }
    try {
      // Backup (before product-formula materials fix — mapped with empty productList on first load):
      // const jobCostRequest = axios.post(`${REST_API_END_POINT}project/fetch-all-job-cost-recipe`, 
      //   { userId: user.user_id, userType: user.user_type, projectId: id, orderId: projectDetails?.request_id });
      // jobCostRequest.then((response) => {
      //   // Backup (previous): const productListData = response.data.results
      //   const productListData = Array.isArray(productList) ? productList : [];
      //   fetchFinishedProductsData()
      //     .then((freshProductListData) => {
      //       if (Array.isArray(freshProductListData) && freshProductListData.length > 0) {
      //         setProductList(freshProductListData);
      //       }
      //     })
      //     .catch((error) => console.error('Error refreshing finished products:', error));
      Promise.all([
        axios.post(`${REST_API_END_POINT}project/fetch-all-job-cost-recipe`, 
          { userId: user.user_id, userType: user.user_type, projectId: id, orderId: projectData?.request_id || projectDetails?.request_id || (Number(req_id) > 0 ? req_id : undefined) }),
        fetchFinishedProductsData()
      ]).then(([response, freshProductListData]) => {
        const productListData = Array.isArray(freshProductListData) && freshProductListData.length > 0
          ? freshProductListData
          : (Array.isArray(productList) ? productList : []);
        if (productListData.length > 0) {
          setProductList(productListData);
        }
        const stafftimelogs = response.data.stafftimelogs
        let selectedProducts = Array.isArray(response.data.selectedMaterials)
          ? response.data.selectedMaterials
          : [];
        const receivedRfpProducts = selectedProducts.filter((row) => row.rfp === 1);
        const rfpProducts = receivedRfpProducts.map((product) => ({
            ...product,
            jobcost_unit_cost: product.unit_cost,
            jobcost_quantity: product.quantity,
            jobcost_actual_quantity: product.actual_quantity,
            jobcost_total: product.total,
            jobcost_total_bill: product.total_bill ?? 0,
            billable: product.billable ?? 1,
            available_stock:product.available_stock
        }));
        console.log('rfpProducts:', rfpProducts);

        selectedProducts = selectedProducts.filter((row) => row.rfp === 0);
        let initialData = Array.isArray(response.data.selectedMaterials)
          ? response.data.selectedMaterials
          : [];
        const allPayouts = response.data.allPayOut
        const project = response.data.projects
        const allMaterials = response.data.allMaterials
        const allRecipes = response.data.allRecipies
        const material = response.data.materials
        const requestServiceLines = response.data.services ?? response.data.allServices ?? []
        let stockProducts = response?.data?.stockProducts
        let jobcostLog = response?.data?.jobcostUpdates
        console.log('requestServiceLines===', requestServiceLines);
        let additionalServices = response.data.additionalServices
        if (additionalServices) {
          setAdditionalServices(additionalServices.reduce((accumulator, currentValue) => {
            return accumulator + parseFloat(currentValue?.jobcost_total_cost || 0);
            // return accumulator + (currentValue?.originalCost * currentValue?.qty);
          }, 0))
        }
          if (material && material.length > 0) {
            // setAdditionalMaterials(material)
            console.log('response?.data?.materials')

            const list = Array.isArray(productListData) ? productListData : [];
            // Backup (before additional-material scan-delete fix): used material.find() — first duplicate row only;
            // product_id was overwritten with job_cost id so delete could target the wrong placeholder row.
            // const fromProductList = list
            //   .filter((item1) => material?.some((item2) => item1.id === item2.product_id))
            //   .map((item1) => {
            //     const match = material?.find((item2) => item1.id === item2.product_id);
            //     return {
            //       ...item1,
            //       ...(match ? { product_id: match.id, job_cost_id: match.id, quantity: match.quantity ?? 0, ... } : {})
            //     };
            //   });
            const fromProductList = list
              .filter((item1) => material?.some((item2) => item1.id === item2.product_id))
              .map((item1) => {
                const matchesForInventory = (material || []).filter(
                  (item2) => item1.id === item2.product_id
                );
                const primaryMatch = matchesForInventory.reduce((best, row) => {
                  if (!best) return row;
                  return Number(row?.quantity || 0) > Number(best?.quantity || 0) ? row : best;
                }, null);
                const match = primaryMatch || matchesForInventory[0];
                const totalQuantity = matchesForInventory.reduce(
                  (sum, row) => sum + Number(row?.quantity || 0),
                  0
                );
                console.log('item1========', item1);
                console.log('match========', match);
                return {
                  ...item1,
                  ...(match
                    ? {
                        product_id: item1.id,
                        job_cost_id: match.id,
                        unit: match?.partial_unit ? match?.partial_unit : item1?.unit,
                        unit_cost:
                          item1?.inhouse == 0 ? 0 : match?.unit_cost ?? match?.material_unit_cost ?? 0,
                        total: match.total ?? 0,
                        quantity: totalQuantity,
                        price: match.price ?? 0,
                        match_actual_quantity: match.actual_quantity ?? 0,
                        match_actual_total: match.actual_total ?? 0,
                        match_actual_unit_price: match.actual_unit_price ?? 0,
                        taken: match?.taken ?? 0,
                        total_bill: match?.total_bill ?? 0,
                        billable: match?.billable ?? 1,
                        productNotes:
                          match?.material_label != null && String(match.material_label).trim() !== ''
                            ? String(match.material_label).trim()
                            : match?.productNotes || '',
                        markup_percent: match?.markup_percent,
                        bill_unit_price: match?.bill_unit_price,
                        isMaterial: item1?.isMaterial || 0,
                        jobcost_timestamp: match?.jobcost_timestamp ?? null
                      }
                    : {})
                };
              });

            // Job-cost rows with recipe=0 often use product_id as inventory / non-order-product id
            // (backend sets notFromRecipe). They never match finished products, so merge them here
            // so JobCostMaterialsTab can render the same rows returned in response.data.materials.
            const orphanJobCostMaterials = (material || [])
              .filter((m) => !list.some((p) => p.id === m.product_id))
              .map((match) => ({
                id: match.product_id,
                name: match.productName || match.rfpProductName || 'Material',
                productNotes:
                  match?.material_label != null && String(match.material_label).trim() !== ''
                    ? String(match.material_label).trim()
                    : match.productName || match.rfpProductName || 'Material',
                job_cost_id: match.id,
                // Backup (before additional-material scan-delete fix): product_id: match.id,
                product_id: match.product_id,
                unit: match?.partial_unit || '',
                unit_cost:
                  match?.inhouse == 0
                    ? 0
                    : Number(
                        match?.unit_cost ??
                          match?.actual_unit_price ??
                          match?.material_unit_cost ??
                          0
                      ) || 0,
                total: match.total ?? 0,
                quantity: match.quantity ?? 0,
                price: match.unit_price ?? match.material_unit_cost ?? 0,
                match_actual_quantity: match.actual_quantity ?? 0,
                match_actual_total: match.actual_total ?? 0,
                match_actual_unit_price: match.actual_unit_price ?? 0,
                taken: match?.taken ?? 0,
                total_bill: match?.total_bill ?? 0,
                billable: match?.billable ?? 1,
                markup_percent: match?.markup_percent,
                bill_unit_price: match?.bill_unit_price,
                isMaterial: match?.isMaterial ?? 1,
                jobcost_timestamp: match?.jobcost_timestamp ?? null,
                barcode: match?.barcode || '',
                inhouse: match?.inhouse ?? 1,
                notFromRecipe: match?.notFromRecipe
              }));

            setAdditionalMaterials([...fromProductList, ...orphanJobCostMaterials]);
          } else {
            setAdditionalMaterials([]);
          }

          if (response.data.newstafftimelogs) {
            setStaffTimelogsGet(response.data.newstafftimelogs);
          }

          if (response.data.projectMembers) {
            setProjectMembers(response.data.projectMembers);
          }

          if (response.data.projectTask) {
            setProjectTasks(response.data.projectTask);
          }

        if (project) {
          setProjectData(project)
          if (!notesHydrated) {
            setInternalNote(project?.internal_note || '');
            setCustomerInvoiceNote(project?.customer_invoice_note || '');
            setNotesTouched(false);
            setNotesHydrated(true);
          }
          let recipe = [{
            "id": 1,
            // "name": project?.job_category_name === 'Time & Material' ? 'Staff Clock-In Time Details' : "Product Formula",
            "name": "Product Formula",
            "added_by": 1,
            "status": 1,
            "timestamp": 1711096046,
            "c_id": 1,
            "authorized_by": "Rakesh Skyniche"
          },
        ]
        // if( project?.job_category_name !== 'Time & Material'){
          let  custom ={
            "id": 2,
            "name": 'Staff Clock-In Time Details' ,
            "added_by": 1,
            "status": 1,
            "timestamp": 1711096046,
            "c_id": 1,
            "authorized_by": "Rakesh Skyniche"
          }
          recipe.push(custom)
        // }
          setCategory([...recipe]);
          setSelectedCategory(1)
        }
        if (allRecipes) {
          setRecipe(allRecipes)
        }
        if (stafftimelogs) {
          setStaffTimelogs(stafftimelogs)
        }
        if (material && material.length > 0) {
          const fetchedIsTM = Number(project?.project_category) === 12;
          // Backup before T&M material markup: setMaterialPayOut(material?.reduce((acc, curr) => acc + (parseFloat(curr.total) || 0), 0))
          setMaterialPayOut(material?.reduce((acc, curr) => acc + getJobCostMaterialCost(curr, fetchedIsTM), 0))
          setMaterialPayOutBill(material?.reduce((acc, curr) => acc + (parseFloat(curr.total_bill) || 0), 0))
        } else {
          setMaterialPayOut(0);
          setMaterialPayOutBill(0);
        }
        setAllServices(Array.isArray(requestServiceLines) ? requestServiceLines : [])
        setAllServicesTemp(Array.isArray(requestServiceLines) ? requestServiceLines : [])
        setOtherEntries(response?.data?.otherEntries || []);
        if (stockProducts) {
          setStockProducts(stockProducts)
        }
        if (jobcostLog){
          setUpdates(jobcostLog)
        }
        if (allPayouts) {
          setAllPayouts(allPayouts || [])
          
          // Store only manually added payouts in separate state
          const manualPayouts = allPayouts.filter(
            p => (p.is_manually_added === 1 || p.is_manually_added === "1") && 
                 (p.service_id === null || p.service_id === undefined || p.service_id === 0 || !p.service_id)
          );
          setManuallyAddedPayouts(manualPayouts || []);
        }
        if (allPayouts?.length > 0) {
          let totalPayOut = allPayouts?.reduce((acc, curr) => acc + curr.amount, 0)
          const totalHourlyPayoutAmount = allPayouts?.filter(payout => payout.is_auto_pay === 1 && (payout.service_id === null || payout.service_id === undefined || payout.service_id === 0 || payout.service_id === "0") && payout.is_manually_added !== 1)?.reduce((acc, curr) => acc + curr.amount, 0);
          setExcessHourlyPayoutAmount(totalHourlyPayoutAmount)
          const totalManualPayoutAmount = allPayouts?.filter(payout => payout.is_auto_pay !== 1 && (payout.service_id === null || payout.service_id === undefined || payout.service_id === 0 || payout.service_id === "0") && payout.is_manually_added !== 1)?.reduce((acc, curr) => acc + curr.amount, 0);
          setExcessManualPayoutAmount(totalManualPayoutAmount)

          const summedHourlyPayouts = Object.values(
            allPayouts?.filter(payout => payout.is_auto_pay === 1)?.reduce((acc, payout) => {
              // Create a unique key based on project_id, task_id, and team
              const key = `${payout.project_id}-${payout.task_id || "null"}-${payout.team || "null"}`;
              
              // Initialize the group in the accumulator if it doesn't exist
              if (!acc[key]) {
                acc[key] = {
                  project_id: payout.project_id,
                  task_id: payout.task_id,
                  team: payout.team,
                  total_amount: 0,
                };
              }
          
              // Add the current payout amount to the total for this group, rounded to 2 decimals
              acc[key].total_amount = parseFloat((acc[key].total_amount + payout.amount).toFixed(2));
          
              return acc;
            }, {})
          );
          
          console.log('summedHourlyPayouts===',summedHourlyPayouts);

          const summedManualPayouts = Object.values(
            allPayouts?.filter(payout => payout.is_auto_pay !== 1)?.reduce((acc, payout) => {
              // Create a unique key based on project_id, task_id, and team
              const key = `${payout.project_id}-${payout.task_id || "null"}-${payout.team || "null"}`;
              
              // Initialize the group in the accumulator if it doesn't exist
              if (!acc[key]) {
                acc[key] = {
                  project_id: payout.project_id,
                  task_id: payout.task_id,
                  team: payout.team,
                  total_amount: 0,
                };
              }
          
              // Add the current payout amount to the total for this group, rounded to 2 decimals
              acc[key].total_amount = parseFloat((acc[key].total_amount + payout.amount).toFixed(2));
          
              return acc;
            }, {})
          );
          
          console.log('summedManualPayouts===',summedManualPayouts);
          
          setHourlyTotalPayOut(summedHourlyPayouts?.reduce((acc, curr) => acc + curr.total_amount, 0))
          setManualTotalPayOut(summedManualPayouts?.reduce((acc, curr) => acc + curr.total_amount, 0))
          // setHourlyTotalPayOut(allPayouts.filter(payout => payout.is_auto_pay === 1).reduce((acc, curr) => acc + curr.amount, 0))
          // setManualTotalPayOut(allPayouts.filter(payout => payout.is_auto_pay !== 1).reduce((acc, curr) => acc + curr.amount, 0))
        console.log('allPayoutsallPayoutsallPayouts',allPayouts)
        }
        if (initialData) {
          setInitialMaterials(initialData)
        }
        if (productListData) {
          setProductList(productListData)
        }
        if (allMaterials) {
          setMaterialList(allMaterials)
        }
        if (project) {
          setJobCost(project.cost || 0)
        }
        console.log('response.data--', response.data);
        if (response.data.selectedMaterials?.length) {
          console.log('productListData--', productListData);
          console.log('selectedProducts----', selectedProducts);

          // setSelectedProjects(
          //   productListData
          //     .filter(item1 => selectedProducts.some(item2 => item1.id === item2.product_id))
          //     .map(item3 => {
          //       let match = selectedProducts.find(item2 => item3.id === item2.product_id);
          //       return { ...item3, ...(match ? { product_id: match.product_id, quantity: match.quantity, price: match.unit_price, recipeName: match.recipeName } : {}) };
          //     })
          // );
          console.log('selectedProducts------------',selectedProducts);
          const selectedProjects1 = selectedProducts.map(selectedProduct => {
            const matchingProduct = productListData.find(product => product.id === selectedProduct.product_id);
            // if (matchingProduct && Number(matchingProduct.qty) > 0) {
              if (matchingProduct) {
              return {
                ...matchingProduct,
                unit: selectedProduct?.partial_unit ? selectedProduct?.partial_unit : matchingProduct?.unit,
                product_id: selectedProduct.product_id,
                jobcost_quantity: selectedProduct.quantity,
                jobcost_actual_quantity: selectedProduct.actual_quantity,
                jobcost_unit_cost: selectedProduct.unit_price ?? 0,
                // jobcost_total:  selectedProduct.total ,
                jobcost_total: selectedProduct.total ?? ((selectedProduct.quantity ?? 0) * (selectedProduct.unit_price ?? 0)),
                jobcost_total_bill: selectedProduct.total_bill ?? 0,
                markup_percent: selectedProduct.markup_percent,
                material_markup_percentage: selectedProduct.material_markup_percentage,
                product_markup: selectedProduct.product_markup,
                billable: selectedProduct.billable ?? 1,
                recipeName: selectedProduct.recipeName,
                taken:selectedProduct.taken,
                task_id:selectedProduct.task_id,
                finalTaken:selectedProduct.finalTaken,
                customer_order_product_id: selectedProduct?.customer_order_product_id || null,
                job_cost_id:selectedProduct.id,
                available_stock:selectedProduct?.available_stock,
                jobcost_timestamp: selectedProduct?.jobcost_timestamp ?? null
              };
            }
            return null; // Handle cases where no matching product is found
          }).filter(project => project !== null);
          console.log('selectedProjects1------------',selectedProjects1);

          setSelectedProjects([...selectedProjects1,...rfpProducts]);
          
          console.log("##############SElected rfp projects",rfpProducts);
        } else {
          setSelectedProjects([]);
        }
      })  
    }catch (error) {
      console.error("Error fetching data:", error);
    }finally{
      setTimeout(() => {
        setLoading(false)
      }, 1000);
    }
  }

  const fetchAvailableServices = async () => {
    try {
      const response = await axios.post(`${REST_API_END_POINT}product/get-all-labour-cost-services-for-job-cost`,{TimeAndMaterial:isTM});
      if (response.data && response.data.results && response.data.results.length > 0) {
        setAvailableServices(response.data.results);
        setServicesTotalCount(response.data.results.length);
      }

    } catch (error) {
      console.error('Error fetching available services:', error);
    }
  };

  const fetchAllProductCategory = async () => {
    setLoading(true);
    try {
      axios
        .post(REST_API_END_POINT + 'product/get-all-product-categories')
        .then((res) => {
          let data = res.data
          if (data.status === 1) {
            let length = data.productCategories.length + 2
            console.log("length", length);
            // let recipe = [{
            //   "id": length,
            //   "name": "Product Formula",
            //   "added_by": 1,
            //   "status": 1,
            //   "timestamp": 1711096046,
            //   "c_id": 1,
            //   "authorized_by": "Rakesh Skyniche"
            // }]

            // //  setCategory(data.productCategories)
            // setCategory([...recipe]);
            setSelectedCategory(length)

          }
        })
        .catch((error) => {
          console.error('Error:', error)
        })
    } catch (e) {
      console.error('Exception:', e)
    }finally{
      setTimeout(() => {
        setLoading(false)
      }, 1000);
    }
  }
  console.log("############CAAA", category);
  useEffect(() => {
    if(req_id && req_id !== "undefined" || projectDetails?.request_id){
      console.log("sdfsdfsfd",projectDetails?.request_id)
      fetchData()
    }
    fetchAllProductCategory()
    fetchJobCostLogs();
    fetchAvailableServices();
  }, [renderCards, projectDetails]);

  useEffect(() => {
    if (projectData?.id) {
      fetchJobCostLogs();
    }
  }, [projectData]);

  let grandTotalCost = 0
  const progressValue = useMemo(() => {
    // const Cost = ((selectedProjects.reduce((accumulator, currentValue) => {
    //   return accumulator + (currentValue.unit_cost * currentValue.quantity);
    // }, 0) + Number(manualTotalPayOut) + Number(hourlyTotalPayOut) + Number(materialPayOut)) / jobCost) * 100
    let totalCost = selectedProjects.reduce((accumulator, currentValue) => {
      let newTotal = 0;
      if(currentValue?.taken == 1){
        newTotal = currentValue?.jobcost_total
        // newTotal = currentValue?.jobcost_unit_cost * currentValue?.jobcost_quantity
      }
      return accumulator + newTotal;
    }, 0) + manualTotalPayOut + materialPayOut + Math.max(0, (services?.reduce((accumulator, currentValue) => {
    // }, 0) + manualTotalPayOut + hourlyTotalPayOut + materialPayOut + Math.max(0, (services?.reduce((accumulator, currentValue) => {
      let newTotal = 0;
      if(currentValue?.taken == 1){
        // newTotal = currentValue?.originalCost * currentValue?.qty
        // newTotal = currentValue?.jobcost_unit_cost * currentValue?.jobcost_quantity
        newTotal = parseFloat(currentValue?.jobcost_total_cost || 0)
      }
      return accumulator + newTotal;
    }, 0) + additionalServices) -(parseFloat(manualTotalPayOut ? parseFloat(manualTotalPayOut) : 0)).toFixed(2)
    // }, 0) + additionalServices) -(parseFloat(manualTotalPayOut ? parseFloat(manualTotalPayOut) : 0) + (hourlyTotalPayOut ? parseFloat(hourlyTotalPayOut) : 0)).toFixed(2)
  )
    let Cost = (totalCost) / jobCost * 100;
    console.log("#################Cost-jobCost", jobCost);
    console.log("#################Cost-totalCost", totalCost);
    console.log("#################Cost-Cost", Cost);
    console.log("#################Cost1",  (manualTotalPayOut ? parseFloat(manualTotalPayOut) : 0) + (hourlyTotalPayOut ? parseFloat(hourlyTotalPayOut) : 0)
  );
    console.log("#################Cost", hourlyTotalPayOut);
    if (Cost > 100) {
      return 100
    } else {
      return Cost
    }
  }, [selectedProjects, manualTotalPayOut, hourlyTotalPayOut, services, additionalServices])

  console.log("###########seselectedProjects", progressValue);
  function isSumGreater(productId, valQty) {
    let sum = 0;
    initialMaterials?.forEach(material => {
      if (material.product_id === productId) {
        sum += material.quantity;
      }
    });
    productList?.forEach(product => {
      if (product.id === productId) {
        sum += product.qty;
      }
    });
    return sum < Number(valQty);
  }
  useEffect(() => {
    const errorFields = [];
    setErrorFieldId([]);
    selectedProjects?.forEach((val) => {
      console.log("###########Rfp value",val.rfp);
      const result = isSumGreater(val.productId, val.jobcost_quantity);
      if (result && val.rfp!=1) {
        errorFields.push({ productId: val.productId, errorText: 'Quantity exceeds the stock' });
      }
    });
    selectedProjects?.forEach((val) => {
      console.log("###########Rfp value",val.rfp);
      if (val.quantity <= 0 && val.rfp!=1) {
        errorFields.push({ productId: val.productId, errorText: 'Enter a valid quantity' });
      }
    });
    if (errorFields.length > 0) {
      setErrorFieldId([])
      setErrorFieldId(errorFields);
    }
  }, [selectedProjects, manualTotalPayOut, hourlyTotalPayOut])

  const handleProjectClick = (project) => {
    console.log("###################qqq", project);

    <Stack direction={{ xs: 'column', md: 'row' }}>
      <Typography variant="body" sx={{ display: 'flex', alignItems: 'center' }}>
        Material Name :
        <span style={{ color: theme.palette.primary.dark, fontWeight: 'bold' }}>
          <Autocomplete
            sx={{ ml: 1, width: 300 }}
            id="combo-box-demo"
            options={selectedMaterial.ingredients}
            value={ingredient}
            onChange={(event, newValue) => setIngredient(newValue)}
            renderInput={(params) => (
              <TextField {...params}
                label="Select a Material" />
            )}
            getOptionLabel={(option) => option.name ? option.name : ''}
          />
        </span>
        Quantity : {selectedMaterial?.ingredients?.find(item => item.product_id === ingredient?.product_id)?.quantity}
      </Typography>
    </Stack>

    setSelectedProjects(prevSelectedProjects => [...prevSelectedProjects, project]);
  };

  const fetchJobCostLogs = async () => {
    const projectId = projectData?.id || id;
    console.log('projectData?.id++++++++++',projectData?.id);
    console.log('Using projectId for request:', projectId);
    
    if (!projectId) {
      console.error("No project ID available for fetching job cost logs");
      return;
    }
    
    try {
      const newProjectId = isMirrored ? projectData?.id : projectId;
      const response = await axios.post(`${REST_API_END_POINT}project/get-job-cost-logs`, { projectId:newProjectId, isMirrored: isMirrored, targetFacilityId: targetFacilityId ? targetFacilityId : null });
      const fetchedLogs = response?.data?.data ?? [];
      setLogs(fetchedLogs);
      setUpdates(fetchedLogs);
    } catch (error) {
      console.error("Error fetching job cost logs:", error);
    }
  };

  const NewUserSchema = Yup.object().shape({
    quantity: Yup.number().min(0, 'Quantity must be at least 0').test('valid-quantity', 'Enter a valid quantity', (value) => value >= 0).required('Quantity is required'),
  });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      quantity: 1,
    },
    validationSchema: NewUserSchema,
    onSubmit: async (values, { setSubmitting, setFieldError }) => {
      try {
        // if(selectedProjects?.length > 0){
        console.log('selectedProjectsselectedProjectsselectedProjects',selectedProjects)
        const values = selectedProjects?.map(project => ({
          ...(project.product_id ? { id: project.product_id } : {}),
          productId: project.id,
          projectId: id,
          recipeName: project.recipeName ? project.recipeName : "",
          quantity: project.jobcost_quantity ?? 0,
          unitPrice: project.jobcost_unit_cost ?? project?.vendor_price ?? 0,
          actual_quantity: project.jobcost_actual_quantity ?? 0,
          actual_unit_cost: project.unit_cost ?? project?.vendor_price ?? 0,
          actual_total: project.actual_total_cost ?? (Number(project?.vendor_price ?? 0) * Number(project?.jobcost_quantity ?? 0)) ?? 0,
          taken: project.taken,
          task_id: project.task_id || null,
          rfp:project.rfp,
          total: (Number(project.jobcost_total ?? 0)),
          customer_order_product_id: project?.customer_order_product_id || null,
          jobcost_timestamp: project?.jobcost_timestamp || Math.floor(Date.now() / 1000),
          // total: (Number(project.jobcost_unit_cost) * project.jobcost_quantity)
        }))
        const serviceValues = services?.map(serv => ({
          ...serv,
          taken: serv.taken,
        }))
        // const takenStockProducts = stockProducts?.filter(
        //   serv => serv.taken === 1 && serv.finalTaken !== 1
        // );
        const takenStockProducts = stockProducts?.filter((serv) => {
          const qty = Number(serv.jobcost_quantity ?? 0);
          const inStock = Number(serv.in_stock_no ?? 0);

          const withinStock = inStock > 0 && qty <= inStock; // only allow if qty <= inStock and stock exists

          return serv.taken === 1 && serv.finalTaken !== 1 && withinStock;
        });
        function isSumGreater(productId, valQty) {
          let sum = 0;
          initialMaterials?.forEach(material => {
            if (material.product_id === productId) {
              sum += material.quantity;
            }
          });
          productList?.forEach(product => {
            if (product.id === productId) {
              sum += product.qty;
            }
          });
          return sum < Number(valQty);
        }
        const errorFields = [];
        values.forEach((val) => {
          const result = isSumGreater(val.productId, val.quantity);
          console.log("################val rfp0",val);
          // if (result &&  val.rfp!=1) {
          //   errorFields.push({ productId: val.productId, errorText: 'Quantity exceeds the stock ddd' });
          // }
        });
        values.forEach((val) => {
          if (val.quantity < 0 && val.rfp!=1) {
            errorFields.push({ productId: val.productId, errorText: 'Enter a valid quantity' });
          }
        });
        if (errorFields.length > 0) {
          setErrorFieldId([])
          setErrorFieldId(errorFields);
          // setRenderCards(!renderCards)
          return;
        }
        else {
          setErrorFieldId([])
          axios.post(`${REST_API_END_POINT}project/add-job-cost`, {
            userId: user.user_id,
            values,
            selectedServices: serviceValues,
            otherEntries,
            stockProducts: takenStockProducts,
            projectId: id,
            recipe: 1,
            finalizeInvoice: (Number(projectData?.isReview) === 2 || (Number(projectData?.isReview) === 1 && Number(projectData?.finalize_invoice) === 1)) ? 1 : 0,
            requestId: req_id || projectDetails?.request_id,
            isReview: (updates?.length > 0 && staffTimelogs?.length > 0) ? true : false,
            jobcost_timestamp: Math.floor(Date.now() / 1000),
            ...(notesTouched ? { internalNote, customerInvoiceNote } : {})
          }, {
            headers: {
              'Content-Type': 'application/json',
            },
          }).then((response) => {
            if (response.data.status === 1) {
              setNotesTouched(false);
              enqueueSnackbar(response.data.message, { variant: 'success' });
            } else if (response?.data?.message) {
              enqueueSnackbar(response.data?.message, { variant: 'error' });
            }
            else {
              enqueueSnackbar('Error adding Jobcost', { variant: 'error' });
            }
            setRenderCards(!renderCards)
            fetchJobCostLogs();
            onDataChange()
          }).catch((error) => {
            console.log("error",error);
            // enqueueSnackbar('Error adding sssssss Jobcost' + error, { variant: 'error' });
          })
        }
        // }else{
        //   enqueueSnackbar('Please select a material', { variant: 'error' });
        // }
        
        setSubmitting(false);
      } catch (error) {
        console.error(error);
        enqueueSnackbar('Error adding Jobcost' + error, { variant: 'error' });
      }
    }
  });

  const handleDeleteSubmit = async (deletedId) => {
    try {
      // console.log('deletedId----',deletedId);
      setSelectedProjects([...selectedProjects.filter(selected => selected.id !== deletedId)])
      const values = selectedProjects?.filter(selected => selected.id !== deletedId)?.map(project => ({
        ...(project.product_id ? { id: project.product_id } : {}),
        productId: project.id,
        projectId: id,
        quantity: project.jobcost_quantity,
        task_id: project.task_id || null,
        unitPrice: project.jobcost_unit_cost,
        // actual_quantity: project.actual_quantity,
        // actual_unit_cost: project.actual_unit_cost,
        // actual_total: project.actual_total,
        actual_quantity: project.unit_qty || 0,
        actual_unit_cost: project.unit_cost || 0,
        actual_total: project.actual_total_cost || 0,
        recipeName: project.recipeName ? project.recipeName : '', // Ensure match is defined
        total: (Number(project.jobcost_total)),
        jobcost_timestamp: project?.jobcost_timestamp || Math.floor(Date.now() / 1000),
        // total: (Number(project.jobcost_unit_cost) * project.jobcost_quantity)
      }));

      function isSumGreater(productId, valQty) {
        let sum = 0;
        initialMaterials?.forEach(material => {
          if (material.product_id === productId) {
            sum += material.quantity;
          }
        });
        productList?.forEach(product => {
          if (product.id === productId) {
            sum += product.qty;
          }
        });
        return sum < Number(valQty);
      }

      const errorFields = [];
      values.forEach((val) => {
        const result = isSumGreater(val.productId, val.quantity);
        if (result) {
          errorFields.push({ productId: val.productId, errorText: 'Quantity exceeds the stock' });
        }
      });

      values.forEach((val) => {
        if (val.quantity <= 0) {
          errorFields.push({ productId: val.productId, errorText: 'Enter a valid quantity' });
        }
      });

      if (errorFields.length > 0) {
        setErrorFieldId([])
        setErrorFieldId(errorFields);
        return;
      } else {
        setErrorFieldId([])
        axios.post(`${REST_API_END_POINT}project/add-job-cost`, { userId: user.user_id, values, projectId: id, recipe: 1, jobcost_timestamp: Math.floor(Date.now() / 1000) }, {
          headers: {
            'Content-Type': 'application/json',
          },
        }).then((response) => {
          if (response.data.status === 1) {
            enqueueSnackbar(response.data.message, { variant: 'success' });
          } else if (response?.data?.message) {
            enqueueSnackbar(response.data.message, { variant: 'error' });
          } else {
            enqueueSnackbar('Error adding Jobcost', { variant: 'error' });
          }
          onDataChange()
          setSelectedProjects([])
          setManualTotalPayOut(0)
          setHourlyTotalPayOut(0)
          setInitialMaterials([])
          setProductList([])
          setMaterialList([])
          setJobCost(0)
          setDeleteId();
          // fetchData()
          setRenderCards(!renderCards)
          onDataChange()
        }).catch((error) => {
          console.error(error);
          enqueueSnackbar('Error adding Jobcost', { variant: 'error' });
        })
      }
    } catch (error) {
      console.error(error);
      enqueueSnackbar('Error adding Jobcost' + error, { variant: 'error' });
    }
  }

  const handleJobCost = async () => {
    console.log("#####################Hifiiiiiiiiiiiiii");
    axios.post(`${REST_API_END_POINT}recipe/update-job-cost-automatically`, { userId: user.user_id, projectId: id, requestId: req_id || projectDetails?.request_id, name: projectData.name }).then((response) => {
      if (response.data.status === 1) {
        // fetchData();
        // setJobCost(0)
        setMaterialList([])
        setProductList([])
        setInitialMaterials([])
        setAllServices([])
        setRecipe([])
        setAdditionalServices([])
        setProjectData([])
        // setMaterialPayOut(0)
        // setHourlyTotalPayOut(0)
        // setManualTotalPayOut(0)
        setSelectedProjects([])
        setRenderCards(!renderCards)
        onDataChange()
        enqueueSnackbar(response.data.message, { variant: 'success' });
      } else if (response.data.status === 0) {
        enqueueSnackbar(response.data.message, { variant: 'error' });
      }
    })
  }
  const handleFilterByName = (event) => {
    setFilterName(event.target.value);
  };
  const handleCategoryChange = (category) => {
    setSelectedCategory(category);
  };
  const { errors, touched, handleSubmit, isSubmitting, getFieldProps } = formik;
   // Backup before T&M material markup fix: const isTM = projectData?.project_category === 12;
   const laborTabCount = laborRowsCount?.total || 0;
   const otherTabServicesCount = useMemo(() => {
     // OLD: return (services || []).filter(s => {
     //   const isInstallLabor = Number(s.id) === 10 || Number(s.labour_cost_service_id) === 10;
     //   return isTM ? !isInstallLabor : Number(s.from_job) === 1;
     // }).length;
     return (services || []).filter((s) => shouldShowServiceOnJobCostOtherTab(s, isTM)).length;
   }, [services, isTM]);
   const laborSectionTabs = [
     { value: 'Labor', label: isTM ? 'Install Labor' :'Labor', color: 'primary', count: laborTabCount },
     { value: 'Materials', label: 'Materials', color: 'info', count: (selectedProjects?.length || 0) + (additionalMaterials?.length || 0) },
     { value: 'Equipment', label: 'Equipment', color: 'warning', count: otherEntries?.length || 0 },
     { value: 'Other', label: isTM ? 'Add Services':'Other', color: 'error', count: otherTabServicesCount },
     { value: 'Summary', label: 'Summary', color: 'success', count: 0 }
   ];
  const materialWithStock = materialList?.filter((data) => data?.total_qty > 0)
  const productWithQty = productList?.filter((data) => data?.qty > 0)
  const linkState = {
    pathname: `${PATH_DASHBOARD.project.jobCost}/${id}`,
    state: params
  };

  // const handleClick = () => {
  //   if(popupOn){
  //   handleClickOpenJobCost()
  //   setRecipeCostCurrentTab(currentTab);
  // }else{
  //   navigate(`${PATH_DASHBOARD.project.jobCost}/${id}`,
  //     {state: { request: req_id || projectDetails?.request_id,currentTab : currentTab, isEstimateJob: isEstimateJob }});
  //   }
  const handleOpenAddMaterial = () => {
    setRecalculateTrigger((prev) => prev + 1);
    setJobCostCalculatorModal(true);
  };

  const handleCloseJobCostCalculatorModal = () => {
    setJobCostCalculatorModal(false);
    fetchData();
    if (onDataChange) onDataChange();
  };

  const handleCloseJobCostAddMaterialModal = () => {
    setJobCostCalculatorModal(false);
    // fetchData();
    if (onDataChange) onDataChange();
  };

  const handleOpenAddService = () => {
    fetchAvailableServices();
    setServicesPage(0);
    setServicesRowsPerPage(10);
    setServicesPreview(true);
  };

  const handleInternalNoteChange = (value) => {
    setInternalNote(value);
    setNotesTouched(true);
  };

  const handleCustomerInvoiceNoteChange = (value) => {
    setCustomerInvoiceNote(value);
    setNotesTouched(true);
  };

  const handleGenerateSummaryWithAI = async () => {
    if (isGeneratingSummaryNote) return;
    setIsGeneratingSummaryNote(true);
    try {
      const startDate = projectData?.installation_start_date ? Number(projectData?.installation_start_date) * 1000 : null;
      const endDate = projectData?.installation_end_date ? Number(projectData?.installation_end_date) * 1000 : null;
      const formatDate = (dateValue) => {
        if (!dateValue || Number.isNaN(new Date(dateValue).getTime())) return '';
        return new Date(dateValue).toLocaleDateString(undefined, { month: 'long', day: 'numeric', year: 'numeric' });
      };
      const periodLabel = startDate && endDate
        ? `${formatDate(startDate)} - ${formatDate(endDate)}`
        : 'Current billing period';

      const summaryPayload = {
        ...summaryTabData,
        stats: {
          ...summaryTabData.stats,
          Equipment: summaryTabData.stats.Other,
          Other: summaryTabData.stats.Equipment
        },
        billable: Number(grandTotalBill || 0),
        cost: Number(totalCostWithBill || 0),
        margin: `${Number(actualMarginPercent || 0).toFixed(2)}%`
      };

      const response = await axios.post(`${REST_API_END_POINT}project/generate-invoice-summary-note`, {
        summaryData: summaryPayload,
        periodLabel,
        projectName: projectData?.name || '',
        customerName: projectData?.customer || projectData?.customer_name || ''
      });

      if (response?.data?.status === 1 && response?.data?.note) {
        setCustomerInvoiceNote(response.data.note);
        setNotesTouched(true);
      } else {
        enqueueSnackbar(response?.data?.message || 'Failed to generate note', { variant: 'error' });
      }
    } catch (error) {
      console.log('AI summary note generation error', error);
      enqueueSnackbar('Failed to generate note', { variant: 'error' });
    } finally {
      setIsGeneratingSummaryNote(false);
    }
  };

  const handleRecalculateAll = () => {
    fetchData();
    fetchJobCostLogs();
    setRecalculateTrigger((prev) => prev + 1);
    enqueueSnackbar('Totals Recalculated Successfully', { variant: 'success' });
  };

  const refreshJobCostGraphData = () => {
    fetchData();
    setRecalculateTrigger((prev) => prev + 1);
  };

  // grandTotalCost = selectedProjects.reduce((accumulator, currentValue) => {
  //   let newTotal = 0;
  //   if(currentValue?.taken == 1){
  //     newTotal = currentValue?.unit_cost * currentValue?.quantity
  //   }
  //   return accumulator + newTotal;
  // }, 0) + manualTotalPayOut + hourlyTotalPayOut + materialPayOut + Math.max(0, (services?.reduce((accumulator, currentValue) => {
  //   let newTotal = 0;
  //   if(currentValue?.taken == 1){
  //     newTotal = currentValue?.originalCost * currentValue?.qty
  //   }
  //   return accumulator + newTotal;
  // }, 0) + additionalServices) - (manualTotalPayOut ? manualTotalPayOut?.toFixed(2) : 0) + (hourlyTotalPayOut ? hourlyTotalPayOut?.toFixed(2) : 0))

  
  let newMaterialPayOut = parseFloat(materialPayOut.toFixed(2)) || 0;
  let newMaterialPayOutBill = parseFloat((materialPayOutBill || 0).toFixed(2));

  let selectedProjectsTotal = selectedProjects?.reduce((accumulator, currentValue) => {
      let newTotal = 0;
      if (includeRecipeCostMaterialRow(currentValue)) {
          // Backup before T&M material markup: newTotal = currentValue?.jobcost_total;
          newTotal = getJobCostMaterialCost(currentValue, isTM);
      }
      return accumulator + newTotal;
  }, 0) || 0;

  let selectedProjectsTotalBill = selectedProjects?.reduce((accumulator, currentValue) => {
      let newTotal = 0;
      if (includeRecipeCostMaterialRow(currentValue)) {
          const isBillable = currentValue?.billable === 1 || currentValue?.billable === '1' || currentValue?.billable === true || currentValue?.is_billable === 1 || currentValue?.is_billable === '1' || currentValue?.is_billable === true;
          if (isBillable) {
              newTotal = parseFloat(currentValue?.jobcost_total_bill || currentValue?.total_bill || 0);
          }
      }
      return accumulator + newTotal;
  }, 0) || 0;
  
  let servicesTotal = services?.reduce((accumulator, currentValue) => {
      const isLaborService = Number(currentValue?.labour_cost_service_id) === 10;
      let newTotal = 0;
      if (isLaborService) {
        if (currentValue?.taken === 1) {
          // OLD: newTotal = parseFloat(currentValue?.jobcost_total_cost || 0);
          newTotal = resolveInstallLaborServiceLineCost(currentValue, isTM);
        }
      } else if (includeRecipeCostServiceRow(currentValue)) {
        // OLD: newTotal = parseFloat(currentValue?.jobcost_total_cost || 0);
        newTotal = resolveJobCostServiceLineTotal(currentValue, isTM);
      }
      return accumulator + newTotal;
  }, 0) || 0;

  const installLaborRowCostSum = (services || []).reduce((sum, s) => {
    if (Number(s?.labour_cost_service_id) !== 10) return sum;
    if (!includeRecipeCostServiceRow(s)) return sum;
    // OLD: return sum + parseFloat(s?.jobcost_total_cost || 0);
    return sum + resolveInstallLaborServiceLineCost(s, isTM);
  }, 0);

  const installLaborRowBillSum = (services || []).reduce((sum, s) => {
    if (Number(s?.labour_cost_service_id) !== 10) return sum;
    if (!includeRecipeCostServiceRow(s)) return sum;
    const isBill =
      s?.billable === 1 || s?.billable === '1' || s?.billable === true;
    if (!isBill) return sum;
    return sum + parseFloat((s?.total_bill ?? s?.jobcost_total_bill) || 0);
  }, 0);

  // Helper to identify and aggregate timelogs that belong purely to "Install Labor" (Service ID 10 or no service associated)
  const installLaborMetrics = useMemo(() => {
    const logs = staffTimelogsGet || [];
    let costTotal = 0;
    let billTotal = 0;
    
    // Find the Install Labor service rate for fallback
    const installLaborService = (services || []).find(s => Number(s.labour_cost_service_id) === 10);
    // OLD: const serviceRate = Number(installLaborService?.jobcost_unit_cost || installLaborService?.originalCost || installLaborService?.unit_cost || 0);
    const serviceRate = resolveInstallLaborServiceUnitCost(installLaborService, isTM);
    const serviceBillRate = Number(installLaborService?.bill_unit_price || installLaborService?.unit_bill || 0);

    logs.forEach(log => {
      // const sId = Number(log?.service_id || log?.rs_id || log?.customer_order_product_id || 0);
      // const isDriver = log?.isDriver === 1 || log?.isDriver === '1' || log?.is_driver === 1 || log?.is_driver === '1';
      // const taskName = (log?.task_name || '').toString().trim().toUpperCase();
      
      // const isManual = log?.is_manually_added === 1 || log?.is_manually_added === '1';
      // const isDefaultLabor = sId === 10 || (sId === 0 && (taskName === 'INSTALL LABOR' || taskName === 'LABOR INSTALL' || isDriver || !isManual));
      
      // if (isDefaultLabor) {
      //   // OLD: only T&M passed install-labor service rate; non-T&M used staff hourly from timelog.
      //   // const fallbackR = isTM ? serviceRate : 0;
      //   // const fallbackBR = isTM ? serviceBillRate : 0;
      //   const fallbackR = serviceRate;
      //   const fallbackBR = isTM ? serviceBillRate : 0;
      //   const computed = getRecipeCostLaborRowComputed(log, fallbackR, fallbackBR);
        
      //   costTotal += (Number(computed?.cost) || 0);
        
      //   const isBillable = log?.billable === 1 || log?.billable === true || log?.is_billable === 1 || log?.is_billable === true;
      //   if (isBillable) {
      //     billTotal += (Number(computed?.bill) || 0);
      //   }
      // }
      if (!isJobCostInstallLaborTimelog(log, services)) return;

      // OLD: only T&M passed install-labor service rate; non-T&M used staff hourly from timelog.
      // const fallbackR = isTM ? serviceRate : 0;
      // const fallbackBR = isTM ? serviceBillRate : 0;
      const fallbackR = serviceRate;
      const fallbackBR = isTM ? serviceBillRate : 0;
      const computed = getRecipeCostLaborRowComputed(log, fallbackR, fallbackBR);
      
      costTotal += (Number(computed?.cost) || 0);
      
      const isBillable = log?.billable === 1 || log?.billable === true || log?.is_billable === 1 || log?.is_billable === true;
      if (isBillable) {
        billTotal += (Number(computed?.bill) || 0);
      }
    });
    
    return {
      cost: costTotal,
      bill: billTotal
    };
  }, [staffTimelogsGet, services, isTM]);

  let hasAddedLaborBill = false;
  let servicesTotalBill = services?.reduce((accumulator, currentValue) => {
    let newTotalBill = 0;
    const isLaborService = Number(currentValue?.labour_cost_service_id) === 10;
    if (isLaborService) {
      if (!hasAddedLaborBill) {
        // Use the filtered "Install Labor" portion of the labor tab
        const installServiceTotal = services.filter(s => Number(s.labour_cost_service_id) === 10 && includeRecipeCostServiceRow(s))
          .reduce((sum, s) => sum + parseFloat(s.jobcost_total_bill || s.total_bill || 0), 0);
        newTotalBill = Math.max(installLaborMetrics.bill, installLaborRowBillSum, installServiceTotal);
        hasAddedLaborBill = true;
      }
    } else if (includeRecipeCostServiceRow(currentValue)) {
      const logsForThisService = (staffTimelogsGet || []).filter(log => Number(log?.service_id || log?.rs_id || log?.customer_order_product_id || 0) === Number(currentValue.id));
      if (logsForThisService.length > 0) {
        newTotalBill = logsForThisService.reduce((sum, log) => {
          const isLogBillable = log?.billable === 1 || log?.billable === true || log?.is_billable === 1 || log?.is_billable === true;
          if (!isLogBillable) return sum;
          const computed = getRecipeCostLaborRowComputed(log);
          return sum + (Number(computed?.bill) || 0);
        }, 0);
      } else {
        const isBillable = currentValue?.billable === 1 || currentValue?.billable === '1' || currentValue?.billable === true || currentValue?.is_billable === 1 || currentValue?.is_billable === '1' || currentValue?.is_billable === true;
        if (isBillable) {
          newTotalBill = parseFloat((currentValue?.total_bill ?? currentValue?.jobcost_total_bill) || 0);
        }
      }
    }
    return accumulator + newTotalBill;
  }, 0) || 0;
  
  selectedProjectsTotal = parseFloat(selectedProjectsTotal.toFixed(2));
  servicesTotal = parseFloat(servicesTotal.toFixed(2));
  servicesTotalBill = parseFloat(servicesTotalBill.toFixed(2));
  
  let manualTotal = parseFloat(manualTotalPayOut?.toFixed(2)) || 0;
  let hourlyTotal = parseFloat(hourlyTotalPayOut?.toFixed(2)) || 0;
  
  let newAdditionalServices = additionalServices || 0;
  
  let manualAndHourlyTotal = Math.max(0, manualTotal + hourlyTotal);
  let totalServiceCost = services?.reduce((accumulator, currentValue) => {
      // return accumulator + (currentValue?.originalCost * currentValue?.qty);
      // return accumulator + (currentValue?.jobcost_unit_cost * currentValue?.jobcost_quantity);
      return accumulator + parseFloat(currentValue?.jobcost_total_cost || 0);
  }, 0) || 0;
  
  // const handleMaterialCheckboxChange = (index) => {
  //   setSelectedProjects(prevState => 
  //     prevState.map((project, i) => 
  //       i === index ? { ...project, taken: project.taken ? 0 : 1 } : project
  //     )
  //   );
  // };

  const handleMaterialCheckboxChange = (index) => {
    setSelectedProjects((prevState) =>
      prevState.map((project, i) => {
        if (i === index) {
        
          if (project.finalTaken === 1) {
            return {
              ...project,
              taken: project.finalTaken ? 1 : 1,
              // jobcost_quantity: project.taken ? project.jobcost_quantity : project.jobcost_actual_quantity,
              // jobcost_unit_cost: project.taken ? project.jobcost_unit_cost : project.jobcost_actual_unit_cost,
              // // jobcost_total: project.taken ? (Number(project.jobcost_actual_quantity) * Number(project.jobcost_unit_cost)) : (project.jobcost_actual_quantity * Number(project.jobcost_actual_unit_cost)),
              // jobcost_total:  (Number(project.jobcost_actual_quantity) * Number(project.jobcost_unit_cost)) || (project.jobcost_actual_quantity * Number(project.jobcost_actual_unit_cost)),
          
            };
          }
          return {
            ...project,
            taken: project.taken ? 0 : 1,
            jobcost_quantity: project.taken==1 ? project.jobcost_quantity : project.jobcost_actual_quantity,
            jobcost_unit_cost: project.taken==1 ? project.jobcost_unit_cost : project.jobcost_actual_unit_cost,
            // jobcost_total: project.taken ? (Number(project.jobcost_actual_quantity) * Number(project.jobcost_unit_cost)) : (project.jobcost_actual_quantity * Number(project.jobcost_actual_unit_cost)),
            // Backup before T&M material markup: jobcost_total: (Number(project.jobcost_actual_quantity) * Number(project.unit_cost)),
            jobcost_total: isTM
              ? getJobCostMaterialCost(project, true, {
                  qty: project.jobcost_actual_quantity,
                  unitCost: project.jobcost_unit_cost || project.unit_cost
                })
              : (Number(project.jobcost_actual_quantity) * Number(project.unit_cost)) ,
        
          };
        }
        return project;
      })
    );
  };
  
  const handleStockCheckboxChange = (index,isStock) => {
    setStockProducts((prevState) =>
      prevState.map((project, i) => {
        if (i !== index) return project;

        if (project.finalTaken === 1) {
          return {
            ...project,
            taken: 1
          };
        }

        let newTaken = project.taken === 1 ? 0 : 1;
        // if (
        //   newTaken === 1 &&
        //   (project.jobcost_quantity > project.in_stock_no || !project.in_stock_no)
        // ) {
        //   newTaken = 0;
        // }
        // const updatedJobcostQuantity =
        //   newTaken === 1
        //     ? (Number(project.jobcost_quantity) > 0
        //       ? Number(project.jobcost_quantity)
        //       : Number(project.location_quantity) || 1)
        //     : Number(project.jobcost_quantity);
        const updatedJobcostQuantity =
          newTaken === 1
            ? isStock
              ? Number(project.in_stock_no) || 0
              : (Number(project.jobcost_quantity) > 0
                ? Number(project.jobcost_quantity)
                : Number(project.location_quantity) || 1)
            : Number(project.jobcost_quantity);

        const updatedTotalCost =
          newTaken === 1
            ? Number((Number(updatedJobcostQuantity) * Number(project.product_retail_price || 0)).toFixed(2))
            : project.jobcost_total_cost;

        return {
          ...project,
          taken: newTaken,
          jobcost_quantity: updatedJobcostQuantity,
          jobcost_total_cost: updatedTotalCost
        };
      })
    );
  };

  
  // const handleServiceCheckboxChange = (index,service) => {
  //   const isLabour10 = service?.labour_cost_service_id === 10;
  //   console.log('projectprojectprojectproject 2', service)
  //   setAllServices(prevState => 
  //     prevState.map((project, i) => 
  //       i === index ? { ...project, taken: project.taken ? 0 : 1,jobcost_quantity : project.qty  , jobcost_total_cost : project.qty * project.unit_cost} : project
  //     )
  //   );
  // };

const handleServiceCheckboxChange = (index, service) => {
  console.log('serviceeeeeeeeeeeeeeee1', service)
  const isLabour10 = service?.labour_cost_service_id === 10;

  // If production labor and has manual hours, don't trigger any calculations - return early
  if (service?.__isRecipeGroup && totalManualHours > 0) {
    return;
  }
  setAllServices(prevState => {
    const labour10HasQty =
      isLabour10 &&
      prevState.some(
        p => p.labour_cost_service_id === 10 && Number(p.jobcost_quantity) > 0
      );

    return prevState.map(project => {
      const jobcostQtyNum = parseFloat(project.jobcost_quantity) || 0;
      console.log('serviceeeeeeeeeeeeeeee jobcostQtyNum', jobcostQtyNum)
      
      const jobcostQuantity = jobcostQtyNum > 0 ? jobcostQtyNum : Number(project.qty) || 0;
      console.log('serviceeeeeeeeeeeeeeee jobcostQuantity', jobcostQuantity)

      if (isLabour10 && project.labour_cost_service_id === 10) {
        if (project.finalTaken === 1) {
          return { ...project, taken: 1 };
        }

        if (labour10HasQty) {
          return { ...project, taken: project.taken ? 0 : 1 };
        }

        return {
          ...project,
          taken: project.taken ? 0 : 1,
          ...(jobcostQtyNum <= 0 && {
            jobcost_quantity: jobcostQuantity,
            jobcost_total_cost: (project?.jobcost_total_cost && project?.jobcost_total_cost > 0) ? project?.jobcost_total_cost : Number((jobcostQuantity * project.originalCost).toFixed(2)),
          }),
        };
      }
if (service?.__isRecipeGroup && project.recipe_id != null && project.labour_cost_service_id !== 10) {
  // Get manually added payouts total to check if production labor should be locked
  const manuallyAddedPayoutsTotal = manuallyAddedPayouts?.reduce(
    (sum, p) => sum + parseFloat(p.amount || 0), 0
  ) || 0;
  
  const jobcostQtyNum = parseFloat(project.jobcost_quantity) || 0;
  const jobcostQuantity = jobcostQtyNum > 0 ? jobcostQtyNum : Number(project.qty) || 0;

  // ✅ Check if any other items in the recipe group already have values
  const hasOtherRecipeQty = prevState.some(
    s => s.recipe_id === project.recipe_id &&
         s.id !== project.id &&
         Number(s.jobcost_quantity) > 0
  );

  // Determine finalTaken: if manually added hours/payouts exist, must be taken (1), otherwise toggle
  const finalTaken = (manuallyAddedPayoutsTotal > 0 || totalManualHours > 0) ? 1 : (project.taken ? 0 : 1);

  const updated = {
    ...project,
    taken: finalTaken,
  };
console.log('updatedddddddddd 1',updated)
  if (finalTaken === 1 && !hasOtherRecipeQty) {
    updated.jobcost_quantity = jobcostQuantity;
    updated.jobcost_total_cost =
      project?.jobcost_total_cost && project?.jobcost_total_cost > 0
        ? project?.jobcost_total_cost
        : Number((jobcostQuantity * project.originalCost).toFixed(2));
  }
console.log('updatedddddddddd 2',updated)
  return updated;
}

      console.log('service?.id === project.id',service?.id, project.id)
      if ((service?.id === project.id) && !service?.__isRecipeGroup ) {
        // if (project.finalTaken === 1) {
        //   return { ...project, taken: 1 };
        // }

        return {
          ...project,
          taken: project.taken ? 0 : 1,
          ...(jobcostQtyNum <= 0 && {
            jobcost_quantity: jobcostQuantity,
            jobcost_total_cost: (project?.jobcost_total_cost && project?.jobcost_total_cost > 0) ? project?.jobcost_total_cost : Number((jobcostQuantity * project.originalCost).toFixed(2)),
          }),
        };
      }

      console.log('serviceeeeeeeeeeeeeeee project', project)
      return project; // untouched rows
    });
  });
};

  const additionalLaborCost1 = useMemo(() => (
  services.reduce((sum, service) => {
    if (!includeRecipeCostServiceRow(service) || service.recipe_id != null || service.labour_cost_service_id === 10) return sum;
    const actual = parseFloat(service.jobcost_total_cost || 0);
    const expected = (parseFloat(service.originalCost) || 0) * (parseFloat(service.qty) || 0);
    return sum + (projectData?.project_category !== 12 && expected > 0 ? Math.min(actual, expected) : actual);
  }, 0)
), [services, projectData?.project_category]);

  /** Job Editing header: match Labor tab + timelog rows (allPayOut sums can stay stale after rate edits). */
  const timelogStaffPayoutTotals = useMemo(() => {
    const logs = staffTimelogsGet || [];
    const installLaborService = (services || []).find(s => Number(s.labour_cost_service_id) === 10);
    // OLD: const installServiceCostRate = Number(installLaborService?.jobcost_unit_cost || installLaborService?.originalCost || installLaborService?.unit_cost || 0);
    const installServiceCostRate = resolveInstallLaborServiceUnitCost(installLaborService, isTM);
    let manual = 0;
    let hourly = 0;
    for (const log of logs) {
      // OLD: getLaborTimelogCost(log) — used member hourly whenever present.
      // const cost = getLaborTimelogCost(log);
      const fb = isRecipeCostInstallLaborTimelog(log) ? installServiceCostRate : 0;
      const cost = getLaborTimelogCost(log, fb);
      const isManual = log?.is_manually_added === 1 || log?.is_manually_added === '1';
      if (isManual) manual += cost;
      else hourly += cost;
    }
    return {
      manual: Math.round((manual + Number.EPSILON) * 100) / 100,
      hourly: Math.round((hourly + Number.EPSILON) * 100) / 100
    };
  }, [staffTimelogsGet, services]);

  const jobEditingHeaderLaborPayout = useMemo(() => {
    const useTimelog = (staffTimelogsGet || []).length > 0;
    if (useTimelog) {
      const total = timelogStaffPayoutTotals.manual + timelogStaffPayoutTotals.hourly;
      return {
        actualLaborCost: Number(tabSummaryStats?.Labor?.cost ?? 0),
        manualStaffPayout: timelogStaffPayoutTotals.manual,
        hourlyStaffPayout: timelogStaffPayoutTotals.hourly,
        totalStaffPayout: Math.round((total + Number.EPSILON) * 100) / 100
      };
    }
    return {
      actualLaborCost: Number(additionalLaborCost1) || 0,
      manualStaffPayout: Number(manualTotalPayOut) || 0,
      hourlyStaffPayout: Number(hourlyTotalPayOut) || 0,
      totalStaffPayout: (Number(manualTotalPayOut) || 0) + (Number(hourlyTotalPayOut) || 0)
    };
  }, [
    staffTimelogsGet,
    timelogStaffPayoutTotals,
    tabSummaryStats?.Labor?.cost,
    additionalLaborCost1,
    manualTotalPayOut,
    hourlyTotalPayOut
  ]);

const totalStockCost = useMemo(() => (
  stockProducts.reduce((sum, item) => {
    if (item?.taken !== 1) return sum;

    const cost = parseFloat(item.jobcost_total_cost || 0);
    return sum + cost;
  }, 0)
), [stockProducts]);
console.log('totalStockCosttotalStockCost',totalStockCost)

// const excessLaborCost1 = useMemo(() => {
//   let labourExpected = 0;
//   let labourActual   = 0;
//   let otherExcess    = 0;
// console.log('excessLaborCost1---services--',services)
//   services.forEach(r => {
//     const expected = r.taken == 1 ? (parseFloat(r.originalCost * r.qty) || 0) : 0;
//     const actual   = r.taken == 1 ? (parseFloat(r.jobcost_total_cost) || 0) : 0;

//     if (+r.labour_cost_service_id === 10) {
//       // Group totals for labour id 10
//       labourExpected += expected;
//       labourActual   += actual;
//     } else {
//       // Per-row excess calculation for others
//       if (actual > expected) {
//         otherExcess += actual - expected;
//       }
//     }
//   });

//   const labourExcess = labourActual > labourExpected
//     ? labourActual - labourExpected
//     : 0;
//   console.log('excessLaborCost1---labourExcess', labourExcess)
//   console.log('excessLaborCost1---otherExcess', otherExcess)
//   console.log('excessLaborCost1---excessHourlyPayoutAmount', excessHourlyPayoutAmount)
//   console.log('excessLaborCost1---excessManualPayoutAmount', excessManualPayoutAmount)
//   return +(labourExcess + otherExcess + (excessHourlyPayoutAmount || 0) + (excessManualPayoutAmount || 0)).toFixed(2);
// }, [services, excessHourlyPayoutAmount, excessManualPayoutAmount]);

// OLD: excessLaborCost1 — install labor (id 10) counted in labourExcess (Install $65 showed as Excess when expected qty was 0).
// const excessLaborCost1 = useMemo(() => {
//   let labourExpected = 0;
//   let labourActual = 0;
//   let productionExpected = 0;
//   let productionActual = 0;
//   // let otherExpected = 0;
//   // let otherActual = 0;
//   let otherExcess = 0;
//
//   services.forEach(s => {
//     const isTaken = s.taken == 1 || s.billable == 1 || s.is_billable == 1;
//     if (!isTaken) return;
//
//     const unitCost = (parseFloat(s.originalCost) || 0);
//     const expected = (parseFloat(unitCost * s.qty) || 0);
//     const actual = resolveJobCostServiceLineTotal(s, isTM);
//
//     if (+s.labour_cost_service_id === 10) {
//       // install labour
//       labourExpected += expected;
//       labourActual += Math.max(actual, installLaborMetrics.cost);
//     } else if (s.recipe_id && s.labour_cost_service_id !== 10) {
//       // production labour
//       productionExpected += expected;
//       productionActual += actual;
//     } else {
//       // additional services / other
//       if (actual > expected) {
//         otherExcess += actual - expected;
//       }
//     }
//   });
//
//   const labourExcess = labourActual > labourExpected ? labourActual - labourExpected : 0;
//   const productionExcess = productionActual > productionExpected ? productionActual - productionExpected : 0;
//   // const otherExcess = otherActual > otherExpected ? otherActual - otherExpected : 0;
//   if (projectData?.project_category === 12) return (0).toFixed(2);
//
//   return (
//     labourExcess +
//     productionExcess +
//     otherExcess +
//     (excessHourlyPayoutAmount || 0) +
//     (excessManualPayoutAmount || 0)
//   ).toFixed(2);
// }, [services, excessHourlyPayoutAmount, excessManualPayoutAmount, installLaborMetrics, isTM, projectData?.project_category]);

const excessLaborCost1 = useMemo(() => {
  let productionExpected = 0;
  let productionActual = 0;
  // let otherExpected = 0;
  // let otherActual = 0;
  let otherExcess = 0;

  services.forEach(s => {
    const isTaken = s.taken == 1 || s.billable == 1 || s.is_billable == 1;
    if (!isTaken) return;

    // install labour
    // Install labor (id 10) belongs on Install Labor card only — never Excess Labor (T&M or cost card).
    if (+s.labour_cost_service_id === 10) return;

    const unitCost = (parseFloat(s.originalCost) || 0);
    const expected = (parseFloat(unitCost * s.qty) || 0);
    const actual = resolveJobCostServiceLineTotal(s, isTM);

    if (s.recipe_id && s.labour_cost_service_id !== 10) {
      // production labour
      productionExpected += expected;
      productionActual += actual;
    } else {
      // additional services / other
      if (actual > expected) {
        otherExcess += actual - expected;
      }
    }
  });

  const productionExcess = productionActual > productionExpected ? productionActual - productionExpected : 0;
  // const otherExcess = otherActual > otherExpected ? otherActual - otherExpected : 0;
  if (projectData?.project_category === 12) return (0).toFixed(2);

  return (
    productionExcess +
    otherExcess +
    (excessHourlyPayoutAmount || 0) +
    (excessManualPayoutAmount || 0)
  ).toFixed(2);
}, [services, excessHourlyPayoutAmount, excessManualPayoutAmount, isTM, projectData?.project_category]);

const installLaborExpected = useMemo(() => {
  return (services || []).reduce((sum, s) => {
    if (Number(s?.labour_cost_service_id) !== 10 || !includeRecipeCostServiceRow(s)) return sum;
    return sum + (parseFloat(s.originalCost || 0) * parseFloat(s.qty || 0));
  }, 0);
}, [services]);

const installLaborCost = useMemo(() => {
  const installRows = services.filter(s => Number(s.labour_cost_service_id) === 10 && includeRecipeCostServiceRow(s));
  const manualRows = installRows.filter(s => s.jobcost_quantity != null && s.jobcost_quantity !== '');
  
  let actualCost = installLaborMetrics.cost;
  if (manualRows.length > 0) {
    // OLD: sum + (parseFloat(s.jobcost_total_cost) || parseFloat(s.total_cost) || 0)
    const sumFromServices = installRows.reduce(
      (sum, s) => sum + resolveInstallLaborServiceLineCost(s, isTM),
      0
    );
    actualCost = Math.max(installLaborRowCostSum, sumFromServices);
  }
  return actualCost.toFixed(2);
}, [installLaborMetrics, installLaborRowCostSum, services]);



// const productionLabourTotal = useMemo(() => {
//   return services?.reduce((acc, s) => {
//     if (s?.recipe_id && s?.labour_cost_service_id !== 10 && s?.taken == 1) {
//       const expected = Number(s.originalCost || 0) * Number(s.qty || 0);
//       const actual = parseFloat(s.jobcost_total_cost || 0);
//       const cost = expected > actual ? actual : expected;
//       console.log(`🧮 ghddddddddddddaf `, s);
//       console.log(`🧮 [ProdLabour] ID=${s.id} name=${s.name}`);
//       console.log('→ ghddddddddddddaf expected:', expected);
//       console.log('→ ghddddddddddddaf actual:', actual);
//       console.log('→ ghddddddddddddaf used cost:', cost);
//       return acc + cost;
//     }
//     return acc;
//   }, 0).toFixed(2);
// }, [services]);

const productionLabourTotal = useMemo(() => {
  // Filter regular production labour services
  const filtered = services?.filter(
    s => s?.recipe_id && s?.labour_cost_service_id !== 10 && includeJobCostServiceRowActual(s, isTM)
  );

  const expected = filtered.reduce((sum, s) => sum + Number(s.originalCost || 0) * Number(s.qty || 0), 0);
  // OLD: parseFloat(s.jobcost_total_cost) || parseFloat(s.total_cost) — formula total_cost counted as actual before cost-card entry.
  const actual   = filtered.reduce((sum, s) => sum + getJobCostServiceActualCost(s, isTM), 0);
  
  // Get manually added tasks' payouts total
  // For Time & Material (project_category === 12), use allPayouts filtered for manually added
  // For other projects, use the pre-filtered manuallyAddedPayouts state
  let manuallyAddedPayoutsTotal = 0;
  
  if (projectData?.project_category === 12) {
    // For Time & Material, get all manually added payouts from allPayouts
    const manuallyAddedPayoutsForTM = allPayouts?.filter(
      // Backup before Install Labor request-service classification:
      // p => (p.is_manually_added === 1 || p.is_manually_added === "1")
      p => (p.is_manually_added === 1 || p.is_manually_added === "1") && !isJobCostInstallLaborPayout(p, services)
    ) || [];
    manuallyAddedPayoutsTotal = manuallyAddedPayoutsForTM.reduce(
      (sum, p) => sum + parseFloat(p.amount || 0), 0
    ) || 0;
  } else {
    // For other projects, use the pre-filtered state
    // Backup before non-T&M Install Labor production split:
    // manuallyAddedPayoutsTotal = manuallyAddedPayouts?.reduce(
    //   (sum, p) => sum + parseFloat(p.amount || 0), 0
    // ) || 0;
    manuallyAddedPayoutsTotal = manuallyAddedPayouts?.filter(
      p => !isJobCostInstallLaborPayout(p, services)
    )?.reduce(
      (sum, p) => sum + parseFloat(p.amount || 0), 0
    ) || 0;
  }
  
  // For regular services: use actual cost to include OT premium, but capped at expected for standard bucket if NOT T&M
  const regularProductionLabour = (projectData?.project_category !== 12 && expected > 0) ? Math.min(actual, expected) : actual;
  const used = regularProductionLabour + manuallyAddedPayoutsTotal;

  console.log('🧮 [Production Labour]');
  console.log('→ Production Labour Expected Total:', expected);
  console.log('→ Production Labour Actual Total (from services):', actual);
  console.log('→ Regular Production Labour (min):', regularProductionLabour);
  console.log('→ Manually Added Tasks Payouts:', manuallyAddedPayoutsTotal);
  console.log('→ Production Labour Used Total:', used);
  console.log('→ Manually Added Payouts:', manuallyAddedPayouts);

  return used.toFixed(2);
}, [services, manuallyAddedPayouts, allPayouts, projectData?.project_category, isTM]);

/** Timelog labor on product/subtask rows (not Install Labor) — catalog cost, matches Labor tab. */
const productionTimelogLaborCost = useMemo(() => {
  const logs = staffTimelogsGet || [];
  const installLaborService = (services || []).find((s) => Number(s.labour_cost_service_id) === 10);
  const installServiceRate = resolveInstallLaborServiceUnitCost(installLaborService, isTM);
  let total = 0;
  logs.forEach((log) => {
    // Backup before Install Labor request-service classification:
    // const sId = Number(log?.service_id || log?.rs_id || log?.customer_order_product_id || 0);
    // const isDriver =
    //   log?.isDriver === 1 ||
    //   log?.isDriver === '1' ||
    //   log?.is_driver === 1 ||
    //   log?.is_driver === '1';
    // const taskName = (log?.task_name || '').toString().trim().toUpperCase();
    // const isManual = log?.is_manually_added === 1 || log?.is_manually_added === '1';
    // const isInstallLaborLog =
    //   sId === 10 ||
    //   (sId === 0 &&
    //     (taskName === 'INSTALL LABOR' ||
    //       taskName === 'LABOR INSTALL' ||
    //       isDriver ||
    //       !isManual));
    // if (isInstallLaborLog) return;
    if (isJobCostInstallLaborTimelog(log, services)) return;
    // OLD: getRecipeCostLaborRowComputed / getLaborTimelogCost used payout amount (~10.83)
    total += getJobCostTimelogLineCost(log, isTM, installServiceRate);
  });
  return Math.round((total + Number.EPSILON) * 100) / 100;
}, [staffTimelogsGet, services, isTM]);

const effectiveProductionLabor = useMemo(() => {
  const tabMemberLabor = Number(tabSummaryStats?.Labor?.laborCost ?? 0);
  // Backup before production labor tab-priority fix:
  // return Math.max(
  //   Number(productionLabourTotal || 0),
  //   productionTimelogLaborCost,
  //   tabMemberLabor
  // );
  return resolveEffectiveProductionLabor({
    recipeLabor: productionLabourTotal,
    timelogLabor: productionTimelogLaborCost,
    tabLabor: tabMemberLabor,
    isTM: isTM,
  });
}, [productionLabourTotal, productionTimelogLaborCost, tabSummaryStats?.Labor?.laborCost, isTM]);

const materialTotal = useMemo(() => {
  return selectedProjects?.reduce((acc, project) => {
    if (includeRecipeCostMaterialRow(project)) {
      return acc + (parseFloat(project?.jobcost_total) || 0);
    }
    return acc;
  }, 0).toFixed(2);
}, [selectedProjects]);

/** Job Editing / header total — same component sum as JobCost.js submit page. */
const jobEditingGrandTotalCost = useMemo(() => {
  const materialLine =
    parseFloat(materialPayOut || 0) +
    parseFloat(materialTotal || 0) +
    parseFloat(totalStockCost || 0);
  const excessLine = isTM ? 0 : Number(excessLaborCost1 || 0);
  return parseFloat(
    (
      materialLine +
      Number(additionalLaborCost1 || 0) +
      Number(effectiveProductionLabor || 0) +
      Number(installLaborCost || 0) +
      Number(otherTotals?.cost || 0) +
      excessLine
    ).toFixed(2)
  );
}, [
  materialPayOut,
  materialTotal,
  totalStockCost,
  additionalLaborCost1,
  effectiveProductionLabor,
  installLaborCost,
  otherTotals,
  excessLaborCost1,
  isTM
]);


const excessLabourOnly = useMemo(() => {
  let labourExpected = 0;
  let labourActual = 0;

  services.forEach(service => {
    if (+service.labour_cost_service_id === 10) {
      const expected = (parseFloat(service.originalCost) || 0) * (parseFloat(service.qty) || 0);
      // OLD: const actual = parseFloat(service.jobcost_total_cost) || 0;
      const actual = resolveInstallLaborServiceLineCost(service, isTM);
      labourExpected += expected;
      labourActual += actual;
    }
  });

  return labourActual > labourExpected
    ? +(labourActual - labourExpected).toFixed(2)
    : 0;
}, [services]);



console.log('excessQtyCostexcessQtyCost',excessLaborCost1 )
console.log('excessQtyCostexcessQtyCost-manual',excessManualPayoutAmount )
console.log('excessQtyCostexcessQtyCost-hourly',excessHourlyPayoutAmount )
console.log('excessLabourOnlyexcessLabourOnly',excessLabourOnly )

  // const excessLaborCost1 = useMemo(() => (
  //   Math.max(0, manualTotalPayOut + hourlyTotalPayOut - additionalLaborCost1)
  // ), [manualTotalPayOut, hourlyTotalPayOut, additionalLaborCost1]);
  const additionalAmount = ((excessManualPayoutAmount || 0) + (excessHourlyPayoutAmount || 0)) || 0
  
  // Get manually added payouts total
  // For Time & Material (project_category === 12), use allPayouts filtered for manually added
  // For other projects, use the pre-filtered manuallyAddedPayouts state
  let manuallyAddedPayoutsTotal = 0;
  let manuallyAddedPayoutsBillTotal = 0;
  
  if (projectData?.project_category === 12) {
    // For Time & Material, get all manually added payouts from allPayouts
    const manuallyAddedPayoutsForTM = allPayouts?.filter(
      // Backup before Install Labor request-service classification:
      // p => (p.is_manually_added === 1 || p.is_manually_added === "1")
      p => (p.is_manually_added === 1 || p.is_manually_added === "1") && !isJobCostInstallLaborPayout(p, services)
    ) || [];
    manuallyAddedPayoutsTotal = manuallyAddedPayoutsForTM.reduce(
      (sum, p) => sum + parseFloat(p.amount || 0), 0
    ) || 0;
    manuallyAddedPayoutsBillTotal = manuallyAddedPayoutsForTM.reduce(
      (sum, p) => {
        const isBillable = p.billable === 1 || p.billable === '1' || p.billable === true || p.is_billable === 1 || p.is_billable === '1' || p.is_billable === true;
        return sum + (isBillable ? parseFloat(p.bill_amount || 0) : 0);
      }, 0
    ) || 0;
  } else {
    // For other projects, use the pre-filtered state
    manuallyAddedPayoutsTotal = manuallyAddedPayouts?.reduce(
      (sum, p) => sum + parseFloat(p.amount || 0), 0
    ) || 0;
    manuallyAddedPayoutsBillTotal = manuallyAddedPayouts?.reduce(
      (sum, p) => {
        const isBillable = p.billable === 1 || p.billable === '1' || p.billable === true || p.is_billable === 1 || p.is_billable === '1' || p.is_billable === true;
        return sum + (isBillable ? parseFloat(p.bill_amount || 0) : 0);
      }, 0
    ) || 0;
  }
  
  // Ensure labor service cost reflects edited timelogs (same approach as servicesTotalBill)
  const laborCostTotal = Number(tabSummaryStats?.Labor?.cost || 0);
  let hasAddedLaborCost = false;
  const servicesTotalCostFixed = services?.reduce((accumulator, currentValue) => {
    let newTotal = 0;
    const isLaborService = Number(currentValue?.labour_cost_service_id) === 10;
    if (isLaborService) {
      if (!hasAddedLaborCost) {
        newTotal = Math.max(installLaborMetrics.cost, installLaborRowCostSum);
        hasAddedLaborCost = true;
      }
    } else if (includeRecipeCostServiceRow(currentValue)) {
      const logsForThisService = (staffTimelogsGet || []).filter(log => Number(log?.service_id || log?.rs_id || log?.customer_order_product_id || 0) === Number(currentValue.id));
      if (logsForThisService.length > 0) {
        newTotal = logsForThisService.reduce((sum, log) => {
          const computed = getRecipeCostLaborRowComputed(log);
          return sum + (Number(computed?.cost) || 0);
        }, 0);
      } else {
        newTotal = (parseFloat(currentValue?.jobcost_total_cost) || parseFloat(currentValue?.total_cost) || 0);
      }
    }
    return accumulator + newTotal;
  }, 0) || 0;

  const installLaborNum = Number(installLaborCost || 0);
  const bucketedLabor = installLaborNum + Number(effectiveProductionLabor || 0);
  // OLD: productionLabourTotal + installLaborCost missed workflow/subtask timelogs counted on the Labor tab
  const laborForGrandTotal = Math.max(Number(laborCostTotal || 0), bucketedLabor);
  // OLD (non-T&M double-count): additionalLaborCost1 + laborForGrandTotal — same $65 in service row and Labor tab (~$130).
  const nonTmCompareLaborStack =
    Number(additionalLaborCost1 || 0) +
    Number(effectiveProductionLabor || 0) +
    installLaborNum;
  const nonTmLaborGrandTotal = Number(laborCostTotal || 0) > 0
    ? Math.max(
        Number(laborCostTotal || 0),
        installLaborNum,
        Number(effectiveProductionLabor || 0)
      )
    : nonTmCompareLaborStack;
  const laborGrandTotalComponent = isTM
    ? Number(additionalLaborCost1 || 0) + laborForGrandTotal
    : nonTmLaborGrandTotal;
  // Backup before JobCost-aligned grand total fix ($1155 used Labor tab total $599 instead of component sum $1154):
  // grandTotalCost =
  //   Number(newMaterialPayOut || 0) +
  //   Number(selectedProjectsTotal || 0) +
  //   Number(totalStockCost || 0) +
  //   laborGrandTotalComponent +
  //   Number(otherTotals?.cost || 0) +
  //   Number(excessLaborCost1 || 0);
  grandTotalCost = jobEditingGrandTotalCost;
  // ✅ Removed totalStockCost and additionalAmount from Bill calculation as they are costs
  // let grandTotalBill = summaryTabData.billable;
  let grandTotalBill = projectData?.sales_order_total || 0;
  // if (projectData?.project_category !== 12) {
  //   grandTotalCost = summaryTabData.cost;
  // }
  
  grandTotalCost = parseFloat(grandTotalCost.toFixed(2));
  grandTotalBill = parseFloat(Number(grandTotalBill).toFixed(2));
  const totalCostWithBill = parseFloat((grandTotalCost).toFixed(2));
  const marginPercentage = calculateMargin(grandTotalBill, totalCostWithBill);
  const actualMarginPercent = calculateSummaryMarginPercent(grandTotalBill, totalCostWithBill);
  console.log('totalCostWithBill',totalCostWithBill);
  

  console.log('costtttttttttttt services',services)
  console.log('costtttttttttttt',servicesTotal,manualAndHourlyTotal,totalServiceCost,newAdditionalServices, additionalAmount)

  console.log('grandTotalCostservicesservices=12=newMaterialPayOut==',newMaterialPayOut);
  console.log('grandTotalCostservicesservices=12=selectedProjectsTotal==',selectedProjectsTotal);
  console.log('grandTotalCostservicesservices=12=servicesTotal==',servicesTotal);
  console.log('grandTotalCostservicesservices=12=additionalAmount==',additionalAmount);
  console.log('servicesservices=12=manualAndHourlyTotal==',manualAndHourlyTotal);
  console.log('servicesservices=12=manualTotalPayOut==',manualTotalPayOut);
  console.log('servicesservices=12=hourlyTotalPayOut==',hourlyTotalPayOut);
  console.log('servicesservices=12=additionalLaborCost1==',additionalLaborCost1);
  console.log('servicesservices=12=totalServiceCost==',totalServiceCost);
  console.log('servicesservices=12=newAdditionalServices==',newAdditionalServices);
  console.log('grandTotalCostservicesservices=12=excessLaborCost1==',excessLaborCost1);

  const isEditing = (section, idx) => rowEdit.section === section && rowEdit.index === idx;

  const handleEditRow = (section, idx, serviceId) => {
    if (section === 'services') {
      // Only show confirmation when starting to edit (not when clicking Done)
      if (!isEditing('services', idx)) {
        // Check if this is production labor by checking the consolidated services
        const consolidatedServices = services?.reduce((acc, curr) => {
          if (curr.labour_cost_service_id === 10) {
            if (!acc.some(item => item.labour_cost_service_id === 10)) {
              acc.push({ ...curr, __isRecipeGroup: false });
            }
          } else if (curr.recipe_id != null) {
            if (!acc.some(item => item.__isRecipeGroup)) {
              acc.push({ ...curr, __isRecipeGroup: true });
            }
          } else {
            acc.push(curr);
          }
          return acc;
        }, []);
        
        const isProductionLabor = consolidatedServices?.[idx]?.__isRecipeGroup === true;
        
        setEditServiceConfirmation({ 
          open: true, 
          serviceIndex: idx,
          isProductionLabor: isProductionLabor 
        });
      } else {
        // If already editing, delete staff task timelogs when Done is clicked
        if (serviceId) {
          deleteStaffTaskTimelogsByService(serviceId, excludeManualFromProductionLabor);
        }
        // Stop editing and reset the exclude flag
        setExcludeManualFromProductionLabor(false);
        setRowEdit({ section: null, index: null });
      }
    } else if (section === 'additional') {
      if (isEditing('additional', idx)) {
        (async () => {
          const row = additionalMaterials[idx];
          const jobCostId = row?.job_cost_id ?? row?.product_id;
          if (!jobCostId || !id || !user?.user_id) {
            enqueueSnackbar('Missing job cost or project', { variant: 'error' });
            return;
          }
          try {
            const res = await axios.post(
              `${REST_API_END_POINT}project/save-job-cost-tm-additional-material`,
              {
                jobCostId,
                projectId: id,
                userId: user.user_id,
                materialLabel: row.productNotes || row.name || '',
                quantity: Number(row.quantity) || 0,
                unitCost: Number(row.unit_cost) || 0,
                markupPercent: Number(row.markup_percent ?? row.markup ?? 0) || 0,
                billUnitPrice: Number(row.bill_unit_price ?? row.bill_rate ?? 0) || 0,
                billable: row.billable !== 0 && row.billable !== false && row.billable !== '0'
              },
              { headers: { 'Content-Type': 'application/json' } }
            );
            if (res?.data?.status === 1) {
              enqueueSnackbar(res.data.message || 'Saved', { variant: 'success' });
              setRowEdit({ section: null, index: null });
              fetchData();
            } else {
              enqueueSnackbar(res?.data?.message || 'Save failed', { variant: 'error' });
            }
          } catch (e) {
            enqueueSnackbar('Save failed', { variant: 'error' });
          }
        })();
      } else {
        setRowEdit({ section: 'additional', index: idx });
      }
    } else {
      // For other sections, edit directly
      setRowEdit(prev =>
        prev.section === section && prev.index === idx
          ? { section: null, index: null }
          : { section, index: idx }  
      );
    }
  };

  const handleEditServiceConfirm = () => {
    const { serviceIndex, isProductionLabor } = editServiceConfirmation;
    
    // If it's production labor, exclude manual hours and payouts from calculation
    if (isProductionLabor) {
      setExcludeManualFromProductionLabor(true);
    }
    
    setRowEdit({ section: 'services', index: serviceIndex });
    setEditServiceConfirmation({ open: false, serviceIndex: null, isProductionLabor: false });
  };

  const handleEditServiceCancel = () => {
    setEditServiceConfirmation({ open: false, serviceIndex: null, isProductionLabor: false });
  };

  const handleServiceAdd = async (service) => {
    try {
      // Get the expected hours from the state
      const expectedHours = serviceExpectedHours[service.id] || 0;
      const isTMProject = projectData?.project_category === 12;
      const catalogUnitCost = getLabourCostServiceCatalogRate(service, isTMProject);
      // OLD: cost: service.cost || 0, total_cost: service.total_cost (always base in UI; backend always used total_cost as unit_cost)
      const resolvedRequestId =
        Number(projectData?.request_id) > 0
          ? projectData.request_id
          : Number(projectDetails?.request_id) > 0
            ? projectDetails.request_id
            : Number(req_id) > 0
              ? req_id
              : null;

      if (!resolvedRequestId) {
        enqueueSnackbar('Missing request id — cannot add service', { variant: 'error' });
        return;
      }

      const serviceData = {
        name: service.name,
        id: service.id,
        type_id: service.type_id || service.service_type_id,
        cost: catalogUnitCost,
        workflow_id: service.workflow_id || service.workflow_id,
        expected_hours: expectedHours,
        status: 1,
        is_addition_service: 1,
        total_cost: isTMProject ? (service.total_cost || catalogUnitCost) : (service.cost || catalogUnitCost),
        makeAsTask:service?.makeAsTask || 0,
        makeInstallCard:service?.makeInstallCard || 0,
      };

      const response = await axios.post(`${REST_API_END_POINT}request/add-request-service`, {
        serviceData,
        userId: user?.user_id,
        requestId: resolvedRequestId,
        projectId: id,
        orderId: resolvedRequestId,
        projectCategory: projectData?.project_category
      });

      if (response.data.status === 1) {
        // setAllServices(response.data.services || []);
        // Prefer refetch against the job request so Other tab matches the estimate/SO Job Cost load.
        await fetchData();
        
        enqueueSnackbar('Service added successfully', { variant: 'success' });
      } else {
        enqueueSnackbar(response.data.message || 'Failed to add service', { variant: 'error' });
      }
    } catch (error) {
      console.error('Error adding service:', error);
      enqueueSnackbar('Error adding service', { variant: 'error' });
    }
  };

  // Pagination handlers for services modal
  const handleServicesChangePage = (event, newPage) => {
    setServicesPage(newPage);
  };

  const handleServicesChangeRowsPerPage = (event) => {
    setServicesRowsPerPage(parseInt(event.target.value, 10));
    setServicesPage(0);
  };

  const handleDeleteRow = (section, idx, selectedProjects, serviceId, is_from_job = 0, is_recipe_group = false) => {
    let itemToDelete;
    let message;
    let deleteEndpoint;
    let deleteData;

    if (section === 'services') {
      // Handle service deletion
      if (!serviceId) {
        enqueueSnackbar('Service ID not found', { variant: 'error' });
        return;
      }
      message = `Are you sure you want to delete this service?`;
      const from_job = projectData.job_category_name === 'Time & Material' ? 1 : is_from_job
      deleteEndpoint = `${REST_API_END_POINT}request/delete-request-service`;
      const resolvedRequestId =
        Number(projectData?.request_id) > 0
          ? projectData.request_id
          : Number(projectDetails?.request_id) > 0
            ? projectDetails.request_id
            : Number(req_id) > 0
              ? req_id
              : null;
      deleteData = { serviceId, userId: user?.user_id, from_job, is_recipe_group, request_id: resolvedRequestId, projectId: id, orderId: resolvedRequestId };
    } else if (section === 'additional') {
      itemToDelete = additionalMaterials?.[idx];
      if (!itemToDelete?.job_cost_id) {
        enqueueSnackbar('Job cost ID not found', { variant: 'error' });
        return;
      }
      message = `Remove this additional material from job cost?`;
      deleteEndpoint = `${REST_API_END_POINT}project/job-cost-delete-item`;
      deleteData = { jobCostId: itemToDelete.job_cost_id, user_id: user?.user_id };
    } else {
      // Handle material/stock deletion
      itemToDelete = selectedProjects?.[idx];
      if (!itemToDelete?.job_cost_id) {
        enqueueSnackbar('Job cost ID not found', { variant: 'error' });
        return;
      }
      message = `Are you sure you want to delete this job cost item?`;
      deleteEndpoint = `${REST_API_END_POINT}project/job-cost-delete-item`;
      deleteData = { jobCostId: itemToDelete.job_cost_id, user_id: user?.user_id };
    }

    setConfirmationPopup({
      open: true,
      handleClick: async () => {
        try {
          const response = await axios.post(deleteEndpoint, deleteData);

          if (response.data.status === 1) {
            if (section === 'materials') {
              setSelectedProjects(prev => prev.filter((_, i) => i !== idx));
            } else if (section === 'additional') {
              fetchData();
            } else if (section === 'stock') {
              setStockProducts(prev => prev.filter((_, i) => i !== idx));
            } else if (section === 'services') {
              // setAllServices(prev => prev.filter((item, i) => item.id !== serviceId));
              // // Trigger re-render to recalculate totals
              // setAllServices(prev => [...prev]);
              setAllServices(response.data.services || []);
            }

            // Show success message
            enqueueSnackbar(response.data.message || 'Item deleted successfully', { variant: 'success' });
            if (section !== 'services') {
              fetchJobCostLogs();
            }
          } else {
            enqueueSnackbar(response.data.message || 'Failed to delete item', { variant: 'error' });
          }
        } catch (error) {
          console.error('Error deleting item:', error);
          enqueueSnackbar('Error deleting item', { variant: 'error' });
        } finally {
          setConfirmationPopup({ ...confirmationPopup, open: false });
        }
      },
      handleClose: () => {
        setConfirmationPopup({ ...confirmationPopup, open: false });
      },
      message
    });
  };

  const deleteStaffTaskTimelogsByService = async (serviceId, isProductionLabor = false) => {
    try {
      const response = await axios.post(`${REST_API_END_POINT}project/delete-staff-task-timelogs-by-service`, {
        serviceId,
        projectId: id,
        userId: user?.user_id,
        isProductionLabor: isProductionLabor
      });
      

      if (response.data.status === 1) {
        console.log(`Deleted ${response.data.deletedCount} staff task timelogs for service ${serviceId}`);
        
        // If production labor, clear manually added data without full refresh
        if (isProductionLabor) {
          // Remove manually added timelogs where service_id and installation_id are NULL
          setStaffTimelogsGet(prev => 
            prev.filter(log => {
              const isManuallyAdded = log.is_manually_added === 1 || log.is_manually_added === "1";
              const hasNoServiceId = log.service_id === null || log.service_id === undefined || log.service_id === 0;
              const hasNoInstallationId = log.installation_id === null || log.installation_id === undefined || log.installation_id === 0;
              
              // Keep if NOT (manually added AND no service_id AND no installation_id)
              return !(isManuallyAdded && hasNoServiceId && hasNoInstallationId);
            })
          );
          
          // Clear manually added payouts (where service_id is NULL)
          setManuallyAddedPayouts([]);
          
          // Also update allPayouts to remove manually added payouts with service_id NULL
          setAllPayouts(prev => 
            prev.filter(p => {
              const isManuallyAdded = p.is_manually_added === 1 || p.is_manually_added === "1";
              const hasNoServiceId = p.service_id === null || p.service_id === undefined || p.service_id === 0;
              
              // Keep if NOT (manually added AND no service_id)
              return !(isManuallyAdded && hasNoServiceId);
            })
          );
        }
      } else {
        console.error('Failed to delete staff task timelogs:', response.data.message);
      }
    } catch (error) {
      console.error('Error deleting staff task timelogs:', error);
    }
  };

  return (
    (loading || !projectData) ?
      <Stack alignItems='center' justifyContent='center' mt={10}>
        <LoadingScreen />
      </Stack> :
      <Page title={`Job Calculator |${COMPANY_NAME}`} mt={3} >
        <Container  >
          {popupOn?<Button
            variant="outlined"
            type="button"
            // component={RouterLink}
            // to={PATH_DASHBOARD.project.viewproject + id}
            // onClick={()=>{
            //   navigate(`${PATH_DASHBOARD.project.viewproject}/${id}`,
            //     {state: { currentTab : currentTab }});
            // }}
            onClick={handleBackToAlljobs}
            sx={{ alignItems: 'flex-end', mb: 4 }}
            startIcon={
              <Stack>
                <KeyboardBackspaceOutlined />
              </Stack>
            }
          >
            Back to Job Details
          </Button>:
          (isEstimateJob ? 
          <Button
            variant="outlined"
            type="button"
            onClick={()=>{
              navigate(`${PATH_DASHBOARD.quotation.viewEstimateProject}/${id}`,
                {state: { currentTab : currentTab }});
            }}
            // onClick={handleBackToAlljobs}
            sx={{ alignItems: 'flex-end', mb: 4 }}
            startIcon={
              <Stack>
                <KeyboardBackspaceOutlined />
              </Stack>
            }
          >
            Back to Job Details
          </Button> :
          <Button
            variant="outlined"
            type="button"
            // component={RouterLink}
            // to={PATH_DASHBOARD.project.viewproject + id}
            onClick={()=>{
              navigate(`${PATH_DASHBOARD.project.viewproject}/${id}`,
                {state: { currentTab : currentTab }});
            }}
            // onClick={handleBackToAlljobs}
            sx={{ alignItems: 'flex-end', mb: 4 }}
            startIcon={
              <Stack>
                <KeyboardBackspaceOutlined />
              </Stack>
            }
          >
            Back to Job Details
          </Button>)}

          <Button
            variant="outlined"
            type="button"
            onClick={()=>{ setJobCostPreview(true); }}
            sx={{ alignItems: 'flex-end', mb: 4, ml:4 }}
          >
            Expected V/S Actual
          </Button>

          {!(projectData?.finalize_invoice === 1 || projectData?.isReview === 1) && projectData?.project_category === 12 && (
            <LoadingButton
              variant="contained"
              color="warning"
              loading={updatingTmDraft}
              onClick={handleOpenTmDraftConfirm}
              sx={{ alignItems: 'flex-end', mb: 4, ml: 4, borderRadius: 1.5 }}
            >
              {Number(projectData?.tm_review_draft || 0) === 1 ? 'Release From Draft' : 'Move to Draft'}
            </LoadingButton>
          )}
          <CompareJobCostChartMain
            logs={logs}
            projectData={projectData}
            setLogs={setLogs}
            requestId={projectData?.request_id}
            fetchJobCostLogs={fetchJobCostLogs}
            recalculateTrigger={recalculateTrigger}
            staffTimelogsProp={staffTimelogsGet}
            laborTabLaborCost={tabSummaryStats?.Labor?.laborCost}
            tmLabel={projectData?.job_category_name === 'Time & Material' ? 'T&M' : undefined}
            id={id}
          />
          <Paper variant='outlined' sx={{ p: 3, mb: 3 }}>
            <Stack direction={'row'} spacing={2} display={'flex'} alignItems={'center'} justifyContent={'space-between'}>
              <Stack direction="row" spacing={2} alignItems="center" width={'20%'}>
                <Stack direction="column" spacing={1}>
                  <Stack direction="row" spacing={1} alignItems="center">
                    <Typography variant="h4" sx={{ color: 'text.primary', fontWeight: 800 }}>Job Editing</Typography>
                    {projectData?.job_category_name === 'Time & Material' ? <Label variant="filled" color="info">T&M</Label> : ''}
                  </Stack>
                  {/* <Box width={'50%'}> */}
                  <Stack spacing={2} mb={1} sx={{ mr: '7% !important' }} width={'100%'}>
                    {/* {projectData?.job_category_name === 'Time & Material' ? 
                  <Typography variant="subtitle2">Expected Budget (Material + Service) : {jobCost}</Typography>
                :
                  <Typography variant="subtitle2">Expected Budget (Product Formula Cost + Labor Cost) : {jobCost}</Typography>
                } */}
                    <Box sx={{ display: 'flex', alignItems: 'center', }}>
                      <Box sx={{ width: '100%', mr: 1 }}>
                        <BorderLinearProgress variant="determinate" value={progressValue} />
                      </Box>
                      <Box sx={{ minWidth: 35 }}>
                        <Typography variant="body2" color="text.secondary">{Math.round(progressValue) || 0}%</Typography>
                      </Box>
                    </Box>
                  </Stack>
                  {/* </Box> */}
                  <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <Grid container spacing={3}>
                      <Grid item md={12} xs={12}>
                        {/* <Button
                variant="outlined"
                type="button"
                onClick={()=>handleClick()}
                // component={RouterLink}
                // to={linkState}
                sx={{ mb: 4 }}
              > */}
                        {/* {projectData?.job_category_name=='Time & Material' ? 'Go To Materials' : 'Add Material'} */}
                        {/* {projectData?.job_category_name=='Time & Material' ? 'Add Material' : 'Add Material'}
              </Button> */}
                      </Grid>
                      <Grid item md={12} xs={12}>
                        <Stack direction="row" justifyContent="space-between" alignItems="center">
                          <div style={{ textAlign: 'left' }}>
                            {/* {
                       projectData?.job_category_name=='Time & Material' ?
                       ''
                       : */}

                            <Typography variant="subtitle2">

                              Actual Labor Cost: {Number(jobEditingHeaderLaborPayout.actualLaborCost || 0).toFixed(2)}
                              {/* Actual Labor Cost: {projectData?.job_category_name=='Time & Material' ? '0.00' :
                      (services?.reduce((accumulator, currentValue) => {
                        // return accumulator + (currentValue?.originalCost * currentValue?.qty);
                        return accumulator + (currentValue?.jobcost_unit_cost * currentValue?.jobcost_quantity);
                      }, 0) || 0).toFixed(2)} */}
                            </Typography>
                            {/* } */}
                          </div>
                          {
                            updates?.length > 0 ? ''
                              :
                              <div style={{ textAlign: 'right' }}>
                                  {!isTM && (
                                    <Typography variant="subtitle2">
                                      Manual Staff Pay Out: {Number(jobEditingHeaderLaborPayout.manualStaffPayout || 0).toFixed(2)}
                                    </Typography>
                                  )}
                                  {!isTM && (
                                    <Typography variant="subtitle2">
                                      Hourly Staff Pay Out: {Number(jobEditingHeaderLaborPayout.hourlyStaffPayout || 0).toFixed(2)}
                                    </Typography>
                                  )}
                                  {!isTM && (
                                    <Typography variant="subtitle2" sx={{ color: theme.palette.mode === 'light' ? '#ffd000' : 'yellow' }}>
                                      Total Staff Pay Out: {Number(jobEditingHeaderLaborPayout.totalStaffPayout || 0).toFixed(2)}
                                    </Typography>
                                  )}
                              </div>
                          }
                        </Stack>
                      </Grid>
                    </Grid>
                  </div>
                </Stack>
              </Stack>
              <Stack direction="row" width={'80%'} spacing={2} sx={{ flexWrap: 'wrap', rowGap: 1.5, mb: 3 }} justifyContent={{ xs: 'flex-start', md: 'flex-end' }} alignItems="center">
                {[
                  {
                    key: 'Material Cost',
                    value: parseFloat((parseFloat(materialPayOut || 0) + parseFloat(materialTotal || 0) + parseFloat(totalStockCost || 0)).toFixed(2)),
                    color: 'text.primary',
                    tooltip: `Material Cost = Material Payout (${parseFloat(materialPayOut || 0).toFixed(2)}) + Material Total (${parseFloat(materialTotal || 0).toFixed(2)}) + Stock Cost (${parseFloat(totalStockCost || 0).toFixed(2)})`
                  },
                  {
                    key: 'Additional Services',
                    value: parseFloat(parseFloat(additionalLaborCost1 || 0).toFixed(2)),
                    color: 'text.primary',
                    tooltip: `Additional Services = ${parseFloat(additionalLaborCost1 || 0).toFixed(2)}`
                  },
                  {
                    key: 'Production Labor',
                    value: parseFloat(parseFloat(effectiveProductionLabor || 0).toFixed(2)),
                    color: 'text.primary',
                    tooltip: `Production Labor = ${parseFloat(effectiveProductionLabor || 0).toFixed(2)}`
                  },
                  {
                    key: 'Install Labor',
                    value: parseFloat(parseFloat(installLaborCost || 0).toFixed(2)),
                    color: 'text.primary',
                    tooltip: `Install Labor = ${parseFloat(installLaborCost || 0).toFixed(2)}`
                  },
                  {
                    key: 'Equipment Cost',
                    value: parseFloat(parseFloat(otherTotals?.cost || 0).toFixed(2)),
                    color: 'text.primary',
                    tooltip: `Equipment Cost = ${parseFloat(otherTotals?.cost || 0).toFixed(2)}`
                  },
                  projectData?.project_category !== 12 && {
                    key: 'Excess Labor Cost',
                    value: parseFloat(parseFloat(excessLaborCost1 || 0).toFixed(2)),
                    color: 'text.primary',
                    tooltip: `Excess Labor Cost = ${parseFloat(excessLaborCost1 || 0).toFixed(2)}`
                  },
                  !isTM && {
                    // key: 'Total Bill',
                    // value: parseFloat(parseFloat(grandTotalBill || 0).toFixed(2)),
                    // tooltip: `Total Bill = Materials (${(newMaterialPayOutBill + selectedProjectsTotalBill).toFixed(2)}) + Services (${servicesTotalBill.toFixed(2)}) + PayOuts (${manuallyAddedPayoutsBillTotal.toFixed(2)}) + Stock (${totalStockCost.toFixed(2)}) + Other (${Number(otherTotals?.bill || 0).toFixed(2)})`
                    key: 'Bill Amount',
                    value: parseFloat(parseFloat(grandTotalBill || 0).toFixed(2)),
                    color: 'primary.main',
                    tooltip: `Bill Amount = Sales Order Price`
                   },
                   {
                    key: 'Total Cost',
                    value: parseFloat(parseFloat(totalCostWithBill || 0).toFixed(2)),
                    color: '#fc8c03',
                    tooltip: `Total Cost = Grand Cost (${parseFloat(grandTotalCost || 0).toFixed(2)})`
                  },
                  !isTM && {
                    key: 'Margin',
                    // value: `${marginPercentage.toFixed(2)}%`,
                    // isPercent: true,
                    // tooltip: `Margin % = ((Total Bill ${parseFloat(grandTotalBill || 0).toFixed(2)} - Total Cost ${parseFloat(totalCostWithBill || 0).toFixed(2)}) / Total Cost ${parseFloat(totalCostWithBill || 0).toFixed(2)}) x 100`
                    value: parseFloat(marginPercentage || 0).toFixed(2),
                    percent: actualMarginPercent.toFixed(2),
                    color: marginPercentage < 0 ? 'error.main' : 'success.main',
                    tooltip: `Margin = Bill Amount - Total Cost | Margin % = ((Bill Amount - Total Cost) / Bill Amount) x 100`
                  }
                ].filter(Boolean).map((card) => (
                  <Tooltip key={card.key} title={card.tooltip || ''} arrow>
                    <SummaryCard
                      onMouseEnter={() => setHoveredCard(card.key)}
                      onMouseLeave={() => setHoveredCard(null)}
                      sx={{
                        ...(card.key === 'Bill Amount'
                          ? {
                            background: (loading || (hoveredCard !== null && hoveredCard !== 'Bill Amount'))
                              ? 'background.paper'
                              : `linear-gradient(135deg, ${theme.palette.primary.light} 0%, ${theme.palette.primary.main} 100%) !important`,
                            border: (loading || (hoveredCard !== null && hoveredCard !== 'Bill Amount'))
                              ? `1px solid ${theme.palette.divider}`
                              : 'none',
                            // boxShadow: (loading || (hoveredCard !== null && hoveredCard !== 'Bill Amount'))
                            //   ? 'none'
                            //   : `0 10px 20px -10px ${theme.palette.primary.main}`,
                            '& .MuiTypography-root': {
                              color: (loading || (hoveredCard !== null && hoveredCard !== 'Bill Amount'))
                                ? 'inherit'
                                : 'white !important'
                            },
                            '&:hover': {
                              transform: 'translateY(-6px)',
                              background: `linear-gradient(135deg, ${theme.palette.primary.light} 0%, ${theme.palette.primary.main} 100%) !important`,
                              // boxShadow: `0 20px 40px -12px ${theme.palette.primary.main}80`
                            }
                          }
                          : hoveredCard === card.key
                            ? {
                              background: `linear-gradient(135deg, ${theme.palette.primary.light} 0%, ${theme.palette.primary.main} 100%) !important`,
                              // boxShadow: `0 10px 20px -10px ${theme.palette.primary.main}`,
                              '& .MuiTypography-root': { color: 'white !important' }
                            }
                            : {})
                      }}
                    >
                      {loading ? (
                        <>
                          <Skeleton width="40%" height={12} sx={{ mb: 1.5, mx: 'auto' }} />
                          <Skeleton width="70%" height={28} sx={{ mx: 'auto' }} />
                        </>
                      ) : (
                        <>
                          <Typography variant="overline" sx={{ color: 'text.secondary', mb: 0.5, fontWeight: 700, fontSize: '0.75rem', textTransform: 'none' }}>
                            {card.key}
                          </Typography>
                          <Typography variant="h5" sx={{ color: card.color, fontWeight: 800 }}>
                            {card.isPercent ? card.value : `$${Number(card.value || 0).toFixed(2)}`}
                            {card.key === 'Margin' && card.percent && ` (${card.percent}%)`}
                          </Typography>
                        </>
                      )}
                    </SummaryCard>
                  </Tooltip>
                ))}
              </Stack>
            </Stack>
            
            <Grid item md={12} xs={12} direction='column' sx={{ display: 'flex', mt: 2 }}>
              {/* {projectData.jobcost === 1 ? 
              <Button variant='outlined' sx={{ color: 'error.main', cursor:'none', borderColor: 'error.main' }}>
                {projectData.notifyJobcost}
              </Button> : ""} */}
              {Number(projectData.jobcost) === 1 && String(projectData.notifyJobcost || '').trim() ? (
                <Button
                  variant='outlined'
                  sx={{
                    color: 'error.main',
                    borderColor: 'error.main',
                    pointerEvents: 'none',
                    userSelect: 'text',
                  }}
                >
                  {projectData.notifyJobcost}
                </Button>
              ) : ""}
              {/* <Box sx={{ position: 'relative', display: 'inline-block', margin: '20px' }}>
                {projectData.jobcost === 1 ? (
                    <Typography
                    variant="outlined"
                    sx={{
                      position: 'absolute',
                      top: '-20px',
                      left: '50%',
                      transform: 'translateX(-50%)',
                      // backgroundColor: 'white',
                      padding: '5px 15px',
                      color: 'error.main',
                      fontSize: '26px',
                      border: '1px solid',
                      borderColor: 'error.main',
                      borderRadius: '4px',
                      whiteSpace: 'nowrap',
                      wordWrap:'break-word'
                    }}
                    >
                      {projectData.notifyJobcost}
                    </Typography>
                ) : ''}
              </Box> */}
            </Grid>
            {Number(projectData.jobcost) === 1 && String(projectData.notifyJobcost || '').trim() && !isMirrored && <Box sx={{ display: 'flex', justifyContent: 'space-around' }}>
              
              <Button
                variant="outlined"
                type="submit"
                onClick={()=>navigate(PATH_DASHBOARD.products.material)}
                sx={{ mb: 4, mt: 3,ml:2 }}
                startIcon={ <Logout /> }
              >
               Go to Material Inventory
              </Button>
              <Button
              variant="outlined"
              type="submit"
              onClick={handleJobCost}
              sx={{ mb: 4, mt: 3, }}
            >
              Update JobCost
            </Button>
            </Box>}
  
            <Grid container spacing={3}>
              <Grid item md={5} xs={12} sx={{ display: isHidden ? 'none' : 'block' }}>
  
                <Tabs
                  value={selectedCategory}
                  sx={{
                    backgroundColor: theme.palette.grey[700],
                    borderRadius: 2,
                    mb: 1,
                  }}
                  onChange={(e, newValue) => handleCategoryChange(newValue)}
                  variant="scrollable"
                  aria-label="scrollable auto tabs example"
                  allowScrollButtonsMobile
                  autoFocus
                  scrollButtons="auto"
                >
                  {category.map((category) => (
                    <Tab key={category.id} sx={{ ml: 3,}}
                      disableRipple
                      autoCapitalize={category.name}
                      label={category.name}
                      value={category.id} />
                  ))}
                </Tabs>
                {/* {projectData?.job_category_name === 'Time & Material' ? 
                  <Card
                    sx={{
                      p: 1,
                      height: '560px',
                      overflowY: 'auto',
                      // backgroundColor: 'transparent',
                      // background: 'transparent',
                      '&::-webkit-scrollbar': {
                        width: '0.4em',
                      },
                      '&::-webkit-scrollbar-track': {
                        boxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
                        webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
                      },
                      '&::-webkit-scrollbar-thumb': {
                        backgroundColor: 'rgba(0,0,0,.1)',
                        borderRadius: '4px',
                      },
                    }}
                  >
                    <Grid container spacing={1}>
                      <Scrollbar>
                        <TableContainer sx={{ minWidth: 340 }}>
                          <Table>
                            <TableHead
                              sx={{
                                borderBottom: (theme) => `solid 1px ${theme.palette.divider}`,
                                // '& th': { backgroundColor: 'transparent' }
                              }}
                            >
                              <TableRow>
                                <TableCell align="center">
                                  <Typography variant="body1">Staff Name</Typography>
                                </TableCell>
                                <TableCell align="center">
                                  <Typography variant="body1">Task</Typography>
                                </TableCell>
                                <TableCell align="center">
                                  <Typography variant="body1">Clocked-In Hours</Typography>
                                </TableCell>
                                <TableCell align="center">
                                  <Typography variant="body1">Hourly Rate</Typography>
                                </TableCell>
                                <TableCell align="center">
                                  <Typography variant="body1">Total</Typography>
                                </TableCell>
                              </TableRow>
                            </TableHead>
  
                            <TableBody>
                              {staffTimelogs?.map((log, logIndex) => (
                                <TableRow
                                  key={`log_${logIndex}`}
                                  sx={{
                                    borderBottom: (theme) => `solid 1px ${theme.palette.divider}`,
                                  }}
                                >
                                  <TableCell align="center">
                                    <Typography variant="subtitle2">{log.staff_name}</Typography>
                                  </TableCell>
                                  <TableCell align="center">
                                    <Typography variant="subtitle2">{log.isDriver==1 ? (log.task_name ||'Labor Install') : log.task_name}</Typography>
                                  </TableCell>
                                  <TableCell align="center">
                                    <Typography variant="subtitle2">{parseFloat(log.hours || 0)?.toFixed(4)}</Typography>
                                  </TableCell>
                                  <TableCell align="center">
                                    <Typography variant="subtitle2">{Number.isFinite(Number(log?.hourly_rate)) ? Number(log.hourly_rate) : 0}</Typography>
                                  </TableCell>
                                  <TableCell align="center">
                                    <Typography variant="subtitle2">{parseFloat(log.total_cost || 0)?.toFixed(2)}</Typography>
                                  </TableCell>
                                </TableRow>
                              ))
                              }
  
                            </TableBody>
                          </Table>
                        </TableContainer>
  
                      </Scrollbar>
                    </Grid>
                  </Card>
                :  */}
                  <>
                  {
                    selectedCategory==1?
                    <>
                  
                  <SearchStyle
                    sx={{ backgroundColor: 'var(--signwise-app-chrome-toolbar)', height: 40, mt: 1 }}
                    value={filterName}
                    onChange={handleFilterByName}
                    placeholder="Search Material"
                    startAdornment={
                      <InputAdornment position="start">
                        <Box component={Icon} icon={searchFill} sx={{ color: 'text.disabled' }} />
                      </InputAdornment>
                    }
                  />
                  <Card
                    variant='outlined'
                    sx={{
                      p: 3,
                      mt: 2,
                      height: '360px',
                      overflowY: 'auto',
                      backgroundColor: 'transparent',
                      background: 'transparent',
                      '&::-webkit-scrollbar': {
                        width: '0.4em',
                      },
                      '&::-webkit-scrollbar-track': {
                        boxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
                        webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
                      },
                      '&::-webkit-scrollbar-thumb': {
                        backgroundColor: 'rgba(0,0,0,.1)',
                        borderRadius: '4px',
                      },
                    }}
                  >
                    <Grid container spacing={1}>
                      {recipe.map((recipeItem, index) => (
                        <Grid key={index} item xs={6} sm={4} md={4}> {/* Adjusted md to 4 */}
                          <Card
                            variant='outlined'
                            onMouseEnter={() => setIsHover(true)}
                            onMouseLeave={() => setIsHover(false)}
                            sx={{
                              minWidth: 100,
                              display: 'flex',
                              flexDirection: 'column',
                              alignItems: 'center',
                              textAlign: 'center',
                              transition: 'transform 0.2s',
                              '&:hover': {
                                transform: 'scale(1.02)',
                              },
                            }}
                            // onClick={() => { setMaterialsPreview(true); setIsRecipe(true); setSelectedMaterial(recipeItem) }}
                          >
                            {/* Display truncated recipe name */}
                            <div style={{ fontWeight: 'bold', marginBottom: '10px', marginTop: '10px' }}>
                              R: {recipeItem.name.split(' ').slice(0, 2).join(' ')}
                            </div>
                            {/* Display counts */}
                            <div>
                              Materials: {recipeItem.ingredients.length}
                            </div>
                            <div>
                              Services: {recipeItem.services.length}
                            </div>
                            {/* Highlighted productName */}
                            <div style={{ fontWeight: 'bold', color: theme.palette.mode === 'light' ? "#ffd000" : "yellow", marginTop: '10px', marginBottom: '10px' }}>
                              C: { recipeItem.productNotes || recipeItem.productName}
                            </div>
                          </Card>
                        </Grid>
                      ))}
                    </Grid>
                  </Card>
  
                  </>
                  :
                  <Card
                  sx={{
                    p: 1,
                    mt: 1,
                    boxShadow:'none',
                    height: '560px',
                    overflowY: 'auto',
                    // backgroundColor: 'transparent',
                    // background: 'transparent',
                    '&::-webkit-scrollbar': {
                      width: '0.4em',
                    },
                    '&::-webkit-scrollbar-track': {
                      boxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
                      webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
                    },
                    '&::-webkit-scrollbar-thumb': {
                      backgroundColor: 'rgba(0,0,0,.1)',
                      borderRadius: '4px',
                    },
                  }}
                >
                  <Grid container spacing={1}>
                    <Scrollbar>
                      <TableContainer sx={{ minWidth: 720 }}>
                        <Table size="small">
                          <TableHead
                            sx={{
                              // borderBottom: (theme) => `solid 1px ${theme.palette.divider}`,
                              // '& th': { backgroundColor: 'transparent' }
                            }}
                          >
                            <TableRow>
                              <TableCell align="center">
                                <Typography variant="body1">Staff Name</Typography>
                              </TableCell>
                              <TableCell align="center">
                                <Typography variant="body1">Task</Typography>
                              </TableCell>
                              <TableCell align="center">
                                <Typography variant="body1">Hours</Typography>
                              </TableCell>
                              {/* <TableCell align="center">
                                <Typography variant="body1">OT</Typography>
                              </TableCell> */}
                              <TableCell align="center">
                                <Typography variant="body1">Labor Rate</Typography>
                              </TableCell>
                              {/* <TableCell align="center">
                                <Typography variant="body1">Bill Rate</Typography>
                              </TableCell> */}
                              <TableCell align="center">
                                <Typography variant="body1">Cost</Typography>
                              </TableCell>
                              {/* <TableCell align="center">
                                <Typography variant="body1">Bill</Typography>
                              </TableCell> */}
                            </TableRow>
                          </TableHead>
  
                          <TableBody>
                            {updates?.length > 0  ? '' :
                            staffTimelogs?.map((log, logIndex) => {
                              const sId = Number(log?.service_id || log?.rs_id || log?.customer_order_product_id || 0);
                              const logService = (services || []).find(s => Number(s.id) === sId || (sId === 0 && Number(s.labour_cost_service_id) === 10));
                              // OLD: const serviceRate = Number(logService?.jobcost_unit_cost || logService?.originalCost || logService?.unit_cost || 0);
                              const serviceRate = resolveInstallLaborServiceUnitCost(logService, isTM);
                              
                              const row = getRecipeCostLaborRowComputed(log, serviceRate);
                              const displayRegularHours = roundToTwo(row.regularH);
                              const displayOtHours = roundToTwo(row.otH);
                              const displayCostRate = roundToTwo(row.costRate);
                              const displayCost = roundToTwo(
                                (displayRegularHours * displayCostRate) +
                                (displayOtHours * displayCostRate * 1.5)
                              );

                              return (
                              <TableRow
                                key={`log_${logIndex}`}
                                sx={{
                                  borderBottom: (theme) => `solid 1px ${theme.palette.divider}`,
                                }}
                              >
                                <TableCell align="center">
                                  <Typography variant="subtitle2">{log.staff_name}</Typography>
                                </TableCell>
                                <TableCell align="center">
                                  <Typography variant="subtitle2">{log.isDriver==1 ? (log?.task_name ||'Labor Install') : (log?.task_name === 'null' || log?.task_name == null ? 'N/A' : log?.task_name) }</Typography>
                                </TableCell>
                                <TableCell align="center">
                                  <Typography variant="subtitle2">{displayRegularHours.toFixed(2)}</Typography>
                                </TableCell>
                                {/* <TableCell align="center">
                                  <Typography variant="subtitle2">{row.otH ? row.otH.toFixed(2) : '-'}</Typography>
                                </TableCell> */}
                                <TableCell align="center">
                                  <Typography variant="subtitle2">${displayCostRate.toFixed(2)}</Typography>
                                </TableCell>
                                {/* <TableCell align="center">
                                  <Typography variant="subtitle2">${row.displayBillRate.toFixed(2)}</Typography>
                                </TableCell> */}
                                <TableCell align="center">
                                  <Tooltip title={getRecipeCostLaborBreakdownText(displayRegularHours, displayOtHours, displayCostRate)} arrow>
                                    <Typography variant="subtitle2">${displayCost.toFixed(2)}</Typography>
                                  </Tooltip>
                                </TableCell>
                                {/* <TableCell align="center">
                                  <Tooltip title={getRecipeCostLaborBreakdownText(row.regularH, row.otH, row.displayBillRate)} arrow>
                                    <Typography variant="subtitle2" sx={{ fontWeight: 700, color: 'primary.main' }}>${row.bill.toFixed(2)}</Typography>
                                  </Tooltip>
                                </TableCell> */}
                              </TableRow>
                              );
                            })
                            }
  
                          </TableBody>
                        </Table>
                      </TableContainer>
  
                    </Scrollbar>
                  </Grid>
                  {updates?.length > 0 ? (<Box sx={{mt:2}}>
                   <RequestTabUpdates updates={updates?.length > 0 ? updates : []} details={projectData}/>
                  </Box>) : ''}
                </Card>
                  }
                  </>
                
              </Grid>
              <Grid item md={isHidden ? 12 : 7} xs={12}>
                <Box sx={{ position: 'relative' }}>
                <Card variant='outlined' sx={{ mt: 1 }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', py: 2, pl: 2, flexDirection: 'row', gap: 2, }}>
                      <Tooltip title={isHidden ? 'Show Details' : 'Hide Details'} placement="top">
                        <IconButton
                          onClick={() => setIsHidden(!isHidden)}
                          sx={{
                            backgroundColor: '#f5f5f528',
                            border: '1px solid #ccc',
                            borderRadius: '4px',
                            width: 30,
                            height: 40,
                            color: '#ffffff',
                            '&:hover': {
                              backgroundColor: '#44424263',
                            },
                            transition: 'all 0.2s ease-in-out',
                          }}
                        >
                          {isHidden ? <ArrowForwardIos fontSize="small" /> : <ArrowBackIos fontSize="small" sx={{ marginLeft: '7px' }} />}
                        </IconButton>
                      </Tooltip>
                    <Typography variant="h4" noWrap>Expense</Typography>
                  </Box>


                  
                  <Box sx={{ mb: 2, mx: 2 }}>
                    <Tabs
                      value={laborSectionTab}
                      onChange={(e, v) => setLaborSectionTab(v)}
                      sx={{
                        '& .MuiTabs-indicator': {
                          height: 3,
                          borderRadius: '3px 3px 0 0',
                          background: `linear-gradient(90deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.light} 100%)`
                        },
                        '& .MuiTab-root': {
                          minWidth: 'auto',
                          mr: 4,
                          px: 0,
                          textTransform: 'none',
                          fontSize: '1rem',
                          fontWeight: 600
                        },
                        '& .Mui-selected': { color: 'text.primary' }
                      }}
                    >
                      {laborSectionTabs.map((tab) => (
                        <Tab
                          disableRipple
                          key={tab.value}
                          value={tab.value}
                          label={
                            tab.value === 'Labor' && isTM ? (
                              <Tooltip
                                arrow
                                title={`Service Count: ${laborRowsCount?.serviceCount || 0}, Labor Count: ${laborRowsCount?.laborCount || 0}`}
                              >
                                <Stack direction="row" alignItems="center" spacing={1}>
                                  {tab.label}
                                  <TabBadge active={laborSectionTab === tab.value ? 1 : 0} color={tab.color}>
                                    {tab.count}
                                  </TabBadge>
                                </Stack>
                              </Tooltip>
                            ) : tab.value === 'Materials' ? (
                              <Tooltip
                                arrow
                                title={`Materials: ${selectedProjects?.length || 0}, Additional Materials: ${additionalMaterials?.length || 0}`}
                              >
                                <Stack direction="row" alignItems="center" spacing={1}>
                                  {tab.label}
                                  <TabBadge active={laborSectionTab === tab.value ? 1 : 0} color={tab.color}>
                                    {tab.count}
                                  </TabBadge>
                                </Stack>
                              </Tooltip>
                            ) : tab.value === 'Summary' ? (
                              <Stack direction="row" alignItems="center" spacing={1}>
                                {tab.label}
                              </Stack>
                            ) : (
                              <Stack direction="row" alignItems="center" spacing={1}>
                                {tab.label}
                                <TabBadge active={laborSectionTab === tab.value ? 1 : 0} color={tab.color}>
                                  {tab.count}
                                </TabBadge>
                              </Stack>
                            )
                          }
                        />
                      ))}
                    </Tabs>
                    <Divider sx={{ mt: -0.1 }} />
                  </Box>
                  <Box sx={{ px: 2, pb: 2, display: laborSectionTab === 'Labor' ? 'block' : 'none' }}>
                    <JobCostMemberClockInTimer
                      logs={logs}
                      fetchData={fetchData}
                      staffTimelogsGet={staffTimelogsGet}
                      setStaffTimelogsGet={setStaffTimelogsGet}
                      projectMembers={projectMembers}
                      setProjectMembers={setProjectMembers}
                      projectTasks={projectTasks}
                      setProjectTasks={setProjectTasks}
                      setLogs={setLogs}
                      fetchJobCostLogs={fetchJobCostLogs}
                      services={services}
                      userId={user?.user_id}
                      userType={user?.user_type}
                      projectData={projectData}
                      requestId={projectData?.request_id || projectDetails?.request_id || (Number(req_id) > 0 ? req_id : undefined)}
                      projectId={id}
                      isTM={isTM}
                      subTaskId={projectTasks?.[0]?.id}
                      isMirrored={isMirrored}
                      targetFacilityId={targetFacilityId}
                      onRowsCountChange={setLaborRowsCount}
                      refreshTrigger={recalculateTrigger}
                      onRefreshTrigger={() => setRecalculateTrigger((prev) => prev + 1)}
                      onSummaryChange={handleLaborSummaryChange}
                      onServicesRefresh={refreshJobCostGraphData}
                    />
                  </Box>

                  <Box sx={{ display: laborSectionTab === 'Other' ? 'block' : 'none' }}>
                    <JobCostEquipmentsTab
                      theme={theme}
                      services={services}
                      setAllServices={setAllServices}
                      isLoading={loading}
                      onAddEquipmentEntry={handleOpenAddService}
                      onSummaryChange={handleEquipmentSummaryChange}
                      onServicesRefresh={fetchData}
                      userId={user?.user_id}
                      requestId={projectData?.request_id || projectDetails?.request_id || (Number(req_id) > 0 ? req_id : undefined)}
                      projectId={id}
                      projectData={projectData}
                      manuallyAddedPayouts={manuallyAddedPayouts}
                      totalManualHours={totalManualHours}
                      staffTimelogs={staffTimelogsGet}
                      isTM={isTM}
                      onRowsCountChange={setOtherRowsCount}
                    />
                  </Box>

                  {laborSectionTab === 'Materials' ? (
                    <JobCostMaterialsTab
                      theme={theme}
                      selectedProjects={selectedProjects}
                      setSelectedProjects={setSelectedProjects}
                      // onAddMaterialEntry={handleClick}
                      onAddMaterialEntry={handleOpenAddMaterial}
                      handleMaterialCheckboxChange={handleMaterialCheckboxChange}
                      handleEditRow={handleEditRow}
                      handleDeleteRow={handleDeleteRow}
                      handleScrollLeft={handleScrollLeft}
                      handleScrollRight={handleScrollRight}
                      isEditing={isEditing}
                      isMirrored={isMirrored}
                      projectData={projectData}
                      isTM={isTM}
                      projectId={id}
                      userId={user?.user_id}
                      // Backup (before product-formula compare refresh fix): onMaterialsRefresh={fetchData}
                      onMaterialsRefresh={() => {
                        fetchData();
                        setRecalculateTrigger((prev) => prev + 1);
                      }}
                      QbLogo={QbLogo}
                      enqueueSnackbar={enqueueSnackbar}
                      errorFieldId={errorFieldId}
                      additionalMaterials={additionalMaterials}
                      initialMaterials={initialMaterials}
                      productList={productList}
                      isLoading={loading}
                      onSummaryChange={handleMaterialsSummaryChange}
                    />
                  ) : laborSectionTab === 'Equipment' ? (
                    <JobCostOtherTab
                      theme={theme}
                      entries={otherEntries}
                      setEntries={setOtherEntries}
                      isLoading={loading}
                      onSummaryChange={handleOtherSummaryChange}
                      onEquipmentRefresh={refreshJobCostGraphData}
                      // onEquipmentRefresh={fetchData}
                      onJobLogRefresh={fetchJobCostLogs}
                      userId={user?.user_id}
                      requestId={projectData?.request_id || projectDetails?.request_id || (Number(req_id) > 0 ? req_id : undefined)}
                      projectId={id}
                      isTM={isTM}
                      entryKind="Equipment"
                    />
                  ) : laborSectionTab === 'Summary' ? (
                    <Box sx={{ px: 2, pb: 2 }}>
                      <TMSummary
                        swapEquipmentOtherStats
                        isTM={isTM}
                        data={{
                          ...summaryTabData,
                          billable: Number(grandTotalBill || 0),
                          cost: Number(totalCostWithBill || 0),
                          margin: `${actualMarginPercent.toFixed(2)}%`
                        }}
                        internalNote={internalNote}
                        customerInvoiceNote={customerInvoiceNote}
                        onInternalNoteChange={handleInternalNoteChange}
                        onCustomerInvoiceNoteChange={handleCustomerInvoiceNoteChange}
                        onGenerateWithAI={handleGenerateSummaryWithAI}
                        isGeneratingWithAI={isGeneratingSummaryNote}
                      />
                    </Box>
                  ) : null}
                  {false && (<Box sx={{ width: "100%", display: "flex", alignItems: 'center', justifyContent: "flex-end", my: 2, mr: 5 }}>
                    {/* Color indicators for stock types */}
                    <Box sx={{ display: "flex", alignItems: "center", gap: 2, mr: 2 }}>
                      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                        <Box sx={{ width: 20, height: 20, backgroundColor: theme.palette.mode === 'light' ? "black" : "#ffffff", borderRadius: "20%", border: "1px solid black" }} />
                        <Typography variant="body2">Materials</Typography>
                      </Box>
                      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                        <Box sx={{ width: 20, height: 20, backgroundColor: theme.palette.mode === 'light' ? "#ffd000" : "yellow", borderRadius: "20%", border: "1px solid black" }} />
                        <Typography variant="body2">Services</Typography>
                      </Box>
                      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                        <Box sx={{ width: 20, height: 20, backgroundColor: theme.palette.mode === 'light' ? " #ff5b78" : "#ffc0cb", borderRadius: "20%", border: "1px solid black" }} />
                        <Typography variant="body2">Additional Materials</Typography>
                      </Box>
                      {
                        projectData?.job_category_name == 'Time & Material' ? ""
                        :
                      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                        <Box sx={{ width: 20, height: 20, backgroundColor: "#1ccaff", borderRadius: "20%", border: "1px solid black" }} />
                        <Typography variant="body2">Stock Catalogs</Typography>
                      </Box>
                      }
                    </Box>
                  </Box>)}
                  <FormikProvider value={formik}>
                    <Form noValidate autoComplete="off" onSubmit={handleSubmit}>
                      {false &&(<Scrollbar
                        sx={{
                          height: '200px'
                        }}>
                        <TableContainer sx={{ minWidth: 550 }} ref={tableContainerRef}>
                          <Table>
                            <TableHead
                              sx={{
                                borderBottom: (theme) => `solid 1px ${theme.palette.divider}`,
                                '& th': { backgroundColor: 'transparent' }
                              }}
                            >
                              <TableRow>
                                 <TableCell align="center">
                                </TableCell>
                                <TableCell align="center">
                                </TableCell>
                                  <TableCell align="center">
                                </TableCell>
                                <TableCell align="center">
                                  <Typography variant="body1" >Name</Typography>
                                </TableCell>
                                <TableCell align="center">
                                  {/* {projectData?.job_category_name === 'Time & Material' 
                                    ? ''
                                    :  */}
                                    <Typography variant="body1" >Product Formula</Typography>
                                  {/* } */}
                                </TableCell>
                                <TableCell align="center">
                                  <Typography variant="body1" noWrap>Expected Qty</Typography>
                                </TableCell>
                                <TableCell align="center">
                                  <Typography variant="body1" noWrap>Actual Qty</Typography>
                                </TableCell>
                                {/* <TableCell align="center">
                                  <Typography variant="body1" noWrap>Unit price</Typography>
                                </TableCell> */}
                                <TableCell align="center">
                                  <Typography variant="body1" noWrap>Total </Typography>
                                </TableCell>
                                {(selectedProjects?.length > 0 || stockProducts?.length > 0) && (
                                  <TableCell align="center">
                                    <Typography variant="body1">Actions</Typography>
                                  </TableCell>
                                )}
                                {/* <TableCell align="center">
                                  <Typography variant="body1" noWrap></Typography>
                                </TableCell> */}
                              </TableRow>
                            </TableHead>
  
                            <TableBody>
                              {console.log("#############selectedProjects", selectedProjects)}
                              {selectedProjects?.map((selectedProject, index) => {
                                let qtyExceed = 0
                                let unitName = UNITS?.filter((item) => item?.id == selectedProject?.unit)
                                let shortUnitName = unitName?.[0]?.short_name || "";
                                return (
                                  <TableRow
                                    key={index}
                                    sx={{
                                      borderBottom: (theme) => `solid 1px ${theme.palette.divider}`,
                                      backgroundColor: (selectedProject?.taken==1) ? theme.palette.divider : null,
                                    }}
                                  >
                                                <TableCell padding="checkbox" onClick={handleScrollRight}>
                                                <IconButton sx={{ backgroundColor: theme.palette.divider,width:"35px",height:"35px" }} >
                                                <ArrowForwardIos color="#ffffff" sx={{width:"20px",fontSize:'1rem'}}/>
                                                  </IconButton>
                                                </TableCell>
  
                                    <TableCell align="center">
                                      <Stack direction={'row'}>
                                    <Checkbox key={index}
                                      sx={{cursor:'pointer'}}
                                      checked={(selectedProject?.taken==1) ? true : false}
                                      onChange={()=>{ handleMaterialCheckboxChange(index)}}
                                      color="primary"
                                      disabled={isMirrored}
                                    />
                                      </Stack>
                                    </TableCell>
                                     <TableCell align="center">
                                    {(selectedProject?.finalTaken==1 && projectData?.syncWithQuickbooks ==1) ?<Avatar src={QbLogo} alt="QB" sx={{ width: 30, height: 30, objectFit: "cover",}}/>
                                    :""}
                                     </TableCell>
                                    <TableCell align="center">
                                      <Box sx={{ maxWidth: 130, justifyContent: 'center', alignItems: 'center' }}>
                                        <Tooltip title={selectedProject?.productNotes || selectedProject?.name||selectedProject?.productName || selectedProject?.rfpProductName}>
                                          <Typography variant="subtitle2" sx={{overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap'}}>{selectedProject?.productNotes || selectedProject?.name||selectedProject?.productName || selectedProject?.rfpProductName}</Typography>
                                        </Tooltip>
                                        <Tooltip title={selectedProject?.barcode||"(Sub contract)"}>
                                          <Typography variant="subtitle2" sx={{overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap'}}>{selectedProject?.barcode||"(Sub contract)"}</Typography>
                                        </Tooltip>
                                        {/* <span style={{ color: theme.palette.error.main }}>
                                          {selectedProjects.rfp!=1?selectedProjects?.filter(item => item.id === selectedProject?.id)?.reduce((accumulator, currentValue) => {
                                            const initialQuantity = initialMaterials?.find(item => item.product_id === selectedProject.id)?.quantity || 0;
                                            const productQuantity = productList?.find(item => item.id === selectedProject.id)?.qty || 0;
                                            const stock = (initialQuantity + productQuantity) - currentValue?.quantity;
                                            return stock >= 0 ? ('Stock left : ' + stock.toFixed(2)) : '';
                                          }, 0) || '':''}
                                        </span> */}
                                      </Box>
                                    </TableCell>
                                    <TableCell>{<Typography variant="subtitle2" >{selectedProject?.recipeName ? selectedProject.recipeName : ""}</Typography>}</TableCell>
                                    {/* <TableCell align="left">1</TableCell> */}
                                    <TableCell align="center">
                                      <TextField
                                        sx={{ width: '80%' }}
                                        type='text'
                                        label={(selectedProject?.unit == 4) ? "Quantity" : shortUnitName}
                                        disabled={true}
                                        value={selectedProject.jobcost_actual_quantity}
                                        onKeyPress={(event) => {
                                          event.preventDefault();
  
                                        }}
                                        onChange={(event) => {
                                          // console.log('errorFieldId--2----',errorFieldId)
                                          let newValue = event.target.value;
                                          if (newValue.startsWith('-')) {
                                            newValue = newValue.slice(1);
                                          }
                                          const updatedProjects = selectedProjects.map(p => {
                                            if (p.id === selectedProject.id) {
                                              return {
                                                ...p,
                                                quantity: event.target.value
                                              };
                                            }
                                            return p;
                                          });
                                          const qtyExceed = selectedProjects?.filter(item => item.id === selectedProject?.id)?.reduce((accumulator, currentValue) => {
                                            const initialQuantity = initialMaterials?.find(item => item.product_id === selectedProject.id)?.quantity || 0;
                                            const productQuantity = productList?.find(item => item.id === selectedProject.id)?.qty || 0;
                                            const stock = initialQuantity + productQuantity;
                                            const balanceStock = stock - event.target.value;
                                            return (balanceStock < 0)
                                          }, 0) || 0
  
                                          setSelectedProjects(updatedProjects);
                                        }}
                                        // error={errorFieldId?.length > 0 && errorFieldId?.find(data => data.productId === selectedProject.id) || ''}
                                        //  helperText={errorFieldId?.length > 0 && errorFieldId.find(field => field.productId === selectedProject.id)?.errorText || ''}
                                        
                                         // error={Boolean(touched.quantity && errors.quantity)}
                                        // helperText={touched.quantity && errors.quantity}
                                        InputProps={{
                                          inputProps: {
                                            min: 1,
                                            max: () => {
                                              const initialQuantity = initialMaterials?.find(item => item.product_id === selectedProject.id)?.quantity || 0;
                                              const productQuantity = productList?.find(item => item.id === selectedProject.id)?.qty || 0;
                                              return initialQuantity + productQuantity;
                                            }
                                          }
                                        }}
                                        defaultValue={1}
                                      />
                                      
                                    </TableCell>
                                    <TableCell align="center">
                                      <TextField
                                        sx={{ width: '80%' }}
                                        type="number"
                                        // disabled={selectedProject.finalTaken == 1}
                                        disabled={!isEditing('materials', index)} 
                                        label={(selectedProject?.unit == 4) ? "Quantity" : shortUnitName}
                                        // disabled={true}
                                        value={selectedProject.jobcost_quantity}
                                        // onKeyPress={(event) => {
                                        //   event.preventDefault();
  
                                        // }}
                                        // onChange={(event) => {
                                        //   // console.log('errorFieldId--2----',errorFieldId)
                                        //   let newValue = event.target.value;
                                        //   if (newValue.startsWith('-')) {
                                        //     newValue = newValue.slice(1);
                                        //   }
                                        //   const updatedProjects = selectedProjects.map(p => {
                                        //     if (p.id === selectedProject.id) {
                                        //       return {
                                        //         ...p,
                                        //         quantity: event.target.value,
                                        //         jobcost_quantity: event.target.value
                                        //       };
                                        //     }
                                        //     return p;
                                        //   });
                                        //   const qtyExceed = selectedProjects?.filter(item => item.id === selectedProject?.id)?.reduce((accumulator, currentValue) => {
                                        //     const initialQuantity = initialMaterials?.find(item => item.product_id === selectedProject.id)?.quantity || 0;
                                        //     const productQuantity = productList?.find(item => item.id === selectedProject.id)?.qty || 0;
                                        //     const stock = initialQuantity + productQuantity;
                                        //     const balanceStock = stock - event.target.value;
                                        //     return (balanceStock < 0)
                                        //   }, 0) || 0
  
                                        //   setSelectedProjects(updatedProjects);
                                        // }}
                                        // onChange={(event) => {
                                        //   let newValue = event.target.value;
                                        //   if (newValue.startsWith('-')) {
                                        //     newValue = newValue.slice(1); // Prevent negative values
                                        //   }
                                        
                                        //   const updatedProjects = selectedProjects.map((p, idx) => {
                                        //     if (idx === index) {
                                        //       const updatedProject = {
                                        //         ...p,
                                        //         jobcost_quantity: newValue,
                                        //         jobcost_total: newValue * Number(p.jobcost_unit_cost),
                                        //       };
                                        
                                        //       // If the value entered is less than the first box value, uncheck the checkbox
                                        //       if (Number(newValue) < Number(p.jobcost_actual_quantity)) {
                                        //         updatedProject.taken = 0;
                                        //       } 
                                        //       // If the value exceeds the first box value, reset it to match the first box value
                                        //       else if (Number(newValue) > Number(p.jobcost_actual_quantity)) {
                                        //         updatedProject.jobcost_quantity = p.jobcost_actual_quantity;
                                        //         updatedProject.taken = 1; // Keep the checkbox checked
                                        //       } else {
                                        //         updatedProject.taken = 1; // Keep the checkbox checked for valid values
                                        //       }
                                        
                                        //       return updatedProject;
                                        //     }
                                        //     return p;
                                        //   });
                                        
                                        //   setSelectedProjects(updatedProjects);
                                        // }}
  
                                        onChange={(event) => {
                                          let newValue = event.target.value;

                                          if (Number(newValue) > Number(selectedProject?.available_stock)) {
                                            enqueueSnackbar(
                                              'Stock not available. Available stock: ' + selectedProject.available_stock,
                                              { variant: 'error' }
                                            );
                                        
                                            // Reset taken only, don’t update quantity
                                            setSelectedProjects((prevState) =>
                                              prevState.map((project, idx) =>
                                                idx === index
                                                  ? {
                                                      ...project,
                                                      taken: 0, // reset taken
                                                    }
                                                  : project
                                              )
                                            );
                                        
                                            return;
                                          }
                                        
                                          // Prevent negative values
                                          if (newValue.startsWith('-')) {
                                            newValue = newValue.slice(1);
                                          }
                                        
                                          setSelectedProjects((prevState) =>
                                            prevState.map((project, idx) => {
                                              if (idx === index) {
                                                // Get the maximum allowed value from the first box
                                                const maxAllowedValue = Number(project.jobcost_actual_quantity);
                                        
                                                // Constrain the value to the maximum allowed
                                                const constrainedValue = Math.min(Number(newValue), maxAllowedValue);
                                        
                                                // Determine the value of "taken" based on the input
                                                const taken = constrainedValue === maxAllowedValue ? 1 : 0;
                                        
                                                // Update the project with the constrained value and "taken" status
                                                return {
                                                  ...project,
                                                  jobcost_quantity:Number(newValue), //constrainedValue,
                                                  jobcost_total: Number(newValue) * Number(project.jobcost_unit_cost), //constrainedValue
                                                  taken: taken,
                                                };
                                              }
                                              return project;
                                            })
                                          );
                                        }}
                                        
                                        
                                        
                                        error={errorFieldId?.length > 0 && errorFieldId?.find(data => data.productId === selectedProject.id) || ''}
                                         helperText={errorFieldId?.length > 0 && errorFieldId.find(field => field.productId === selectedProject.id)?.errorText || ''}
                                        // error={Boolean(touched.quantity && errors.quantity)}
                                        // helperText={touched.quantity && errors.quantity}
                                        InputProps={{
                                          inputProps: {
                                            min: 1,
                                            max: () => {
                                              const initialQuantity = initialMaterials?.find(item => item.product_id === selectedProject.id)?.quantity || 0;
                                              const productQuantity = productList?.find(item => item.id === selectedProject.id)?.qty || 0;
                                              return initialQuantity + productQuantity;
                                            }
                                          }
                                        }}
                                        defaultValue={1}
                                      />
                                      
                                    </TableCell>
  
                                    <TableCell align="center">{fCurrency(Number(selectedProject?.jobcost_total))}</TableCell>
                                    {!isEditing('materials', index) ? (<TableCell align="center">
                                      <>
                                        <Stack direction={'row'} alignItems={'center'} spacing={1}>
                                          {/* {selectedProject.finalTaken == 1 ? '' : ( */}
                                            <Button variant='outlined' color='inherit' sx={{ boxShadow: 'none', minWidth: '40px', padding: '5px 9px' }} size="small" onClick={() => handleEditRow('materials', index)} disabled={isMirrored}>
                                            <Edit size="small" sx={{ fontSize: '24px' }} />
                                          </Button>
                                        {/* // )} */}
                                          <Button variant='outlined' color='inherit' sx={{ boxShadow: 'none', minWidth: '40px', padding: '5px 9px' }} size="small" onClick={() => handleDeleteRow('materials', index, selectedProjects)} disabled={isMirrored}>
                                            <Delete size="small" sx={{ fontSize: '24px' }}/>
                                          </Button>
                                          <IconButton sx={{ backgroundColor: theme.palette.divider,width:"35px",height:"35px" }} onClick={handleScrollLeft} >
                                        <ArrowBackIos color="#ffffff" sx={{width:"20px",ml:0.5,fontSize:'1rem'}}/>
                                   </IconButton>
                                        </Stack>
                                      </>

                                    </TableCell>) : <TableCell align="center">
                                      <>
                                        <Stack direction={'row'} alignItems={'center'} spacing={1}>
                                          <Button variant='outlined' color='inherit' sx={{ boxShadow: 'none', minWidth: '40px', padding: '5px 9px' }} size="small" onClick={() => handleEditRow('materials', index)} disabled={isMirrored}>
                                            <Done size="small" sx={{ fontSize: '24px' }}/>
                                          </Button>
                                          <Button variant='outlined' color='inherit' sx={{ boxShadow: 'none', minWidth: '40px', padding: '5px 9px' }} size="small" onClick={() => handleDeleteRow('materials', index, selectedProjects)} disabled={isMirrored}>
                                            <Delete size="small" sx={{ fontSize: '24px' }}/>
                                          </Button>
                                          <IconButton sx={{ backgroundColor: theme.palette.divider,width:"35px",height:"35px" }} onClick={handleScrollLeft} >
                                        <ArrowBackIos color="#ffffff" sx={{width:"20px",ml:0.5,fontSize:'1rem'}}/>
                                   </IconButton>
                                        </Stack>
                                      </>
                                    </TableCell>}
                                      {/* <TableCell padding="checkbox" onClick={handleScrollLeft}>
                                     <IconButton sx={{ backgroundColor: theme.palette.divider,width:"35px",height:"35px" }} >
                                        <ArrowBackIos color="#ffffff" sx={{width:"20px",ml:0.5,fontSize:'1rem'}}/>
                                   </IconButton>
                                     </TableCell> */}
  
                                  </TableRow>
                                )
                              })}
  
                                {/* {stockProducts?.map((selectedProject, index) => {
                                  let unitName = UNITS?.filter((item) => item?.id == selectedProject?.unit)
                                  let shortUnitName = unitName?.[0]?.short_name || "";
                                  return (
                                    <TableRow
                                      key={index}
                                      sx={{
                                        borderBottom: (theme) => `solid 1px ${theme.palette.divider}`,
                                        backgroundColor: (selectedProject?.taken == 1) ? theme.palette.divider : null,
                                      }}
                                    >
                                      <TableCell padding="checkbox" onClick={handleScrollRight}>
                                        <IconButton sx={{ backgroundColor: theme.palette.divider, width: "35px", height: "35px" }} >
                                          <ArrowForwardIos color="#ffffff" sx={{ width: "20px", fontSize: '1rem' }} />
                                        </IconButton>
                                      </TableCell>
  
                                      <TableCell align="center">
                                        <Stack direction={'row'}>
                                          <Checkbox key={index}
                                            sx={{ cursor: 'pointer' }}
                                            checked={(selectedProject?.taken == 1) ? true : false}
                                            onChange={() => { handleMaterialCheckboxChange(index) }}
                                            color="primary"
                                          />
                                        </Stack>
                                      </TableCell>
                                      <TableCell align="center">
                                        {(selectedProject?.finalTaken == 1 && projectData?.syncWithQuickbooks == 1) ? <Avatar src={QbLogo} alt="QB" sx={{ width: 30, height: 30, objectFit: "cover", }} />
                                          : ""}
                                      </TableCell>
                                      <TableCell align="center">
                                        <Box sx={{ maxWidth: 130, justifyContent: 'center', alignItems: 'center' }}>
                                          <Tooltip title={selectedProject?.name || selectedProject?.productName || selectedProject?.rfpProductName}>
                                            <Typography variant="subtitle2" sx={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{selectedProject?.name || selectedProject?.productName || selectedProject?.rfpProductName}</Typography>
                                          </Tooltip>
                                          <Tooltip title={selectedProject?.barcode || "(Sub contract)"}>
                                            <Typography variant="subtitle2" sx={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{selectedProject?.barcode || "(Sub contract)"}</Typography>
                                          </Tooltip>
                                        </Box>
                                      </TableCell>
                                      <TableCell>{<Typography variant="subtitle2" >{selectedProject?.recipeName ? selectedProject.recipeName : ""}</Typography>}</TableCell>
                                      <TableCell align="center">
                                        <TextField
                                          sx={{ width: '80%' }}
                                          type='text'
                                          label={(selectedProject?.unit == 4) ? "Quantity" : shortUnitName}
                                          disabled={true}
                                          value={selectedProject.jobcost_actual_quantity}
                                          onKeyPress={(event) => {
                                            event.preventDefault();
  
                                          }}
                                          onChange={(event) => {
                                            let newValue = event.target.value;
                                            if (newValue.startsWith('-')) {
                                              newValue = newValue.slice(1);
                                            }
                                            const updatedProjects = selectedProjects.map(p => {
                                              if (p.id === selectedProject.id) {
                                                return {
                                                  ...p,
                                                  quantity: event.target.value
                                                };
                                              }
                                              return p;
                                            });
                                            const qtyExceed = selectedProjects?.filter(item => item.id === selectedProject?.id)?.reduce((accumulator, currentValue) => {
                                              const initialQuantity = initialMaterials?.find(item => item.product_id === selectedProject.id)?.quantity || 0;
                                              const productQuantity = productList?.find(item => item.id === selectedProject.id)?.qty || 0;
                                              const stock = initialQuantity + productQuantity;
                                              const balanceStock = stock - event.target.value;
                                              return (balanceStock < 0)
                                            }, 0) || 0
  
                                            setSelectedProjects(updatedProjects);
                                          }}
                                          InputProps={{
                                            inputProps: {
                                              min: 1,
                                              max: () => {
                                                const initialQuantity = initialMaterials?.find(item => item.product_id === selectedProject.id)?.quantity || 0;
                                                const productQuantity = productList?.find(item => item.id === selectedProject.id)?.qty || 0;
                                                return initialQuantity + productQuantity;
                                              }
                                            }
                                          }}
                                          defaultValue={1}
                                        />
  
                                      </TableCell>
                                      <TableCell align="center">
                                        <TextField
                                          sx={{ width: '80%' }}
                                          type="number"
                                          disabled={selectedProject.finalTaken == 1}
                                          label={(selectedProject?.unit == 4) ? "Quantity" : shortUnitName}
                                          // disabled={true}
                                          value={selectedProject.jobcost_quantity}
                                          onChange={(event) => {
                                            let newValue = event.target.value;
                                            // Prevent negative values
                                            if (newValue.startsWith('-')) {
                                              newValue = newValue.slice(1);
                                            }
                                            setSelectedProjects((prevState) =>
                                              prevState.map((project, idx) => {
                                                if (idx === index) {
                                                  // Get the maximum allowed value from the first box
                                                  const maxAllowedValue = Number(project.jobcost_actual_quantity);
  
                                                  // Constrain the value to the maximum allowed
                                                  const constrainedValue = Math.min(Number(newValue), maxAllowedValue);
  
                                                  // Determine the value of "taken" based on the input
                                                  const taken = constrainedValue === maxAllowedValue ? 1 : 0;
  
                                                  // Update the project with the constrained value and "taken" status
                                                  return {
                                                    ...project,
                                                    jobcost_quantity: constrainedValue,
                                                    jobcost_total: constrainedValue * Number(project.jobcost_unit_cost),
                                                    taken: taken,
                                                  };
                                                }
                                                return project;
                                              })
                                            );
                                          }}
                                          error={errorFieldId?.length > 0 && errorFieldId?.find(data => data.productId === selectedProject.id) || ''}
                                          helperText={errorFieldId?.length > 0 && errorFieldId.find(field => field.productId === selectedProject.id)?.errorText || ''}
                                          InputProps={{
                                            inputProps: {
                                              min: 1,
                                              max: () => {
                                                const initialQuantity = initialMaterials?.find(item => item.product_id === selectedProject.id)?.quantity || 0;
                                                const productQuantity = productList?.find(item => item.id === selectedProject.id)?.qty || 0;
                                                return initialQuantity + productQuantity;
                                              }
                                            }
                                          }}
                                          defaultValue={1}
                                        />
  
                                      </TableCell>
  
                                      <TableCell align="center">{fCurrency(Number(selectedProject?.jobcost_total))}</TableCell>
  
                                      <TableCell padding="checkbox" onClick={handleScrollLeft}>
                                        <IconButton sx={{ backgroundColor: theme.palette.divider, width: "35px", height: "35px" }} >
                                          <ArrowBackIos color="#ffffff" sx={{ width: "20px", ml: 0.5, fontSize: '1rem' }} />
                                        </IconButton>
                                      </TableCell>
  
                                    </TableRow>
                                  )
                                })} */}
                                {stockProducts?.map((selectedProject, index) => {
                                  let unitName = UNITS?.find((item) => item?.id == selectedProject?.unit);
                                  let shortUnitName = unitName?.short_name || "";
  
                                  return (
                                    <TableRow
                                      key={index}
                                      sx={{
                                        borderBottom: (theme) => `solid 1px ${theme.palette.divider}`,
                                        backgroundColor: selectedProject?.taken == 1 ? theme.palette.divider : null,
                                      }}
                                    >
                                      {/* Scroll Right */}
                                      <TableCell padding="checkbox" onClick={handleScrollRight}>
                                        <IconButton
                                          sx={{ backgroundColor: theme.palette.divider, width: "35px", height: "35px" }}
                                        >
                                          <ArrowForwardIos sx={{ width: "20px", fontSize: '1rem' }} />
                                        </IconButton>
                                      </TableCell>
  
                                      {/* Checkbox */}
                                      <TableCell align="center">
                                        <Stack direction={'row'}>
                                          <Checkbox
                                            sx={{ cursor: 'pointer' }}
                                            checked={selectedProject?.taken == 1}
                                            onChange={() => {
                                              if((selectedProject?.location_quantity > selectedProject.in_stock_no || selectedProject?.jobcost_quantity > selectedProject.in_stock_no ) && selectedProject.taken !==1){
                                                setStockConfirmationOpen(true)
                                                setSelectedProducts(selectedProject)
                                              }else{
                                                handleStockCheckboxChange(index);
                                              }
                                            }}
                                            color="primary"
                                            disabled={isMirrored}
                                          />
                                        </Stack>
                                      </TableCell>
                                      <Dialog open={stockConfirmationOpen} onClose={() => setStockConfirmationOpen(false)}>
                                        <DialogContent sx={{ mb: -2 }}>
                                          <Stack direction="column" spacing={2}>
                                            <Typography variant='h6'></Typography>
                                            <Alert severity="warning">
                                              {(selectedProducts?.in_stock_no > 0 && (selectedProducts?.location_quantity > selectedProducts.in_stock_no)) ? 
                                              `Stock (${selectedProducts?.in_stock_no}) is lower than the required quantity (${selectedProducts?.location_quantity}). Do you want to set the Actual quantity to the available stock (${selectedProducts?.in_stock_no}) ?`
                                            : (selectedProducts?.in_stock_no > 0 && (selectedProducts?.jobcost_quantity > selectedProducts.in_stock_no)) ?
                                             `Stock (${selectedProducts?.in_stock_no}) is lower than the Actual quantity (${selectedProducts?.jobcost_quantity}). Do you want to set the Actual quantity to the available stock (${selectedProducts?.in_stock_no}) ?`
                                            : `This product is out of stock (${selectedProducts?.in_stock_no}). Add stock to proceed.`
                                            }
                                              </Alert>
                                          </Stack>
                                        </DialogContent>
                                        <DialogActions>
                                          <Button variant='outlined' color='inherit' onClick={() => setStockConfirmationOpen(false)}>No</Button>
                                          <Button
                                            variant="contained"
                                            sx={{ boxShadow: 'none' }}
                                            disabled={selectedProducts?.in_stock_no <= 0}
                                            onClick={() => {
                                              setStockConfirmationOpen(false);
                                              const isStock = true
                                              handleStockCheckboxChange(index,isStock);
                                              // handleUpdateStatus(status);
                                            }}
                                          >
                                            Yes
                                          </Button>
                                        </DialogActions>
                                      </Dialog>
  
                                      {/* QB Icon (leave empty or show conditionally) */}
                                      <TableCell align="center">
                                        {(selectedProject?.finalTaken == 1 && projectData?.syncWithQuickbooks == 1)
                                          ? <Avatar src={QbLogo} alt="QB" sx={{ width: 30, height: 30, objectFit: "cover" }} />
                                          : ""}
                                      </TableCell>
  
                                      {/* Product Name + Barcode */}
                                      <TableCell align="center">
                                        <Box sx={{ maxWidth: 130 }}>
                                          <Tooltip title={selectedProject?.product_name}>
                                            <Typography variant="subtitle2" noWrap 
                                            // sx={{color:"#1ccaff"}}
                                            >
                                              {selectedProject?.product_name}
                                            </Typography>
                                          </Tooltip>
                                          <Tooltip title={selectedProject?.barcode||""}>
                                          <Typography variant="subtitle2" sx={{overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap'}}>{selectedProject?.barcode||""}</Typography>
                                        </Tooltip>
                                            {
                                            (selectedProject.finalTaken !== 1 &&
                                              (selectedProject.jobcost_quantity > selectedProject.in_stock_no || !selectedProject.in_stock_no) &&
                                              selectedProject.jobcost_quantity > 0) && (
                                              <Typography
                                                variant="caption"
                                                color="error"
                                                sx={{ mt: 0.5, display: 'block' }}
                                              >
                                                Stock is less than required quantity
                                              </Typography>
                                            )}
                                        </Box>
                                      </TableCell>
                                      <TableCell>
                                        <Typography variant="subtitle2">
                                        </Typography>
                                      </TableCell>
  
                                      <TableCell align="center">
                                        <TextField
                                          sx={{ width: '80%' }}
                                          type='text'
                                          label={shortUnitName || "Qty"}
                                          disabled
                                          value={selectedProject.location_quantity}
                                        />
                                      </TableCell>
                                      {/* Editable Quantity Input */}
                                      <TableCell align="center">
                                      <TextField
                                        sx={{ width: '80%' }}
                                          type="number"
                                          // disabled={selectedProject.finalTaken == 1}
                                          disabled={selectedProject.finalTaken == 1 || !isEditing('stock', index)}
                                          label={shortUnitName || "Quantity"}
                                          // value={selectedProject.jobcost_quantity}
                                          value={parseInt(selectedProject.jobcost_quantity) || 0}
                                          onChange={(event) => {
                                            let newQty = parseFloat(event.target.value || 0);
                                            if (newQty < 0) newQty = 0;
  
                                            setStockProducts((prev) =>
                                              prev.map((item, idx) => {
                                                if (idx !== index) return item;
  
                                                const canTake = item.in_stock_no > 0 && item.in_stock_no >= newQty;
  
                                                return {
                                                  ...item,
                                                  jobcost_quantity: newQty,
                                                  jobcost_total_cost: (newQty * parseFloat(item.product_retail_price || 0)).toFixed(2),
                                                  taken: canTake && newQty > 0 ? 1 : 0
                                                };
                                              })
                                            );
                                          }}
                                          inputProps={{
                                            min: 0,
                                          }}
                                        />
                                      </TableCell>
                                      {/* Total */}
                                      <TableCell align="center">
                                        {fCurrency(Number(selectedProject?.jobcost_total_cost || 0))}
                                      </TableCell>
                                      {!isEditing('stock', index) ? (<TableCell align="center">
                                        <>
                                          <Stack direction={'row'} alignItems={'center'} spacing={1}>
                                            {/* {selectedProject.finalTaken == 1 ? '' : ( */}
                                              <Button variant='outlined' color='inherit' sx={{ boxShadow: 'none', minWidth: '40px', padding: '5px 9px' }} size="small" onClick={() => handleEditRow('stock', index)} disabled={isMirrored} >
                                              <Edit size="small" sx={{ fontSize: '24px' }} />
                                            </Button>
                                          {/* // )} */}
                                            <Button variant='outlined' color='inherit' sx={{ boxShadow: 'none', minWidth: '40px', padding: '5px 9px' }} size="small" onClick={() => handleDeleteRow('stock', index, selectedProjects)} disabled={isMirrored}>
                                              <Delete size="small" sx={{ fontSize: '24px' }}/>
                                            </Button>
                                            <IconButton sx={{ backgroundColor: theme.palette.divider,width:"35px",height:"35px" }} onClick={handleScrollLeft} >
                                        <ArrowBackIos color="#ffffff" sx={{width:"20px",ml:0.5,fontSize:'1rem'}}/>
                                   </IconButton>
                                          </Stack>
                                        </>

                                      </TableCell>) : <TableCell align="center">
                                        <>
                                          <Stack direction={'row'} alignItems={'center'} spacing={1}>
                                            <Button variant='outlined' color='inherit' sx={{ boxShadow: 'none', minWidth: '40px', padding: '5px 9px' }} size="small" onClick={() => handleEditRow('stock', index)} disabled={isMirrored}>
                                              <Done size="small" sx={{ fontSize: '24px' }}/>
                                            </Button>
                                            <Button variant='outlined' color='inherit' sx={{ boxShadow: 'none', minWidth: '40px', padding: '5px 9px' }} size="small" onClick={() => handleDeleteRow('stock', index,selectedProjects)} disabled={isMirrored}>
                                              <Delete size="small" sx={{ fontSize: '24px' }}/>
                                            </Button>
                                            <IconButton sx={{ backgroundColor: theme.palette.divider,width:"35px",height:"35px" }} onClick={handleScrollLeft} >
                                        <ArrowBackIos color="#ffffff" sx={{width:"20px",ml:0.5,fontSize:'1rem'}}/>
                                   </IconButton>
                                          </Stack>
                                        </>
                                      </TableCell>}
                                      {/* Scroll Left */}
                                      {/* <TableCell padding="checkbox" onClick={handleScrollLeft}>
                                        <IconButton
                                          sx={{ backgroundColor: theme.palette.divider, width: "35px", height: "35px" }}
                                        >
                                          <ArrowBackIos sx={{ width: "20px", ml: 0.5, fontSize: '1rem' }} />
                                        </IconButton>
                                      </TableCell> */}
                                    </TableRow>
                                  );
                                })}
                              {console.log("servicesservicesservicesservices", services)}
                              {
                              // services
                              //     ?.reduce((acc, curr) => {
                              //       if (curr.labour_cost_service_id === 10) {
                              //         if (!acc.some(item => item.labour_cost_service_id === 10)) {
                              //           const combined = { ...curr }
                              //           const sameItems = services.filter(s => s.labour_cost_service_id === 10)
  
                              //           combined.qty = sameItems.reduce((sum, s) => sum + Number(s.qty || 0), 0)
                              //           combined.jobcost_quantity = sameItems.reduce((sum, s) => sum + Number(s.jobcost_quantity || 0), 0)
                              //           combined.jobcost_total_cost = sameItems.reduce((sum, s) => sum + Number(s.jobcost_total_cost || 0), 0).toFixed(2)
  
                              //           acc.push(combined)
                              //         }
                              //       } else {
                              //         acc.push(curr)
                              //       }
                              //       return acc
                              //     }, [])
                              //     .map((service, serviceIndex) => (
                                services?.reduce((acc, curr) => {
                                  // ✅ Case 1: Consolidate install labour - untouched logic
                                  if (curr.labour_cost_service_id === 10) {
                                    if (!acc.some(item => item.labour_cost_service_id === 10)) {
                                      const combined = { ...curr };
                                      const sameItems = services.filter(s => s.labour_cost_service_id === 10);
  
                                      combined.qty = sameItems.reduce((sum, s) => sum + Number(s.qty || 0), 0);
                                      combined.jobcost_quantity = sameItems.reduce((sum, s) => sum + Number(s.jobcost_quantity || 0), 0);
                                      combined.jobcost_total_cost = sameItems.reduce((sum, s) => sum + Number(s.jobcost_total_cost || 0), 0).toFixed(2);
  
                                      acc.push(combined);
                                    }
                                  }
  
                                  // Case 2: Consolidate ALL services that have any recipe_id (not null) but NOT labour
                                  else if (curr.recipe_id != null) {
                                    const alreadyAdded = acc.some(item => item.__isRecipeGroup);
                                    if (!alreadyAdded) {
                                      const recipeItems = services.filter(s => s.recipe_id != null && s.labour_cost_service_id !== 10);
                                      if (recipeItems.length > 0) {
                                        const combined = { ...recipeItems[0] };
                                        
                                        // Calculate manuallyAddedPayoutsTotal
                                        // Backup before non-T&M Install Labor production split:
                                        // const manuallyAddedPayoutsTotalForCost = manuallyAddedPayouts?.reduce(
                                        //   (sum, p) => sum + parseFloat(p.amount || 0), 0
                                        // ) || 0;
                                        const manuallyAddedPayoutsTotalForCost = manuallyAddedPayouts?.filter(
                                          p => !isJobCostInstallLaborPayout(p, services)
                                        )?.reduce(
                                          (sum, p) => sum + parseFloat(p.amount || 0), 0
                                        ) || 0;
                                        
                                        // If excludeManualFromProductionLabor is true, exclude manual hours and payouts
                                        const manualHoursToAdd = excludeManualFromProductionLabor ? 0 : totalManualHours;
                                        const manualPayoutsToAdd = excludeManualFromProductionLabor ? 0 : manuallyAddedPayoutsTotalForCost;
                                        
                                        combined.qty = manualHoursToAdd + recipeItems.reduce((sum, s) => sum + Number(s.qty || 0), 0);
                                        combined.jobcost_quantity = manualHoursToAdd + recipeItems.reduce((sum, s) => sum + Number(s.jobcost_quantity || 0), 0);
                                        // Backup before production labor row/summary alignment fix:
                                        // combined.jobcost_total_cost = (manualPayoutsToAdd + recipeItems.reduce((sum, s) => sum + Number(s.jobcost_total_cost || 0), 0)).toFixed(2);
                                        combined.jobcost_total_cost = Number(effectiveProductionLabor || 0).toFixed(2);
                                        combined.__isRecipeGroup = true; // internal flag to prevent duplicates
                                        // Set taken to 1 if manual hours or payouts exist, or if any recipe item is taken
                                        combined.taken = (totalManualHours > 0 || manuallyAddedPayoutsTotalForCost > 0 || recipeItems.some(s => s.taken == 1)) ? 1 : (combined.taken || 0);

                                        acc.push(combined);
                                      }
                                    }
                                  }
                                  else {
                                    acc.push(curr);
                                  }
  
                                  return acc;
                                }, [])
                                .map((service, serviceIndex) => (
                                  <React.Fragment key={`service_${serviceIndex}`}>
                                <TableRow
                                  // key={`service_${serviceIndex}`}
                                  sx={{
                                    borderBottom: (theme) => `solid 1px ${theme.palette.divider}`,
                                    backgroundColor: (service?.taken==1) ? theme.palette.divider : null,
                                  }}
                                >
                                    {console.log("jfdnifhijskdfnf", service)}
  
                                              <TableCell padding="checkbox" onClick={handleScrollRight}>
                                                <IconButton sx={{ backgroundColor: theme.palette.divider,width:"35px",height:"35px" }} >
                                                <ArrowForwardIos color="#ffffff" sx={{width:"20px",fontSize:'1rem'}}/>
                                                  </IconButton>
                                                </TableCell>
                                  <TableCell align="center">
                                    {/* {projectData?.job_category_name=='Time & Material' ? '' :
                                    <Checkbox key={serviceIndex}
                                      sx={{cursor:'pointer'}}
                                      checked={(service?.taken==1) ? true : false}
                                      onChange={()=>{ handleServiceCheckboxChange(serviceIndex)}}
                                      color="primary"
                                    />
                                    } */}
                                    <Stack direction={'row'}>
                                    <Checkbox key={serviceIndex}
                                      sx={{cursor:'pointer'}}
                                      checked={(service?.taken==1) ? true : false}
                                      onChange={()=>{ handleServiceCheckboxChange(serviceIndex,service)}}
                                      color="primary"
                                      disabled={isMirrored}
                                    />
                                    {service.labour_cost_service_id === 10 &&
                                      services.filter(s => s.labour_cost_service_id === 10).length > 1 && (
                                        <IconButton
                                          size="small"
                                          onClick={() =>
                                            setOpenLabourIdx(prev =>
                                              prev === serviceIndex ? null : serviceIndex
                                            )
                                          }
                                        >
                                          {openLabourIdx === serviceIndex ? (
                                            <KeyboardArrowUp fontSize="small" />
                                          ) : (
                                            <KeyboardArrowDown fontSize="small" />
                                          )}
                                        </IconButton>
                                      )}
                                    </Stack>
                                  </TableCell>
                                     <TableCell align="center">
                                   {(service?.finalTaken==1  && projectData?.syncWithQuickbooks ==1) ? <Avatar src={QbLogo} alt="QB" sx={{ width: 30, height: 30, objectFit: "cover",}}/>
                                   :""}
                                     </TableCell>
  
                                  <TableCell align="center">
                                    <Typography variant="subtitle2" style={{ color: theme.palette.mode === 'light' ? "#ffd000" : "yellow" }}>{service.__isRecipeGroup ? 'Production Labor' :service.name}</Typography>
                                  </TableCell>
                                  <TableCell align="center">
                                    <Typography variant="subtitle2" style={{ color: theme.palette.mode === 'light' ? "#ffd000" : "yellow" }}>{service.__isRecipeGroup ? '' :service.recipeName}</Typography>
                                  </TableCell>
                                  <TableCell align="center">
                                    <TextField
                                      sx={{ width: '80%', color: theme.palette.mode === 'light' ? "#ffd000" : "yellow" }}
                                      type='number'
                                      label="Hours"
                                      value={parseFloat(service.qty || 0).toFixed(2)}
                                      disabled={true}
                                      InputProps={{
                                        inputProps: {
                                          min: 1
                                        }
                                      }}
                                    />
                                  </TableCell>
                                  <TableCell align="center">
                                    <TextField
                                      sx={{ width: '80%', color: theme.palette.mode === 'light' ? "#ffd000" : "yellow" }}
                                      type='number'
                                      label="Hours"
                                      value={parseFloat(service.jobcost_quantity || 0).toFixed(2)}
                                      disabled={!isEditing('services', serviceIndex)}
                                      onChange={(event) => {
                                        let newValue = parseFloat(event.target.value || 0);
                                        if (newValue < 0) newValue = 0
                                        
                                        setAllServices(prevState => {
                                          if (service.__isRecipeGroup) {
                                            // For recipe group: if manual is excluded, the display value already doesn't include manual hours
                                            // So we directly use newValue. Otherwise, subtract totalManualHours to get base value.
                                            const baseValue = excludeManualFromProductionLabor 
                                              ? Math.max(1, newValue) // When excluded, use value directly but ensure min 1
                                              : Math.max(0, newValue - totalManualHours); // When not excluded, subtract manual hours
                                            
                                            const recipeItems = prevState.filter(s => s.recipe_id != null && s.labour_cost_service_id !== 10);
                                            const totalRecipeQty = recipeItems.reduce((sum, s) => sum + Number(s.jobcost_quantity || 0), 0);
                                            
                                            return prevState.map(serviceItem => {
                                              if (serviceItem.recipe_id != null && serviceItem.labour_cost_service_id !== 10) {
                                                // Calculate proportion based on current quantities
                                                const proportion = totalRecipeQty > 0 
                                                  ? (Number(serviceItem.jobcost_quantity || 0) / totalRecipeQty) 
                                                  : (1 / recipeItems.length);
                                                // Round to 2 decimal places to fix floating-point precision issues
                                                const updatedQty = Math.round((baseValue * proportion) * 100) / 100;
                                                
                                                // Only update base recipe items - cost calculation: qty * originalCost
                                                return {
                                                  ...serviceItem,
                                                  jobcost_quantity: Math.max(0, updatedQty),
                                                  jobcost_total_cost: Number((Math.max(0, updatedQty) * serviceItem.originalCost).toFixed(2)),
                                                  taken: baseValue > 0 ? 1 : 0
                                                };
                                              }
                                              return serviceItem;
                                            });
                                          } else {
                                            // For non-recipe group items, update normally (preserve existing functionality)
                                            return prevState.map(serviceItem => {
                                              if (serviceItem.id === service.id) {
                                                const maxAllowedValue = Number(service.qty);
                                                const constrainedValue = Math.min(Number(newValue), maxAllowedValue);
                                                const taken = constrainedValue === maxAllowedValue ? 1 : 0;
                                                
                                                return {
                                                  ...serviceItem,
                                                  jobcost_quantity: newValue,
                                                  jobcost_total_cost: Number((newValue * serviceItem.originalCost).toFixed(2)),
                                                  taken: taken
                                                };
                                              }
                                              return serviceItem;
                                            });
                                          }
                                        });
                                      }}
                                      InputProps={{
                                        inputProps: {
                                          min: 1
                                        }
                                      }}
                                    />
                                  </TableCell>
                                  {/* <TableCell align="center">
                                    <Typography variant="subtitle2" style={{ color: 'yellow' }}>${service.jobcost_unit_cost|| service.originalCost||service.unit_cost}</Typography>
                                  </TableCell> */}
                                  {/* <Typography variant="subtitle2" style={{ color: 'yellow' }}>${service.originalCost||service.unit_cost}</Typography> */}
                                  <TableCell align="center">
                                    {/* {projectData?.job_category_name=='Time & Material' ?  */}
                                      <Typography variant="subtitle2" style={{ color: theme.palette.mode === 'light' ? "#ffd000" : "yellow" }}>${service.jobcost_total_cost}</Typography>
                                    {/* :
                                      <Typography variant="subtitle2" style={{ color: 'yellow' }}>${((service.jobcost_quantity || service.qty)*(service.jobcost_unit_cost||service.originalCost||service.unit_cost))?.toFixed(2)}</Typography>
                                    } */}
                                    {/* <Typography variant="subtitle2" style={{ color: 'yellow' }}>${(service.qty)*(service.originalCost||service.unit_cost))?.toFixed(2)}</Typography> */}
                                  </TableCell>
  
                                                                      {/* <TableCell padding="checkbox" onClick={handleScrollLeft}>
                                     <IconButton sx={{ backgroundColor: theme.palette.divider,width:"35px",height:"35px" }} >
                                        <ArrowBackIos color="#ffffff" sx={{width:"20px",ml:0.5,fontSize:'1rem'}}/>
                                   </IconButton>
                                     </TableCell> */}
                                      <TableCell align="center">
                                        {!isEditing('services', serviceIndex) ? (
                                          <>
                                            <Stack direction={'row'} alignItems={'center'} spacing={1}>
                                              {/* {service.finalTaken == 1 ? '' : ( */}
                                                <Button variant='outlined' color='inherit' sx={{ boxShadow: 'none', minWidth: '40px', padding: '5px 9px' }} size="small" onClick={() => handleEditRow('services', serviceIndex)} disabled={isMirrored}>
                                                  <Edit size="small" sx={{ fontSize: '24px' }} />
                                                </Button>
                                              {/* )} */}
                                                <Button variant='outlined' color='inherit' sx={{ boxShadow: 'none', minWidth: '40px', padding: '5px 9px' }} size="small" onClick={() => handleDeleteRow('services', serviceIndex, null, service.id, service.from_job, service.__isRecipeGroup)} disabled={isMirrored}>
                                                  <Delete size="small" sx={{ fontSize: '24px' }} />
                                                </Button>
                                              <IconButton sx={{ backgroundColor: theme.palette.divider, width: "35px", height: "35px" }} onClick={handleScrollLeft}>
                                                <ArrowBackIos color="#ffffff" sx={{ width: "20px", ml: 0.5, fontSize: '1rem' }} />
                                              </IconButton>
                                            </Stack>
                                          </>
                                        ) : (
                                          <>
                                            <Stack direction={'row'} alignItems={'center'} spacing={1}>
                                              <Button variant='outlined' color='inherit' sx={{ boxShadow: 'none', minWidth: '40px', padding: '5px 9px' }} size="small" onClick={() => handleEditRow('services', serviceIndex, service?.id)} disabled={isMirrored}>
                                                <Done size="small" sx={{ fontSize: '24px' }} />
                                              </Button>
                                                <Button variant='outlined' color='inherit' sx={{ boxShadow: 'none', minWidth: '40px', padding: '5px 9px' }} size="small" onClick={() => handleDeleteRow('services', serviceIndex, null, service.id, service.from_job, service.__isRecipeGroup)} disabled={isMirrored}>
                                                  <Delete size="small" sx={{ fontSize: '24px' }} />
                                                </Button>
                                              <IconButton sx={{ backgroundColor: theme.palette.divider, width: "35px", height: "35px" }} onClick={handleScrollLeft}>

                                                <ArrowBackIos color="#ffffff" sx={{ width: "20px", ml: 0.5, fontSize: '1rem' }} />
                                              </IconButton>
                                            </Stack>
                                          </>
                                        )}
                                      </TableCell>
                                </TableRow>
                                 {openLabourIdx === serviceIndex &&
                                  service.labour_cost_service_id === 10 && (
                                    <TableRow >
                                      {/* span the full width of the table (adjust colSpan to your column count) */}
                                      <TableCell colSpan={9} sx={{ p: 0 }}>
                                        <Collapse in={openLabourIdx === serviceIndex} timeout="auto" unmountOnExit>
                                          <Box px={2} py={1}>
                                            {/* mini-table */}   
                                            <Table size="small">
                                              <TableHead sx={{
                                                borderBottom: (theme) => `solid 1px ${theme.palette.divider}`,
                                                '& th': { backgroundColor: 'transparent' }
                                              }}>
                                                    <TableRow sx={{fontWeight:400}} >
                                                      <TableCell align='center' sx={{ width: '20%' }}>
                                                        <Typography variant="subtitle2" >Name</Typography>
                                                      </TableCell>
                                                      <TableCell sx={{ width: '30%' }}>
                                                        <Typography variant="subtitle2" >Product Formula</Typography>
                                                      </TableCell>
                                                      {/* <TableCell align="center" sx={{ width: '20%' }}>
                                                         <Typography variant="subtitle2" >Expected Qty</Typography>
                                                       </TableCell> */}
                                                      <TableCell align="center" sx={{ width: '20%' }}>
                                                        <Typography variant="subtitle2" >Actual Qty</Typography>
                                                      </TableCell>
                                                      <TableCell align="right" sx={{ width: '25%' }}>
                                                        <Typography variant="subtitle2" >Total</Typography>
                                                      </TableCell>
                                                    </TableRow>
                                              </TableHead>
  
                                              <TableBody>
                                                {services
                                                  .filter(r => r.labour_cost_service_id === 10)
                                                  .map((row, i) => (
                                                    <TableRow key={i} sx={{fontWeight:400}}>
                                                      <TableCell>
                                                        <Typography variant="subtitle2" style={{ color: theme.palette.mode === 'light' ? "#ffd000" : "yellow" }}>{row.name}</Typography>
                                                      </TableCell>
                                                      <TableCell>
                                                        <Typography variant="subtitle2" >{row?.recipeName}</Typography>
                                                      </TableCell>
                                                      {/* <TableCell align="center">
                                                         <Typography variant="subtitle2" >{row?.qty}</Typography>
                                                       </TableCell> */}
                                                      <TableCell align="center">
                                                        <Typography variant="subtitle2" >{row?.jobcost_quantity}</Typography>
                                                      </TableCell>
                                                      <TableCell align="right">
                                                        <Typography variant="subtitle2" style={{ color: theme.palette.mode === 'light' ? "#ffd000" : "yellow" }}>${row.jobcost_total_cost}</Typography>
                                                      </TableCell>
                                                    </TableRow>
                                                  ))}
                                              </TableBody>
                                            </Table>
                                          </Box>
                                        </Collapse>
                                      </TableCell>
                                    </TableRow>
                                  )}
                              </React.Fragment>
                              ))
                              }
                              {/* Separate Production Labor row for project category 12 (Time & Material) */}
                              {projectData?.project_category === 12 && (() => {
                                // For Time & Material, get all manually added payouts (from allPayouts)
                                const manuallyAddedPayoutsForTM = allPayouts?.filter(
                                  // Backup before Install Labor request-service classification:
                                  // p => (p.is_manually_added === 1 || p.is_manually_added === "1")
                                  p => (p.is_manually_added === 1 || p.is_manually_added === "1") && !isJobCostInstallLaborPayout(p, services)
                                ) || [];
                                
                                const manuallyAddedPayoutsTotalForCost = manuallyAddedPayoutsForTM.reduce(
                                  (sum, p) => sum + parseFloat(p.amount || 0), 0
                                ) || 0;
                                
                                const hasManualTasks = (totalManualHours > 0 || manuallyAddedPayoutsTotalForCost > 0);
                                
                                if (!hasManualTasks) return null;
                                
                                return (
                                  <React.Fragment key={`production_labor_12`}>
                                    <TableRow
                                      sx={{
                                        borderBottom: (theme) => `solid 1px ${theme.palette.divider}`,
                                        backgroundColor: theme.palette.divider,
                                      }}
                                    >
                                      <TableCell padding="checkbox" onClick={handleScrollRight}>
                                        <IconButton sx={{ backgroundColor: theme.palette.divider, width: "35px", height: "35px" }}>
                                          <ArrowForwardIos color="#ffffff" sx={{ width: "20px", fontSize: '1rem' }} />
                                        </IconButton>
                                      </TableCell>
                                      
                                      <TableCell align="center">
                                        <Stack direction={'row'}>
                                          <Checkbox
                                            sx={{ cursor: 'not-allowed' }}
                                            checked={true}
                                            color="primary"
                                          />
                                        </Stack>
                                      </TableCell>
                                      
                                      <TableCell align="center">
                                        {(projectData?.syncWithQuickbooks == 1) ? 
                                          <Avatar src={QbLogo} alt="QB" sx={{ width: 30, height: 30, objectFit: "cover" }} />
                                          : ""}
                                      </TableCell>
                                      
                                      <TableCell align="center">
                                        <Typography variant="subtitle2" style={{ color : theme.palette.mode === 'light' ? "#ffd000" : "yellow" }}>Production Labor</Typography>
                                      </TableCell>
                                      
                                      <TableCell align="center">
                                        <Typography variant="subtitle2" style={{ color: theme.palette.mode === 'light' ? "#ffd000" : "yellow" }}></Typography>
                                      </TableCell>
                                      
                                      <TableCell align="center">
                                        <TextField
                                          sx={{ width: '80%', color: theme.palette.mode === 'light' ? "#ffd000" : "yellow" }}
                                          type='number'
                                          label="Hours"
                                          value={parseFloat(totalManualHours || 0).toFixed(2)}
                                          disabled={true}
                                          InputProps={{
                                            inputProps: {
                                              min: 0
                                            }
                                          }}
                                        />
                                      </TableCell>
                                      
                                      <TableCell align="center">
                                        <TextField
                                          sx={{ width: '80%', color: theme.palette.mode === 'light' ? "#ffd000" : "yellow" }}
                                          type='number'
                                          label="Hours"
                                          value={parseFloat(totalManualHours || 0).toFixed(2)}
                                          disabled={true}
                                          InputProps={{
                                            inputProps: {
                                              min: 0
                                            }
                                          }}
                                        />
                                      </TableCell>
                                      
                                      <TableCell align="center">
                                        <Typography variant="subtitle2" style={{ color: theme.palette.mode === 'light' ? "#ffd000" : "yellow" }}>
                                          ${parseFloat(manuallyAddedPayoutsTotalForCost || 0).toFixed(2)}
                                        </Typography>
                                      </TableCell>
                                      
                                      <TableCell align="center">
                                        <Stack direction={'row'} alignItems={'center'} spacing={1}>
                                          <Tooltip title="Production Labor for Time & Material cannot be edited. It is derived from manually added tasks." placement="top">
                                            <span>
                                              <Button disabled variant='outlined' color='inherit' sx={{ boxShadow: 'none', minWidth: '40px', padding: '5px 9px' }} size="small">
                                                <Edit size="small" sx={{ fontSize: '24px' }} />
                                              </Button>
                                            </span>
                                          </Tooltip>
                                          <Tooltip title="Production Labor for Time & Material cannot be deleted. It is derived from manually added tasks." placement="top">
                                            <span>
                                              <Button disabled variant='outlined' color='inherit' sx={{ boxShadow: 'none', minWidth: '40px', padding: '5px 9px' }} size="small">
                                                <Delete size="small" sx={{ fontSize: '24px' }} />
                                              </Button>
                                            </span>
                                          </Tooltip>
                                          <IconButton sx={{ backgroundColor: theme.palette.divider, width: "35px", height: "35px" }} onClick={handleScrollLeft}>
                                            <ArrowBackIos color="#ffffff" sx={{ width: "20px", ml: 0.5, fontSize: '1rem' }} />
                                          </IconButton>
                                        </Stack>
                                      </TableCell>
                                    </TableRow>
                                  </React.Fragment>
                                );
                              })()}
                              {
                                additionalMaterials?.map((material, index) => (
                                  <TableRow
                                    key={index}
                                    sx={{
                                      borderBottom: (theme) => `solid 1px ${theme.palette.divider}`,
                                      backgroundColor: material.taken === 1 ? theme.palette.divider : null
                                    }}
                                  >
                                    {/* Scroll Right */}
                                    <TableCell padding="checkbox" onClick={handleScrollRight}>
                                      <IconButton sx={{ backgroundColor: theme.palette.divider, width: "35px", height: "35px" }}>
                                        <ArrowForwardIos sx={{ width: "20px", fontSize: '1rem' }} />
                                      </IconButton>
                                    </TableCell>
  
                                    {/* Checkbox */}
                                    <TableCell align="center">
                                      <Stack direction="row">
                                        {/* <Checkbox
                                          checked={material.taken === 1}
                                          onChange={() => handleMaterialCheckboxChange(index, material)}
                                          color="primary"
                                        /> */}
                                      </Stack>
                                    </TableCell>
  
                                    
                                    <TableCell align="center">
                                      {(material?.taken == 1 &&  projectData?.syncWithQuickbooks) ? 
                                      <Avatar src={QbLogo} alt="QB" sx={{ width: 30, height: 30, objectFit: "cover",}}/>
                                        :""}
                                    </TableCell>
  
                                    <TableCell align="center">
                                      <Box sx={{ maxWidth: 130, justifyContent: 'center', alignItems: 'center' }}>
                                        <Tooltip title={material.productNotes || material.name + (material?.inhouse == 1 ? ' (Inhouse)' : ' (Client owned)')+(material?.partial==1?'Partial':'Finished')}>
                                          <Typography variant="subtitle2" sx={{color: material?.isMaterial ==1 ? "#ffc0cb" : '#1ccaff', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap'}}>
                                            {material.productNotes || material.name} {material?.inhouse == 1 ? ' (I)' : ' (C)'}
                                          </Typography>
                                        </Tooltip>
                                        <Typography variant="subtitle2" sx={{color: material?.isMaterial ==1 ? "#ffc0cb" : '#1ccaff'}}>{material?.barcode}</Typography>
                                        <span style={{ color: material?.isMaterial ==1 ? theme.palette.error.main : "#1ccaff" }}>
                                          {additionalMaterials?.filter(item => item.id === material?.id)?.reduce((accumulator, currentValue) => {
                                            const initialQuantity = initialMaterials?.find(item => item.product_id === material.id)?.quantity || 0;
                                            const productQuantity = productList?.find(item => item.id === material.id)?.qty || 0;
                                             const stock = (initialQuantity + productQuantity)  //- currentValue?.quantity;
                                            return stock >= 0 ? ('Stock left : ' + stock.toFixed(2)) : '';
                                          }, 0) || ''}
                                        </span>
                                      </Box>
                                    </TableCell>
                                    {/* Material name */}
                                    {/* <TableCell align="center">
                                      <Typography variant="subtitle2" style={{ color: '#ffc0cb' }}>
                                        {material.productName}
                                      </Typography>
                                    </TableCell> */}
  
                                    {/* Recipe (or empty) */}
                                    <TableCell align="center">
                                      <Typography variant="subtitle2" style={{ color:material?.isMaterial == 1 ? theme.palette.mode === 'light' ? "#ff5b78" : "#ffc0cb" : '#1ccaff' }}>
                                        {'N/A'}
                                      </Typography>
                                    </TableCell>
  
                                    {/* Quantity */}
                                    <TableCell align="center">
                                      <TextField
                                        sx={{ width: '80%', color:material?.isMaterial == 1 ? theme.palette.mode === 'light' ? "#ff5b78" : "#ffc0cb" : '#1ccaff'}}
                                        type="number"
                                        label="Qty"
                                        value={material.quantity}
                                        disabled={material?.isMaterial !== 1 || !isEditing('additional', index) || isMirrored}
                                        onChange={(e) => {
                                          if (material?.isMaterial !== 1) return;
                                          const v = e.target.value;
                                          setAdditionalMaterials((prev) =>
                                            prev.map((m, i) =>
                                              i === index ? { ...m, quantity: v, total: Number(v) * Number(m.unit_cost || 0) } : m
                                            )
                                          );
                                        }}
                                        InputProps={{ inputProps: { min: 1 } }}
                                      />
                                    </TableCell>
  
                                    {/* Jobcost quantity */}
                                    <TableCell align="center">
                                      {/* <TextField
                                        sx={{ width: '80%', color: '#ffc0cb' }}
                                        type="number"
                                        label="Material Qty"
                                        value={Number(material.quantity)}
                                        disabled={true}
                                        InputProps={{ inputProps: { min: 1 } }}
                                      /> */}
                                    </TableCell>
  
                                    {/* Total cost */}
                                    <TableCell align="center">
                                        <Typography variant="subtitle2" style={{ color:material?.isMaterial == 1 ? theme.palette.mode === 'light' ? "#ff5b78" : "#ffc0cb" : '#1ccaff' }}>
                                        ${material.total}
                                      </Typography>
                                    </TableCell>
  
                                    {/* Scroll Left */}
                                    {/* <TableCell padding="checkbox" onClick={handleScrollLeft}>
                                      <IconButton sx={{ backgroundColor: theme.palette.divider, width: "35px", height: "35px" }}>
                                        <ArrowBackIos sx={{ width: "20px", ml: 0.5, fontSize: '1rem' }} />
                                      </IconButton>
                                    </TableCell> */}
                                    <TableCell align="center">
                                    <Stack direction={'row'} alignItems={'center'} spacing={1}>
                                      {material?.isMaterial === 1 && !isMirrored ? (
                                        <>
                                          {!isEditing('additional', index) ? (
                                            <Button variant='outlined' color='inherit' sx={{ boxShadow: 'none', minWidth: '40px', padding: '5px 9px' }} size="small" onClick={() => handleEditRow('additional', index)}>
                                              <Edit size="small" sx={{ fontSize: '24px' }} />
                                            </Button>
                                          ) : (
                                            <Button variant='outlined' color='inherit' sx={{ boxShadow: 'none', minWidth: '40px', padding: '5px 9px' }} size="small" onClick={() => handleEditRow('additional', index)}>
                                              <Done size="small" sx={{ fontSize: '24px' }} />
                                            </Button>
                                          )}
                                          <Button variant='outlined' color='inherit' sx={{ boxShadow: 'none', minWidth: '40px', padding: '5px 9px' }} size="small" onClick={() => handleDeleteRow('additional', index, null)} disabled={isMirrored}>
                                            <Delete size="small" sx={{ fontSize: '24px' }} />
                                          </Button>
                                        </>
                                      ) : (
                                        <>
                                          <Tooltip title={`${material?.isMaterial !== 1 ? "Catalog" : "Additional materials"} — use the Materials tab or Add Material to manage.`} placement="top">
                                            <span>
                                              <Button disabled variant='outlined' color='inherit' sx={{ boxShadow: 'none', minWidth: '40px', padding: '5px 9px' }} size="small">
                                                <Edit size="small" sx={{ fontSize: '24px' }} />
                                              </Button>
                                            </span>
                                          </Tooltip>
                                          <Tooltip title={`${material?.isMaterial !== 1 ? "Catalog" : "Additional materials"} — use the Materials tab or Add Material to manage.`} placement="top">
                                            <span>
                                              <Button disabled variant='outlined' color='inherit' sx={{ boxShadow: 'none', minWidth: '40px', padding: '5px 9px' }} size="small" >
                                                <Delete size="small" sx={{ fontSize: '24px' }} />
                                              </Button>
                                            </span>
                                          </Tooltip>
                                        </>
                                      )}
                                      <IconButton sx={{ backgroundColor: theme.palette.divider, width: "35px", height: "35px" }} onClick={handleScrollLeft}>
                                        <ArrowBackIos color="#ffffff" sx={{ width: "20px", ml: 0.5, fontSize: '1rem' }} />
                                      </IconButton>
                                    </Stack>
                                    </TableCell>
                                  </TableRow>
                                ))
                              }
  
                            </TableBody>
                          </Table>
                        </TableContainer>
  
                      </Scrollbar>)}
                      {false && !isMirrored ? (
                    <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2, mb: 4, flexDirection: { xs: 'column', md: 'row' }, alignItems:'center', gap: 1, }}>
                        <Button
                          variant='outlined'
                          startIcon={<Stack className='lets-icons--add-duotone' />}
                          type="button"
                          size='large'
                          onClick={() => handleClick()}
                        >
                          {projectData?.job_category_name == 'Time & Material' ? 'Add Material' : 'Add Material / Catalog'}
                        </Button>
                        <Button
                          variant='outlined'
                          type="button"
                          size='large'
                          startIcon={<Add />}
                          onClick={() => {
                            fetchAvailableServices();
                            setServicesPage(0); // Reset to first page
                            setServicesRowsPerPage(10); // Reset to default rows per page
                            setServicesPreview(true);
                          }}
                        >
                          Add Service
                        </Button>
                      </Box>
                    ) : null}
                      {/* Job cost totals table rows (Material Cost through Total Cost) — commented out */}
                      {false && (
                      <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
                      <Box>
                      <RowResultStyle>
                        {/* <TableCell colSpan={3} /> */}
                        <TableCell align="right" colSpan={4} >
                          {/* <Typography variant="h6">{ projectData?.job_category_name=='Time & Material' ? "Material Cost":"Additional Material Cost"}</Typography> */}
                          <Typography variant="h6">Material Cost</Typography>
                        </TableCell>
                        <TableCell align="center" width={100}>
                          <Typography variant="h6">
                            {/* {materialPayOut.toFixed(2) || 0} */}
                            {/* {(parseFloat(materialPayOut || 0) + parseFloat(materialTotal || 0)).toFixed(2)} */}
                            {(parseFloat(materialPayOut || 0) + parseFloat(materialTotal || 0) + parseFloat(totalStockCost || 0)).toFixed(2)}
                            </Typography>
                        </TableCell>
                      </RowResultStyle>
  
                      {/* {projectData?.job_category_name=='Time & Material' ? "" : */}
                      <RowResultStyle>
                        <TableCell align="right" colSpan={4} >
                          <Typography variant="h6">Additional Services</Typography>
                        </TableCell>
                        <TableCell align="center" width={100}>
                          <Typography variant="h6">
                            {parseFloat(additionalLaborCost1).toFixed(2)}
                            {/* {projectData?.job_category_name=='Time & Material' ? '0.00' :
                            (services?.reduce((accumulator, currentValue) => {
                              let newTotal = 0;
                              if(currentValue.recipe_id == null && currentValue?.taken == 1){
                                newTotal = currentValue?.jobcost_unit_cost * currentValue?.jobcost_quantity
                                // newTotal = currentValue?.originalCost * currentValue?.qty
                              }
                              return accumulator + newTotal;
                            }, 0) || 0).toFixed(2)} */}
                          </Typography>
                        </TableCell>
                      </RowResultStyle>
                      {/* } */}
                      {/* <RowResultStyle>
                      <TableCell align="right" colSpan={4} >
                        <Typography variant="h6">Additional Labour Cost</Typography>
                      </TableCell>
                      <TableCell align="center" width={100}>
                        <Typography variant="h6">{additionalServices || 0}</Typography>
                      </TableCell>
                    </RowResultStyle> */}
  
                    {/* {projectData?.job_category_name=='Time & Material' ? "" : */}
                      <RowResultStyle>
                        {/* <TableCell  width={240}/> */}
                        <TableCell align="right" colSpan={4} >
                          {/* <Typography variant="h6">Actual Product Formula Cost</Typography> */}
                          <Typography variant="h6">Production Labor</Typography>
                        </TableCell>
                        {/* <TableCell align="center">
                        <Typography variant="h6" sx={{ whiteSpace: { xs: 'none', md: 'nowrap' }, width: '100%', ml: 3 }}>
                          {`${selectedProjects?.reduce((accumulator, currentValue) => {
                            return accumulator + (currentValue?.unit_cost * currentValue?.quantity);
                          }, 0) + services?.reduce((accumulator, currentValue) => {
                            return accumulator + (currentValue?.originalCost * currentValue?.qty);
                          }, 0) || 0} (${selectedProjects?.reduce((accumulator, currentValue) => {
                            return accumulator + (currentValue?.unit_cost * currentValue?.quantity);
                          }, 0) || 0} + ${services?.reduce((accumulator, currentValue) => {
                            return accumulator + (currentValue?.originalCost * currentValue?.qty);
                          }, 0) || 0})`}
                        </Typography>
                      </TableCell> */}
                        <TableCell align="center">
                          <Typography variant="h6" sx={{ whiteSpace: { xs: 'none', md: 'nowrap' } }}>
                            {/* {`${(selectedProjects?.reduce((accumulator, currentValue) => {
                              let newTotal = 0;
                              if(currentValue?.taken == 1){
                                newTotal = currentValue?.jobcost_total
                                // newTotal = currentValue?.jobcost_unit_cost * currentValue?.jobcost_quantity // currentValue?.unit_cost * currentValue?.quantity
                              }
                              return accumulator + newTotal;
                            }, 0) + 
                            services?.reduce((accumulator, currentValue) => {
                              let newTotal = 0;
                              if((currentValue.recipe_id && currentValue?.labour_cost_service_id !== 10) && currentValue?.taken == 1){
                                const initialCost = ((currentValue?.originalCost || 0) * (currentValue?.qty || 0)) || 0
                                newTotal = (initialCost > parseFloat(currentValue?.jobcost_total_cost || 0)) ? parseFloat(currentValue?.jobcost_total_cost || 0) : initialCost
                                // newTotal = currentValue?.jobcost_unit_cost * currentValue?.jobcost_quantity // currentValue?.originalCost * currentValue?.qty
                              }
                              return accumulator + newTotal;
                            }, 0)).toFixed(2)} 
                            (${(selectedProjects?.reduce((accumulator, currentValue) => {
                              let newTotal = 0;
                              if(currentValue?.taken == 1){
                                newTotal = currentValue?.jobcost_total
                                // newTotal = currentValue?.jobcost_unit_cost * currentValue?.jobcost_quantity // currentValue?.unit_cost * currentValue?.quantity
                              }
                              return accumulator + newTotal;
                            }, 0) || 0).toFixed(2)} + ${(services?.reduce((accumulator, currentValue) => {
                              let newTotal = 0;
                              if((currentValue.recipe_id && currentValue?.labour_cost_service_id !== 10) && currentValue?.taken == 1){
                                // newTotal = currentValue?.originalCost * currentValue?.qty
                                // newTotal = currentValue?.jobcost_unit_cost * currentValue?.jobcost_quantity
                                const initialCost = ((currentValue?.originalCost || 0) * (currentValue?.qty || 0)) || 0
                                newTotal = (initialCost > parseFloat(currentValue?.jobcost_total_cost || 0)) ? parseFloat(currentValue?.jobcost_total_cost || 0) : initialCost
                                // newTotal = parseFloat(currentValue?.jobcost_total_cost || 0)
                              }
                              return accumulator + newTotal;
                            }, 0)).toFixed(2)})`}  */}
  
                            {/* {(services?.reduce((accumulator, currentValue) => {
                              let newTotal = 0;
                              if((currentValue.recipe_id && currentValue?.labour_cost_service_id !== 10) && currentValue?.taken == 1){
                                const initialCost = ((currentValue?.originalCost || 0) * (currentValue?.qty || 0)) || 0
                                newTotal = (initialCost > parseFloat(currentValue?.jobcost_total_cost || 0)) ? parseFloat(currentValue?.jobcost_total_cost || 0) : initialCost
                              }
                              return accumulator + newTotal;
                            }, 0)).toFixed(2)} */}
                            { parseFloat(effectiveProductionLabor).toFixed(2)}
                          </Typography>
                        </TableCell>
  
                      </RowResultStyle>
                     {/* } */}
                     <RowResultStyle>
                        <TableCell align="right" colSpan={4} >
                          <Typography variant="h6">Install Labor</Typography>
                        </TableCell>
                        <TableCell align="center" width={100}>
                          <Typography variant="h6">
                            { parseFloat(installLaborCost).toFixed(2)}
                          </Typography>
                        </TableCell>
                      </RowResultStyle>
  
                      <RowResultStyle>
                        {/* <TableCell colSpan={3} /> */}
                        <TableCell align="right" colSpan={4} >
                          {/* <Typography variant="h6">{projectData?.job_category_name=='Time & Material' ? "Service Cost" : "Excess Labor Cost"}</Typography> */}
                          {/* <Typography variant="h6">Excess Labor Cost</Typography> */}
                        </TableCell>
                        {/* <TableCell align="center" width={100}>
                          <Typography variant="h6">
                            { parseFloat(excessLaborCost1).toFixed(2)}
                          </Typography>
                        </TableCell> */}
                      </RowResultStyle>
                      {/* <RowResultStyle>
                        <TableCell align="right" colSpan={4} >
                        <Typography variant="h6">Manual Staff Pay Out</Typography>
                      </TableCell>
                      <TableCell align="center" width={100}>
                        <Typography variant="h6">{manualTotalPayOut ? manualTotalPayOut?.toFixed(2) : 0}</Typography>
                      </TableCell>
                    </RowResultStyle> */}
                      {/* <RowResultStyle>
                        <TableCell align="right" colSpan={4} >
                          <Typography variant="h6">Hourly Staff Pay Out</Typography>
                      </TableCell>
                      <TableCell align="center" width={100}>
                        <Typography variant="h6">{hourlyTotalPayOut ? hourlyTotalPayOut?.toFixed(2) : 0}</Typography>
                      </TableCell>
                    </RowResultStyle> */}
  
                      {!isTM && (
                        <RowResultStyle>
                          <TableCell align="right" colSpan={4} sx={{color:'#1890FF'}} >
                            {/* <Typography variant="h6">Total Bill</Typography> */}
                            <Typography variant="h6">Bill Amount</Typography>
                          </TableCell>
                          <TableCell align="center" width={100} sx={{color:'#1890FF'}}>
                            <Typography variant="h6">{grandTotalBill ? grandTotalBill?.toFixed(2) : 0}</Typography>
                          </TableCell>
                        </RowResultStyle>
                      )}

                      <RowResultStyle>
                        <TableCell align="right" colSpan={4} sx={{color:'#fc8c03'}} >
                          <Typography variant="h6">Total Cost</Typography>

                        </TableCell>
                        <TableCell align="center" width={100} sx={{color:'#fc8c03'}}>
                          {/* <Tooltip title={`Total Cost (${grandTotalCost?.toFixed(2) || '0.00'}) + Total Bill (${grandTotalBill?.toFixed(2) || '0.00'}) = ${totalCostWithBill?.toFixed(2) || '0.00'}`} arrow> */}
                          <Tooltip title={`Bill Amount = Sales Order Price`} arrow>
                            <Typography variant="h6">{totalCostWithBill ? fUSPrice(totalCostWithBill) : fUSPrice(0)}</Typography>
                          </Tooltip>

                        </TableCell>

                      </RowResultStyle>
                      </Box>
                      </Box>
                      )}
                      {/* {currentTab =="Installations" ? '' : */}
                      <Box
                        sx={{
                          mt: false ? 3 : 0,
                          mb: 2,
                          ml:2,
                          mr:2,
                          px: 1.5,
                          py: 1.25,
                          display: 'flex',
                          justifyContent: 'flex-end',
                          alignItems: 'center',
                          backgroundColor: theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.03)' : 'rgba(0, 0, 0, 0.02)',
                          border: `1px solid ${theme.palette.divider}`,
                          borderRadius: 2
                        }}
                      >
                          {/* <Stack direction="row" spacing={1.5} alignItems="center">
                            <ActionButton
                              variant="outlined"
                              color="primary"
                              sx={{ borderColor: 'primary.main', borderWidth: 1.5, '&:hover': { borderWidth: 1.5 } }}
                              startIcon={<Box component='span' className='bi--stars' sx={{ width: 20, height: 20, color: 'primary.main', }} />}
                            >
                              Analyze with AI
                            </ActionButton>
                            <ActionButton
                              variant="outlined"
                              color="primary"
                              onClick={handleRecalculateAll}
                              sx={{ borderColor: 'primary.main', borderWidth: 1.5, '&:hover': { borderWidth: 1.5 } }}
                              startIcon={<Box component='span' className='material-symbols--calculate-outline' sx={{ width: 20, height: 20, color: 'primary.main' }} />}
                            >
                              Recalculate
                            </ActionButton>
                          </Stack> */}

                          <Stack direction="row" spacing={1.5}>
                            <Tooltip
                              title="1.When a job is in progress in QuickBooks, the amount should be debited to Work In Progress(1014000) and credited to (Inventory(1013000) / Split Labor(5081000)) . 
           2.When the job is completed, the total job cost amount should be debited to Finished Goods(1014300) and credited to Work In Progress(1014000)."
                              placement="top"
                            >
                              <IconButton size="small" sx={{ color: 'text.secondary' }}>
                                <Info sx={{ mt: 0.2 }} />
                              </IconButton>
                            </Tooltip>
                            <LoadingButton
                                 disabled={projectData?.installation_acceptance === 1 || isMirrored}
                                 loading={isSubmitting}
                                 onClick={() => {
                                   setConfirmationPopup({
                                     open: true,
                                     message: (Number(projectData?.isReview) === 2 || (Number(projectData?.isReview) === 1 && Number(projectData?.finalize_invoice) === 1)) ? 'Are you sure you want to approve and finalize for invoice?' : 'Are you sure you want to submit job cost?',
                                     handleClick: () => {
                                       setConfirmationPopup({ open: false, message: '', handleClick: () => {}, handleClose: () => {} });
                                       formik.handleSubmit();
                                     },
                                     handleClose: () => setConfirmationPopup({ open: false, message: '', handleClick: () => {}, handleClose: () => {} })
                                   });
                                 }}
                                 variant="contained"
                                 startIcon={<Box component="span" className="material-symbols--lock" sx={{ width: 20, height: 20 }} />}
                                 sx={{
                                   px: 3,
                                   borderRadius: 1.5,
                                   boxShadow: 'none',
                                   background: theme.palette.primary.main,
                                   backgroundImage: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
                                   '&:hover': {
                                     background: theme.palette.primary.dark,
                                     backgroundImage: `linear-gradient(135deg, ${theme.palette.primary.dark} 0%, ${theme.palette.primary.darker} 100%) !important`,
                                     transform: 'scale(1.02)'
                                   }
                                 }}
                               >
                                 {(Number(projectData?.isReview) === 2) ? "Finalize For Invoice" : (Number(projectData?.isReview) === 1 && Number(projectData?.finalize_invoice) === 1 && Number(projectData?.project_category) === 12) ? "Submit Job Cost" : "Submit Job Cost"}
                               </LoadingButton>
                          </Stack>
                      </Box>
                      {/* } */}
                    </Form>
                  </FormikProvider>
                </Card>
                {/* <Tooltip title={isHidden ? 'Show Sidebar' : 'Hide Sidebar'} placement="top">
                  <IconButton
                    onClick={() => setIsHidden(!isHidden)}
                    sx={{
                      position: 'absolute',
                      top: 13,
                      left: -7, //'calc(100% - 12px)',
                      zIndex: 10,
                      backgroundColor: '#f5f5f528',
                      border: '1px solid #ccc',
                      borderRadius: '4px',
                      width: 30,
                      height: 40,
                      color: '#ffffff',
                      '&:hover': {
                        backgroundColor: '#44424263',
                      },
                      transition: 'all 0.2s ease-in-out',
                    }}
                  >
                    {isHidden ? <ArrowForwardIos fontSize="small" /> : <ArrowBackIos fontSize="small" sx={{marginLeft: '7px'}} />}
                  </IconButton>
                </Tooltip> */}
                </Box>
              </Grid>
            </Grid>
              {/* {projectData?.project_category !== 12 ? (
                <JobCostMemberClockInTimer
                  logs={logs}
                  fetchData={fetchData}
                  staffTimelogsGet={staffTimelogsGet}
                  setStaffTimelogsGet={setStaffTimelogsGet}
                  projectMembers={projectMembers}
                  setProjectMembers={setProjectMembers}
                  projectTasks={projectTasks}
                  setProjectTasks={setProjectTasks}
                  setLogs={setLogs}
                  fetchJobCostLogs={fetchJobCostLogs}
                  services={services}
                  userId={user?.user_id}
                  userType={user?.user_type}
                  projectData={projectData}
                  subTaskId={projectTasks?.[0]?.id}
                />
              ) : ''} */}
              {/* {projectData?.project_category !== 12 ? (
                <JobCostLogsListing
                  logs={logs}
                  projectData={projectData}
                  setLogs={setLogs}
                  fetchJobCostLogs={fetchJobCostLogs} />
              ) : ''} */}
              <JobCostLogsListing
                  logs={logs}
                  projectData={projectData}
                  setLogs={setLogs}
                  fetchJobCostLogs={fetchJobCostLogs} />
          </Paper>
        </Container>
        <ConfirmationPopup
          open={confirmationPopup.open}
          handleClick={confirmationPopup.handleClick}
          handleClose={confirmationPopup.handleClose}
          message={confirmationPopup.message}
        />

        <ConfirmationPopup
          open={openTmDraftConfirm}
          handleClick={handleToggleTmDraft}
          handleClose={() => setOpenTmDraftConfirm(false)}
          message={
            Number(projectData?.tm_review_draft || 0) === 0
              ? 'Are you sure you want to move this TM job to Draft?'
              : 'Are you sure you want to release this TM job from Draft?'
          }
          loading2={updatingTmDraft}
        />
        
        {/* Edit Service Confirmation Popup */}
        <Dialog open={editServiceConfirmation.open} onClose={handleEditServiceCancel}>
          <DialogContent>
            <Alert severity="warning">
              When we edit the hours, any already clocked-in data (if present) will be cleared and replaced with the service hourly cost. If no clock-in data exists, only the service hourly cost will be applied. Are you sure?
            </Alert>
            {editServiceConfirmation.isProductionLabor && (manuallyAddedPayouts?.length > 0) && (
              <Alert severity="error" sx={{ mt: 2 }}>
                Note: This is Production Labor with manually added task clock-in data. The manual hours ({totalManualHours.toFixed(2)}) and manually added payouts will be removed from the calculation. The manually added task clock-in data will be cleared.
              </Alert>
            )}
          </DialogContent>
          <DialogActions>
            <Button variant='outlined' color='inherit' onClick={handleEditServiceCancel}>
              No
            </Button>
            <Button 
              variant='contained' 
              color='primary' 
              onClick={handleEditServiceConfirm}
            >
              Yes
            </Button>
          </DialogActions>
        </Dialog>
        {
          materialsPreview && (
            <Modal
              open={materialsPreview}
              handleClose={() => {
                setMaterialsPreview(false);
                setIsRecipe(false)
              }}
              modalTitle={'Select material'}
            >
              {isRecipe ? (
                <Grid container sx={{ justifyContent: 'center' }} spacing={3}>
                  <Grid item xs={12} md={10}>
                    <Stack
                      sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'space-between',
                      }}
                      spacing={3}
                    >
                      <Stack
                        direction={{ xs: 'column', md: 'column' }}
                        display="flex"
                        justifyContent="space-between"
                        spacing={3}
                      >
                        {console.log("#####selectedMaterial", selectedMaterial)}
                        <Stack direction={{ xs: 'column', md: 'row' }}>
                          <Typography variant="body" sx={{ display: 'flex', alignItems: 'center' }}>
                            Material Name :
                            <span style={{ color: theme.palette.primary.dark, fontWeight: 'bold', paddingRight: "2" }}>
                              <Autocomplete
                                sx={{ ml: 1, width: 300 }}
                                id="combo-box-demo"
                                options={selectedMaterial.ingredients}
                                value={ingredient}
                                onChange={(event, newValue) => setIngredient(newValue)}
                                renderInput={(params) => (
                                  <TextField {...params}
                                    label="Select a Material" />
                                )}
                                getOptionLabel={(option) => option.name ? option.name : ''}
                              />
                            </span>
                            Quantity : {selectedMaterial?.ingredients?.find(item => item.product_id === ingredient?.product_id)?.quantity}
                          </Typography>
                        </Stack>




                        {/* <Card> */}
                        <Scrollbar>
                          <TableContainer>
                            <Table>
                              <TableHead sx={{ width: '100%' }}>
                                <TableRow>
                                  <TableCell align='center'>#</TableCell>
                                  <TableCell align='center'>Barcode</TableCell>
                                  <TableCell align='center'>Unit Cost</TableCell>
                                  <TableCell align='center'>Available Stock</TableCell>
                                  <TableCell align='center'></TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {loading ? (
                                  <CircularProgress color="primary" variant="indeterminate" />
                                ) : (

                                  <>
                                    {productWithQty?.filter((data) => (data?.material_id === ingredient?.product_id)).map((row, index) => {
                                      let { id, name, unit_cost, qty, barcode } = row;

                                      const isAlreadyAdded = selectedProjects.some(project => project.material_id === row.material_id);

                                      let totalQuantityInSelectedProjects = 0;

                                      if (isAlreadyAdded) {
                                        totalQuantityInSelectedProjects = selectedProjects.reduce((total, project) => {
                                          if (project.material_id === row.material_id) {
                                            return total + project.quantity;
                                          }
                                          return total;
                                        }, 0);
                                      }

                                      let quantity = selectedMaterial?.ingredients?.find(item => item.product_id === ingredient?.product_id)?.quantity || 1;

                                      if (qty < quantity) {
                                        quantity = qty;
                                      }
                                      console.log("selectedprojects.Product Formula", selectedMaterial.name);
                                      return (
                                        <TableRow
                                          hover
                                          key={index}
                                          tabIndex={-1}
                                          sx={{
                                            borderBottom: (theme) => `solid 1px ${theme.palette.divider}`
                                          }}
                                        >
                                          <TableCell align='center'> {index + 1} </TableCell>
                                          <TableCell align="center"> {barcode} </TableCell>
                                          <TableCell align="center"> ${unit_cost} </TableCell>
                                          <TableCell align="center"> {qty} </TableCell>
                                          <TableCell align="center">
                                            <Button
                                              onClick={() => {
                                                if (!selectedProjects.map(s => s.id).includes(id)) {
                                                  if (totalQuantityInSelectedProjects > 0) {
                                                    let newQuantity = Math.max(0, quantity - totalQuantityInSelectedProjects);
                                                    if (newQuantity === 0) {
                                                      enqueueSnackbar('Material Stock exceed', { variant: 'error' });
                                                      return;
                                                    }
                                                    handleProjectClick({ ...row, quantity: newQuantity, recipeName: selectedMaterial.name });
                                                  } else {
                                                    handleProjectClick({ ...row, quantity: quantity, recipeName: selectedMaterial.name });
                                                  }
                                                } else {
                                                  enqueueSnackbar('Material Already Added', { variant: 'error' });
                                                }
                                              }}
                                            >
                                              <AddCircle />
                                            </Button>
                                          </TableCell>
                                        </TableRow>
                                      );
                                    })}
                                  </>


                                )}
                              </TableBody>
                            </Table>
                          </TableContainer>
                        </Scrollbar>
                        {/* </Card> */}
                        <Box sx={{ mt: 3, display: 'flex', justifyContent: 'center', gap: 2 }}>
                          <Button variant='outlined' onClick={() => { setMaterialsPreview(false); setSelectedMaterial(null); }}>Close</Button>
                        </Box>
                      </Stack>

                    </Stack>
                  </Grid>
                </Grid>) :
                (<Grid container sx={{ justifyContent: 'center' }} spacing={3}>
                  <Grid item xs={12} md={10}>
                    <Stack
                      sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'space-between',
                      }}
                      spacing={3}
                    >
                      <Stack
                        direction={{ xs: 'column', md: 'column' }}
                        display="flex"
                        justifyContent="space-between"
                        spacing={3}
                      >
                        {console.log("#####selectedMaterial", selectedMaterial)}
                        <Stack direction={{ xs: 'column', md: 'column' }}>
                          <Typography variant="body">
                            Material Name : <span style={{ color: theme.palette.primary.dark, fontWeight: 'bold' }}>{selectedMaterial?.name}</span>
                          </Typography>
                        </Stack>

                        {/* <Card> */}
                        <Scrollbar>
                          <TableContainer>
                            <Table>
                              <TableHead sx={{ width: '100%' }}>
                                <TableRow>
                                  <TableCell align='center'>#</TableCell>
                                  <TableCell align='center'>Barcode</TableCell>
                                  <TableCell align='center'>Unit Cost</TableCell>
                                  <TableCell align='center'>Available Stock</TableCell>
                                  <TableCell align='center'></TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {loading ? (
                                  <CircularProgress color="primary" variant="indeterminate" />
                                ) : (
                                  <>
                                    {productWithQty?.filter((data) => (data?.material_id === selectedMaterial?.id)).map((row, index) => {
                                      // console.log('selectedProjects------',selectedProjects);
                                      // console.log('selectedMaterial------',selectedMaterial);
                                      let { id, name, unit_cost, qty, barcode } = row;
                                      return (
                                        <TableRow
                                          hover
                                          key={index}
                                          tabIndex={-1}
                                          sx={{
                                            borderBottom: (theme) => `solid 1px ${theme.palette.divider}`
                                          }}
                                        >
                                          <TableCell align='center'> {index + 1} </TableCell>
                                          <TableCell align="center"> {barcode} </TableCell>
                                          <TableCell align="center"> ${unit_cost} </TableCell>
                                          <TableCell align="center"> {qty} </TableCell>
                                          <TableCell align="center">
                                            <Button
                                              onClick={() => !selectedProjects.map(s => s.id).includes(id) ? handleProjectClick({ ...row, quantity: 1 }) : enqueueSnackbar('Material Already Added', { variant: 'error' })}
                                            >
                                              <AddCircle />
                                            </Button>
                                          </TableCell>
                                        </TableRow>
                                      );
                                    })}
                                  </>
                                )}
                              </TableBody>
                            </Table>
                          </TableContainer>
                        </Scrollbar>
                        {/* </Card> */}
                        <Box sx={{ mt: 3, display: 'flex', justifyContent: 'center', gap: 2 }}>
                          <Button variant='outlined' onClick={() => { setMaterialsPreview(false); setSelectedMaterial(null); }}>Close</Button>
                        </Box>
                      </Stack>

                    </Stack>
                  </Grid>
                </Grid>)}
            </Modal>
          )
        }
        {servicesPreview && (
          <Modal
            open={servicesPreview}
            handleClose={() => {
              setServicesPreview(false);
              setServiceExpectedHours({});
              setServiceSearchTerm('');
              fetchAvailableServices();
            }}
            modalTitle={'Select Service'}
          >
            <Grid item xs={12} md={12} sx={{ marginBottom: 2,pl: 1, }}>
              {/* <Alert severity="error" size='small'>Note : If the expected hours are 0, then while editing the job cost, the amount will be added to Excess Labor Cost.</Alert> */}
            </Grid>
            <Grid container sx={{ justifyContent: 'center' }} spacing={3}>
              <Grid item xs={12} md={12}>
                <Box sx={{ display: 'flex', justifyContent: 'center',alignItems: 'center',width: '100%' }}>
                <TextField
                  // fullWidth
                  size='small'
                  label={'Search Services'}
                  placeholder='Search by service name...'
                  value={serviceSearchTerm}
                  onChange={(e) => setServiceSearchTerm(e.target.value)}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <Search />
                      </InputAdornment>
                    )
                  }}
                  sx={{ mb: 2,width: '80%' }}
                />
                </Box>
                <Stack
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                  }}
                  spacing={3}
                >
                  <Stack
                    direction={{ xs: 'column', md: 'column' }}
                    display="flex"
                    justifyContent="space-between"
                    spacing={3}
                  >

                    <Scrollbar>
                      <TableContainer>
                        <Table>
                          <TableHead sx={{ width: '100%' }}>
                            <TableRow>
                              <TableCell align='center'>#</TableCell>
                              <TableCell align='center'>Service Name</TableCell>
                              <TableCell align='center'>Service Type</TableCell>
                              <TableCell align='center'>Service Folder</TableCell>
                              <TableCell align='center'>Cost</TableCell>
                              <TableCell align='center'>Workflow</TableCell>
                              {projectData?.project_category !== 12 && <TableCell align='center'>Expected Hours</TableCell>}
                              <TableCell align='center'></TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {availableServices
                              ?.filter(service => 
                                service.name?.toLowerCase().includes(serviceSearchTerm.toLowerCase()) ||
                                service.type_name?.toLowerCase().includes(serviceSearchTerm.toLowerCase())
                              )
                              ?.slice(servicesPage * servicesRowsPerPage, servicesPage * servicesRowsPerPage + servicesRowsPerPage)
                              ?.map((service, index) => {
                              const isAlreadyAdded = services.some(s => s.labour_cost_service_id === service.id);
                              return (
                                <TableRow
                                  hover
                                  key={index}
                                  tabIndex={-1}
                                  sx={{
                                    borderBottom: (theme) => `solid 1px ${theme.palette.divider}`
                                  }}
                                >
                                  <TableCell align='center'>{servicesPage * servicesRowsPerPage + index + 1}</TableCell>
                                  <TableCell align="center">{service.name}</TableCell>
                                  <TableCell align="center">{service.type_name || 'N/A'}</TableCell>
                                  <TableCell align="center">
                                    {service.inhouse === 1 ? 'Production' : service.inhouse === 2 ? 'Installs' : service.inhouse === 3 ? 'T/S' : 'Subcontract'}
                                  </TableCell>
                                  <TableCell align="center">
                                    {/* OLD: ${service.cost || 0} — always base; T&M should show total_cost (with markup) */}
                                    ${getLabourCostServiceCatalogRate(service, projectData?.project_category === 12) || 0}
                                  </TableCell>
                                  <TableCell align="center">{service.workflow_name || 'N/A'}</TableCell>
                                  {projectData?.project_category !== 12 && (
                                    <TableCell align="center">
                                      <TextField
                                        type="number"
                                        size="small"
                                        placeholder="0"
                                        disabled={isAlreadyAdded}
                                        inputProps={{
                                          min: 0,
                                          step: 0.5
                                        }}
                                        sx={{ width: '80px' }}
                                        defaultValue={0}
                                        onChange={(e) => {
                                          const hours = parseFloat(e.target.value) || 0;
                                          setServiceExpectedHours(prev => ({
                                            ...prev,
                                            [service.id]: hours
                                          }));
                                        }}
                                        value={serviceExpectedHours[service.id] || 0}
                                      />
                                    </TableCell>
                                  )}
                                  <TableCell align="center">
                                    <Button
                                      onClick={() => handleServiceAdd(service)}
                                      disabled={isAlreadyAdded}
                                      variant={isAlreadyAdded ? "outlined" : "outlined"}
                                      color={isAlreadyAdded ? "inherit" : "primary"}
                                      sx={{ boxShadow: 'none' }}
                                    >
                                      {isAlreadyAdded ? 'Added' : <AddCircle />}
                                    </Button>
                                  </TableCell>
                                </TableRow>
                              );
                            })}
                          </TableBody>
                        </Table>
                      </TableContainer>
                      
                      <TablePagination
                        rowsPerPageOptions={[10, 25, 50, 100]}
                        component="div"
                        count={availableServices?.filter(service => 
                          service.name?.toLowerCase().includes(serviceSearchTerm.toLowerCase()) ||
                          service.type_name?.toLowerCase().includes(serviceSearchTerm.toLowerCase())
                        )?.length || 0}
                        rowsPerPage={servicesRowsPerPage}
                        page={servicesPage}
                        onPageChange={handleServicesChangePage}
                        onRowsPerPageChange={handleServicesChangeRowsPerPage}
                      />
                    </Scrollbar>
                    <Box sx={{ mt: 3, display: 'flex', justifyContent: 'center', gap: 2 }}>
                      <Button variant='outlined' onClick={() => { setServicesPreview(false); }}>Close</Button>
                    </Box>
                  </Stack>
                </Stack>
              </Grid>
            </Grid>
          </Modal>
        )}
        {jobCostPreview && (
          <Modal
            open={jobCostPreview}
            handleClose={() => {
              setJobCostPreview(false);
            }}
            modalTitle={
              <>
              {"Job Cost Calculator "}
              {projectData?.job_category_name === 'Time & Material' ? <Label variant="filled" color="info">T&M</Label> : ''}
              </>
            }
            width={1200}
          >
            <CompareJobCost
              id={id}
              refreshTrigger={recalculateTrigger}
              staffTimelogsProp={staffTimelogsGet}
              laborTabLaborCost={tabSummaryStats?.Labor?.laborCost}
            />
          </Modal>
        )}
        {jobCostCalculatorModal && (
          <Modal
            open={jobCostCalculatorModal}
            // handleClose={handleCloseJobCostCalculatorModal}
            handleClose={handleCloseJobCostAddMaterialModal}
            modalTitle={
              <>
                Job Calculator
                {projectData?.job_category_name === 'Time & Material' ? (
                  <Label variant="filled" color="info" sx={{ ml: 1 }}>T&M</Label>
                ) : ''}
              </>
            }
            width={1400}
          >
            <JobCostCalculator
              jobCostId={id}
              popupOn
              isModal
              handleClickOpenRecipeCost={handleCloseJobCostCalculatorModal}
              setRecipeCostCurrentTab={setRecipeCostCurrentTab}
              onDataChange={onDataChange}
              staffTimelogsProp={staffTimelogsGet}
              laborTabLaborCost={tabSummaryStats?.Labor?.laborCost}
              refreshTrigger={recalculateTrigger}
            />
          </Modal>
        )}
      </Page >
  );
}
